(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire92b0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire92b0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7E3cb", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports.defaults = {
        "0.1": {
            explicitCharkey: false,
            trim: true,
            normalize: true,
            normalizeTags: false,
            attrkey: "@",
            charkey: "#",
            explicitArray: false,
            ignoreAttrs: false,
            mergeAttrs: false,
            explicitRoot: false,
            validator: null,
            xmlns: false,
            explicitChildren: false,
            childkey: "@@",
            charsAsChildren: false,
            includeWhiteChars: false,
            async: false,
            strict: true,
            attrNameProcessors: null,
            attrValueProcessors: null,
            tagNameProcessors: null,
            valueProcessors: null,
            emptyTag: ""
        },
        "0.2": {
            explicitCharkey: false,
            trim: false,
            normalize: false,
            normalizeTags: false,
            attrkey: "$",
            charkey: "_",
            explicitArray: true,
            ignoreAttrs: false,
            mergeAttrs: false,
            explicitRoot: true,
            validator: null,
            xmlns: false,
            explicitChildren: false,
            preserveChildrenOrder: false,
            childkey: "$$",
            charsAsChildren: false,
            includeWhiteChars: false,
            async: false,
            strict: true,
            attrNameProcessors: null,
            attrValueProcessors: null,
            tagNameProcessors: null,
            valueProcessors: null,
            rootName: "root",
            xmldec: {
                "version": "1.0",
                "encoding": "UTF-8",
                "standalone": true
            },
            doctype: null,
            renderOpts: {
                "pretty": true,
                "indent": "  ",
                "newline": "\n"
            },
            headless: false,
            chunkSize: 10000,
            emptyTag: "",
            cdata: false
        }
    };
}).call(module.exports);

});

parcelRegister("fpj45", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var builder, defaults, escapeCDATA, requiresCDATA, wrapCDATA, hasProp = {}.hasOwnProperty;
    builder = (parcelRequire("gUytd"));
    defaults = (parcelRequire("7E3cb")).defaults;
    requiresCDATA = function(entry) {
        return typeof entry === "string" && (entry.indexOf("&") >= 0 || entry.indexOf(">") >= 0 || entry.indexOf("<") >= 0);
    };
    wrapCDATA = function(entry) {
        return "<![CDATA[" + escapeCDATA(entry) + "]]>";
    };
    escapeCDATA = function(entry) {
        return entry.replace("]]>", "]]]]><![CDATA[>");
    };
    module.exports.Builder = function() {
        function Builder(opts) {
            var key, ref, value;
            this.options = {};
            ref = defaults["0.2"];
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this.options[key] = value;
            }
            for(key in opts){
                if (!hasProp.call(opts, key)) continue;
                value = opts[key];
                this.options[key] = value;
            }
        }
        Builder.prototype.buildObject = function(rootObj) {
            var attrkey, charkey, render, rootElement, rootName;
            attrkey = this.options.attrkey;
            charkey = this.options.charkey;
            if (Object.keys(rootObj).length === 1 && this.options.rootName === defaults["0.2"].rootName) {
                rootName = Object.keys(rootObj)[0];
                rootObj = rootObj[rootName];
            } else rootName = this.options.rootName;
            render = function(_this) {
                return function(element, obj) {
                    var attr, child, entry, index, key, value;
                    if (typeof obj !== "object") {
                        if (_this.options.cdata && requiresCDATA(obj)) element.raw(wrapCDATA(obj));
                        else element.txt(obj);
                    } else if (Array.isArray(obj)) for(index in obj){
                        if (!hasProp.call(obj, index)) continue;
                        child = obj[index];
                        for(key in child){
                            entry = child[key];
                            element = render(element.ele(key), entry).up();
                        }
                    }
                    else for(key in obj){
                        if (!hasProp.call(obj, key)) continue;
                        child = obj[key];
                        if (key === attrkey) {
                            if (typeof child === "object") for(attr in child){
                                value = child[attr];
                                element = element.att(attr, value);
                            }
                        } else if (key === charkey) {
                            if (_this.options.cdata && requiresCDATA(child)) element = element.raw(wrapCDATA(child));
                            else element = element.txt(child);
                        } else if (Array.isArray(child)) for(index in child){
                            if (!hasProp.call(child, index)) continue;
                            entry = child[index];
                            if (typeof entry === "string") {
                                if (_this.options.cdata && requiresCDATA(entry)) element = element.ele(key).raw(wrapCDATA(entry)).up();
                                else element = element.ele(key, entry).up();
                            } else element = render(element.ele(key), entry).up();
                        }
                        else if (typeof child === "object") element = render(element.ele(key), child).up();
                        else if (typeof child === "string" && _this.options.cdata && requiresCDATA(child)) element = element.ele(key).raw(wrapCDATA(child)).up();
                        else {
                            if (child == null) child = "";
                            element = element.ele(key, child.toString()).up();
                        }
                    }
                    return element;
                };
            }(this);
            rootElement = builder.create(rootName, this.options.xmldec, this.options.doctype, {
                headless: this.options.headless,
                allowSurrogateChars: this.options.allowSurrogateChars
            });
            return render(rootElement, rootObj).end(this.options.renderOpts);
        };
        return Builder;
    }();
}).call(module.exports);

});
parcelRegister("gUytd", function(module, exports) {








// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLDOMImplementation, XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
    ref = (parcelRequire("gKutS")), assign = ref.assign, isFunction = ref.isFunction;
    XMLDOMImplementation = (parcelRequire("ca3QF"));
    XMLDocument = (parcelRequire("jvyHT"));
    XMLDocumentCB = (parcelRequire("in7R2"));
    XMLStringWriter = (parcelRequire("anTpz"));
    XMLStreamWriter = (parcelRequire("cdCBO"));
    NodeType = (parcelRequire("78YVe"));
    WriterState = (parcelRequire("lGpn4"));
    module.exports.create = function(name, xmldec, doctype, options) {
        var doc, root;
        if (name == null) throw new Error("Root element needs a name.");
        options = assign({}, xmldec, doctype, options);
        doc = new XMLDocument(options);
        root = doc.element(name);
        if (!options.headless) {
            doc.declaration(options);
            if (options.pubID != null || options.sysID != null) doc.dtd(options);
        }
        return root;
    };
    module.exports.begin = function(options, onData, onEnd) {
        var ref1;
        if (isFunction(options)) {
            ref1 = [
                options,
                onData
            ], onData = ref1[0], onEnd = ref1[1];
            options = {};
        }
        if (onData) return new XMLDocumentCB(options, onData, onEnd);
        else return new XMLDocument(options);
    };
    module.exports.stringWriter = function(options) {
        return new XMLStringWriter(options);
    };
    module.exports.streamWriter = function(stream, options) {
        return new XMLStreamWriter(stream, options);
    };
    module.exports.implementation = new XMLDOMImplementation();
    module.exports.nodeType = NodeType;
    module.exports.writerState = WriterState;
}).call(module.exports);

});
parcelRegister("gKutS", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject, slice = [].slice, hasProp = {}.hasOwnProperty;
    assign = function() {
        var i, key, len, source, sources, target;
        target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        if (isFunction(Object.assign)) Object.assign.apply(null, arguments);
        else for(i = 0, len = sources.length; i < len; i++){
            source = sources[i];
            if (source != null) for(key in source){
                if (!hasProp.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    };
    isFunction = function(val) {
        return !!val && Object.prototype.toString.call(val) === "[object Function]";
    };
    isObject = function(val) {
        var ref;
        return !!val && ((ref = typeof val) === "function" || ref === "object");
    };
    isArray = function(val) {
        if (isFunction(Array.isArray)) return Array.isArray(val);
        else return Object.prototype.toString.call(val) === "[object Array]";
    };
    isEmpty = function(val) {
        var key;
        if (isArray(val)) return !val.length;
        else {
            for(key in val){
                if (!hasProp.call(val, key)) continue;
                return false;
            }
            return true;
        }
    };
    isPlainObject = function(val) {
        var ctor, proto;
        return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === "function" && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
    };
    getValue = function(obj) {
        if (isFunction(obj.valueOf)) return obj.valueOf();
        else return obj;
    };
    module.exports.assign = assign;
    module.exports.isFunction = isFunction;
    module.exports.isObject = isObject;
    module.exports.isArray = isArray;
    module.exports.isEmpty = isEmpty;
    module.exports.isPlainObject = isPlainObject;
    module.exports.getValue = getValue;
}).call(module.exports);

});

parcelRegister("ca3QF", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMImplementation;
    module.exports = XMLDOMImplementation = function() {
        function XMLDOMImplementation() {}
        XMLDOMImplementation.prototype.hasFeature = function(feature, version) {
            return true;
        };
        XMLDOMImplementation.prototype.createDocumentType = function(qualifiedName, publicId, systemId) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLDOMImplementation.prototype.createDocument = function(namespaceURI, qualifiedName, doctype) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLDOMImplementation.prototype.createHTMLDocument = function(title) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLDOMImplementation.prototype.getFeature = function(feature, version) {
            throw new Error("This DOM method is not implemented.");
        };
        return XMLDOMImplementation;
    }();
}).call(module.exports);

});

parcelRegister("jvyHT", function(module, exports) {







// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDOMConfiguration, XMLDOMImplementation, XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isPlainObject = (parcelRequire("gKutS")).isPlainObject;
    XMLDOMImplementation = (parcelRequire("ca3QF"));
    XMLDOMConfiguration = (parcelRequire("8khhJ"));
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    XMLStringifier = (parcelRequire("2vBMM"));
    XMLStringWriter = (parcelRequire("anTpz"));
    module.exports = XMLDocument = function(superClass) {
        extend(XMLDocument, superClass);
        function XMLDocument(options) {
            XMLDocument.__super__.constructor.call(this, null);
            this.name = "#document";
            this.type = NodeType.Document;
            this.documentURI = null;
            this.domConfig = new XMLDOMConfiguration();
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter();
            this.options = options;
            this.stringify = new XMLStringifier(options);
        }
        Object.defineProperty(XMLDocument.prototype, "implementation", {
            value: new XMLDOMImplementation()
        });
        Object.defineProperty(XMLDocument.prototype, "doctype", {
            get: function() {
                var child, i, len, ref;
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.DocType) return child;
                }
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "documentElement", {
            get: function() {
                return this.rootObject || null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "inputEncoding", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "strictErrorChecking", {
            get: function() {
                return false;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "xmlEncoding", {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].encoding;
                else return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "xmlStandalone", {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].standalone === "yes";
                else return false;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "xmlVersion", {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].version;
                else return "1.0";
            }
        });
        Object.defineProperty(XMLDocument.prototype, "URL", {
            get: function() {
                return this.documentURI;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "origin", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "compatMode", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "characterSet", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, "contentType", {
            get: function() {
                return null;
            }
        });
        XMLDocument.prototype.end = function(writer) {
            var writerOptions;
            writerOptions = {};
            if (!writer) writer = this.options.writer;
            else if (isPlainObject(writer)) {
                writerOptions = writer;
                writer = this.options.writer;
            }
            return writer.document(this, writer.filterOptions(writerOptions));
        };
        XMLDocument.prototype.toString = function(options) {
            return this.options.writer.document(this, this.options.writer.filterOptions(options));
        };
        XMLDocument.prototype.createElement = function(tagName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createDocumentFragment = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createTextNode = function(data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createComment = function(data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createCDATASection = function(data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createProcessingInstruction = function(target, data) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createAttribute = function(name) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createEntityReference = function(name) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementsByTagName = function(tagname) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.importNode = function(importedNode, deep) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createElementNS = function(namespaceURI, qualifiedName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createAttributeNS = function(namespaceURI, qualifiedName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementsByTagNameNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementById = function(elementId) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.adoptNode = function(source) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.normalizeDocument = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.renameNode = function(node, namespaceURI, qualifiedName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.getElementsByClassName = function(classNames) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createEvent = function(eventInterface) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createRange = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createNodeIterator = function(root, whatToShow, filter) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLDocument.prototype.createTreeWalker = function(root, whatToShow, filter) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        return XMLDocument;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("8khhJ", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMConfiguration, XMLDOMErrorHandler, XMLDOMStringList;
    XMLDOMErrorHandler = (parcelRequire("57wRq"));
    XMLDOMStringList = (parcelRequire("2XbQA"));
    module.exports = XMLDOMConfiguration = function() {
        function XMLDOMConfiguration() {
            var clonedSelf;
            this.defaultParams = {
                "canonical-form": false,
                "cdata-sections": false,
                "comments": false,
                "datatype-normalization": false,
                "element-content-whitespace": true,
                "entities": true,
                "error-handler": new XMLDOMErrorHandler(),
                "infoset": true,
                "validate-if-schema": false,
                "namespaces": true,
                "namespace-declarations": true,
                "normalize-characters": false,
                "schema-location": "",
                "schema-type": "",
                "split-cdata-sections": true,
                "validate": false,
                "well-formed": true
            };
            this.params = clonedSelf = Object.create(this.defaultParams);
        }
        Object.defineProperty(XMLDOMConfiguration.prototype, "parameterNames", {
            get: function() {
                return new XMLDOMStringList(Object.keys(this.defaultParams));
            }
        });
        XMLDOMConfiguration.prototype.getParameter = function(name) {
            if (this.params.hasOwnProperty(name)) return this.params[name];
            else return null;
        };
        XMLDOMConfiguration.prototype.canSetParameter = function(name, value) {
            return true;
        };
        XMLDOMConfiguration.prototype.setParameter = function(name, value) {
            if (value != null) return this.params[name] = value;
            else return delete this.params[name];
        };
        return XMLDOMConfiguration;
    }();
}).call(module.exports);

});
parcelRegister("57wRq", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMErrorHandler;
    module.exports = XMLDOMErrorHandler = function() {
        function XMLDOMErrorHandler() {}
        XMLDOMErrorHandler.prototype.handleError = function(error) {
            throw new Error(error);
        };
        return XMLDOMErrorHandler;
    }();
}).call(module.exports);

});

parcelRegister("2XbQA", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDOMStringList;
    module.exports = XMLDOMStringList = function() {
        function XMLDOMStringList(arr) {
            this.arr = arr || [];
        }
        Object.defineProperty(XMLDOMStringList.prototype, "length", {
            get: function() {
                return this.arr.length;
            }
        });
        XMLDOMStringList.prototype.item = function(index) {
            return this.arr[index] || null;
        };
        XMLDOMStringList.prototype.contains = function(str) {
            return this.arr.indexOf(str) !== -1;
        };
        return XMLDOMStringList;
    }();
}).call(module.exports);

});


parcelRegister("gXtXl", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var DocumentPosition, NodeType, XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLNamedNodeMap, XMLNode, XMLNodeList, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, ref1, hasProp = {}.hasOwnProperty;
    ref1 = (parcelRequire("gKutS")), isObject = ref1.isObject, isFunction = ref1.isFunction, isEmpty = ref1.isEmpty, getValue = ref1.getValue;
    XMLElement = null;
    XMLCData = null;
    XMLComment = null;
    XMLDeclaration = null;
    XMLDocType = null;
    XMLRaw = null;
    XMLText = null;
    XMLProcessingInstruction = null;
    XMLDummy = null;
    NodeType = null;
    XMLNodeList = null;
    XMLNamedNodeMap = null;
    DocumentPosition = null;
    module.exports = XMLNode = function() {
        function XMLNode(parent1) {
            this.parent = parent1;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            this.value = null;
            this.children = [];
            this.baseURI = null;
            if (!XMLElement) {
                XMLElement = (parcelRequire("2T771"));
                XMLCData = (parcelRequire("knRLU"));
                XMLComment = (parcelRequire("dNPBA"));
                XMLDeclaration = (parcelRequire("g5dMw"));
                XMLDocType = (parcelRequire("9dX79"));
                XMLRaw = (parcelRequire("eLnmx"));
                XMLText = (parcelRequire("5NNmw"));
                XMLProcessingInstruction = (parcelRequire("9CnzI"));
                XMLDummy = (parcelRequire("94OGd"));
                NodeType = (parcelRequire("78YVe"));
                XMLNodeList = (parcelRequire("l9pFx"));
                XMLNamedNodeMap = (parcelRequire("5WtBN"));
                DocumentPosition = (parcelRequire("1Sraf"));
            }
        }
        Object.defineProperty(XMLNode.prototype, "nodeName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLNode.prototype, "nodeType", {
            get: function() {
                return this.type;
            }
        });
        Object.defineProperty(XMLNode.prototype, "nodeValue", {
            get: function() {
                return this.value;
            }
        });
        Object.defineProperty(XMLNode.prototype, "parentNode", {
            get: function() {
                return this.parent;
            }
        });
        Object.defineProperty(XMLNode.prototype, "childNodes", {
            get: function() {
                if (!this.childNodeList || !this.childNodeList.nodes) this.childNodeList = new XMLNodeList(this.children);
                return this.childNodeList;
            }
        });
        Object.defineProperty(XMLNode.prototype, "firstChild", {
            get: function() {
                return this.children[0] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "lastChild", {
            get: function() {
                return this.children[this.children.length - 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "previousSibling", {
            get: function() {
                var i;
                i = this.parent.children.indexOf(this);
                return this.parent.children[i - 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "nextSibling", {
            get: function() {
                var i;
                i = this.parent.children.indexOf(this);
                return this.parent.children[i + 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "ownerDocument", {
            get: function() {
                return this.document() || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, "textContent", {
            get: function() {
                var child, j, len, ref2, str;
                if (this.nodeType === NodeType.Element || this.nodeType === NodeType.DocumentFragment) {
                    str = "";
                    ref2 = this.children;
                    for(j = 0, len = ref2.length; j < len; j++){
                        child = ref2[j];
                        if (child.textContent) str += child.textContent;
                    }
                    return str;
                } else return null;
            },
            set: function(value) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        XMLNode.prototype.setParent = function(parent) {
            var child, j, len, ref2, results;
            this.parent = parent;
            if (parent) {
                this.options = parent.options;
                this.stringify = parent.stringify;
            }
            ref2 = this.children;
            results = [];
            for(j = 0, len = ref2.length; j < len; j++){
                child = ref2[j];
                results.push(child.setParent(this));
            }
            return results;
        };
        XMLNode.prototype.element = function(name, attributes, text) {
            var childNode, item, j, k, key, lastChild, len, len1, ref2, ref3, val;
            lastChild = null;
            if (attributes === null && text == null) ref2 = [
                {},
                null
            ], attributes = ref2[0], text = ref2[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref3 = [
                attributes,
                text
            ], text = ref3[0], attributes = ref3[1];
            if (name != null) name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                item = name[j];
                lastChild = this.element(item);
            }
            else if (isFunction(name)) lastChild = this.element(name.apply());
            else if (isObject(name)) for(key in name){
                if (!hasProp.call(name, key)) continue;
                val = name[key];
                if (isFunction(val)) val = val.apply();
                if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
                else if (!this.options.separateArrayItems && Array.isArray(val) && isEmpty(val)) lastChild = this.dummy();
                else if (isObject(val) && isEmpty(val)) lastChild = this.element(key);
                else if (!this.options.keepNullNodes && val == null) lastChild = this.dummy();
                else if (!this.options.separateArrayItems && Array.isArray(val)) for(k = 0, len1 = val.length; k < len1; k++){
                    item = val[k];
                    childNode = {};
                    childNode[key] = item;
                    lastChild = this.element(childNode);
                }
                else if (isObject(val)) {
                    if (!this.options.ignoreDecorators && this.stringify.convertTextKey && key.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.element(val);
                    else {
                        lastChild = this.element(key);
                        lastChild.element(val);
                    }
                } else lastChild = this.element(key, val);
            }
            else if (!this.options.keepNullNodes && text === null) lastChild = this.dummy();
            else {
                if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.text(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) lastChild = this.cdata(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) lastChild = this.comment(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) lastChild = this.raw(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
                else lastChild = this.node(name, attributes, text);
            }
            if (lastChild == null) throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
            return lastChild;
        };
        XMLNode.prototype.insertBefore = function(name, attributes, text) {
            var child, i, newChild, refChild, removed;
            if (name != null ? name.type : void 0) {
                newChild = name;
                refChild = attributes;
                newChild.setParent(this);
                if (refChild) {
                    i = children.indexOf(refChild);
                    removed = children.splice(i);
                    children.push(newChild);
                    Array.prototype.push.apply(children, removed);
                } else children.push(newChild);
                return newChild;
            } else {
                if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i);
                child = this.parent.element(name, attributes, text);
                Array.prototype.push.apply(this.parent.children, removed);
                return child;
            }
        };
        XMLNode.prototype.insertAfter = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.remove = function() {
            var i, ref2;
            if (this.isRoot) throw new Error("Cannot remove the root element. " + this.debugInfo());
            i = this.parent.children.indexOf(this);
            [].splice.apply(this.parent.children, [
                i,
                i - i + 1
            ].concat(ref2 = [])), ref2;
            return this.parent;
        };
        XMLNode.prototype.node = function(name, attributes, text) {
            var child, ref2;
            if (name != null) name = getValue(name);
            attributes || (attributes = {});
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            child = new XMLElement(this, name, attributes);
            if (text != null) child.text(text);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.text = function(value) {
            var child;
            if (isObject(value)) this.element(value);
            child = new XMLText(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.cdata = function(value) {
            var child;
            child = new XMLCData(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.comment = function(value) {
            var child;
            child = new XMLComment(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.commentBefore = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.commentAfter = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.raw = function(value) {
            var child;
            child = new XMLRaw(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.dummy = function() {
            var child;
            child = new XMLDummy(this);
            return child;
        };
        XMLNode.prototype.instruction = function(target, value) {
            var insTarget, insValue, instruction, j, len;
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(j = 0, len = target.length; j < len; j++){
                insTarget = target[j];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                instruction = new XMLProcessingInstruction(this, target, value);
                this.children.push(instruction);
            }
            return this;
        };
        XMLNode.prototype.instructionBefore = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.instructionAfter = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.declaration = function(version, encoding, standalone) {
            var doc, xmldec;
            doc = this.document();
            xmldec = new XMLDeclaration(doc, version, encoding, standalone);
            if (doc.children.length === 0) doc.children.unshift(xmldec);
            else if (doc.children[0].type === NodeType.Declaration) doc.children[0] = xmldec;
            else doc.children.unshift(xmldec);
            return doc.root() || doc;
        };
        XMLNode.prototype.dtd = function(pubID, sysID) {
            var child, doc, doctype, i, j, k, len, len1, ref2, ref3;
            doc = this.document();
            doctype = new XMLDocType(doc, pubID, sysID);
            ref2 = doc.children;
            for(i = j = 0, len = ref2.length; j < len; i = ++j){
                child = ref2[i];
                if (child.type === NodeType.DocType) {
                    doc.children[i] = doctype;
                    return doctype;
                }
            }
            ref3 = doc.children;
            for(i = k = 0, len1 = ref3.length; k < len1; i = ++k){
                child = ref3[i];
                if (child.isRoot) {
                    doc.children.splice(i, 0, doctype);
                    return doctype;
                }
            }
            doc.children.push(doctype);
            return doctype;
        };
        XMLNode.prototype.up = function() {
            if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
            return this.parent;
        };
        XMLNode.prototype.root = function() {
            var node;
            node = this;
            while(node){
                if (node.type === NodeType.Document) return node.rootObject;
                else if (node.isRoot) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.document = function() {
            var node;
            node = this;
            while(node){
                if (node.type === NodeType.Document) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.end = function(options) {
            return this.document().end(options);
        };
        XMLNode.prototype.prev = function() {
            var i;
            i = this.parent.children.indexOf(this);
            if (i < 1) throw new Error("Already at the first node. " + this.debugInfo());
            return this.parent.children[i - 1];
        };
        XMLNode.prototype.next = function() {
            var i;
            i = this.parent.children.indexOf(this);
            if (i === -1 || i === this.parent.children.length - 1) throw new Error("Already at the last node. " + this.debugInfo());
            return this.parent.children[i + 1];
        };
        XMLNode.prototype.importDocument = function(doc) {
            var clonedRoot;
            clonedRoot = doc.root().clone();
            clonedRoot.parent = this;
            clonedRoot.isRoot = false;
            this.children.push(clonedRoot);
            return this;
        };
        XMLNode.prototype.debugInfo = function(name) {
            var ref2, ref3;
            name = name || this.name;
            if (name == null && !((ref2 = this.parent) != null ? ref2.name : void 0)) return "";
            else if (name == null) return "parent: <" + this.parent.name + ">";
            else if (!((ref3 = this.parent) != null ? ref3.name : void 0)) return "node: <" + name + ">";
            else return "node: <" + name + ">, parent: <" + this.parent.name + ">";
        };
        XMLNode.prototype.ele = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.doc = function() {
            return this.document();
        };
        XMLNode.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLNode.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.t = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLNode.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.u = function() {
            return this.up();
        };
        XMLNode.prototype.importXMLBuilder = function(doc) {
            return this.importDocument(doc);
        };
        XMLNode.prototype.replaceChild = function(newChild, oldChild) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.removeChild = function(oldChild) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.appendChild = function(newChild) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.hasChildNodes = function() {
            return this.children.length !== 0;
        };
        XMLNode.prototype.cloneNode = function(deep) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.normalize = function() {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.isSupported = function(feature, version) {
            return true;
        };
        XMLNode.prototype.hasAttributes = function() {
            return this.attribs.length !== 0;
        };
        XMLNode.prototype.compareDocumentPosition = function(other) {
            var ref, res;
            ref = this;
            if (ref === other) return 0;
            else if (this.document() !== other.document()) {
                res = DocumentPosition.Disconnected | DocumentPosition.ImplementationSpecific;
                if (Math.random() < 0.5) res |= DocumentPosition.Preceding;
                else res |= DocumentPosition.Following;
                return res;
            } else if (ref.isAncestor(other)) return DocumentPosition.Contains | DocumentPosition.Preceding;
            else if (ref.isDescendant(other)) return DocumentPosition.Contains | DocumentPosition.Following;
            else if (ref.isPreceding(other)) return DocumentPosition.Preceding;
            else return DocumentPosition.Following;
        };
        XMLNode.prototype.isSameNode = function(other) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.lookupPrefix = function(namespaceURI) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.isDefaultNamespace = function(namespaceURI) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.lookupNamespaceURI = function(prefix) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.isEqualNode = function(node) {
            var i, j, ref2;
            if (node.nodeType !== this.nodeType) return false;
            if (node.children.length !== this.children.length) return false;
            for(i = j = 0, ref2 = this.children.length - 1; 0 <= ref2 ? j <= ref2 : j >= ref2; i = 0 <= ref2 ? ++j : --j){
                if (!this.children[i].isEqualNode(node.children[i])) return false;
            }
            return true;
        };
        XMLNode.prototype.getFeature = function(feature, version) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.setUserData = function(key, data, handler) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.getUserData = function(key) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLNode.prototype.contains = function(other) {
            if (!other) return false;
            return other === this || this.isDescendant(other);
        };
        XMLNode.prototype.isDescendant = function(node) {
            var child, isDescendantChild, j, len, ref2;
            ref2 = this.children;
            for(j = 0, len = ref2.length; j < len; j++){
                child = ref2[j];
                if (node === child) return true;
                isDescendantChild = child.isDescendant(node);
                if (isDescendantChild) return true;
            }
            return false;
        };
        XMLNode.prototype.isAncestor = function(node) {
            return node.isDescendant(this);
        };
        XMLNode.prototype.isPreceding = function(node) {
            var nodePos, thisPos;
            nodePos = this.treePosition(node);
            thisPos = this.treePosition(this);
            if (nodePos === -1 || thisPos === -1) return false;
            else return nodePos < thisPos;
        };
        XMLNode.prototype.isFollowing = function(node) {
            var nodePos, thisPos;
            nodePos = this.treePosition(node);
            thisPos = this.treePosition(this);
            if (nodePos === -1 || thisPos === -1) return false;
            else return nodePos > thisPos;
        };
        XMLNode.prototype.treePosition = function(node) {
            var found, pos;
            pos = 0;
            found = false;
            this.foreachTreeNode(this.document(), function(childNode) {
                pos++;
                if (!found && childNode === node) return found = true;
            });
            if (found) return pos;
            else return -1;
        };
        XMLNode.prototype.foreachTreeNode = function(node, func) {
            var child, j, len, ref2, res;
            node || (node = this.document());
            ref2 = node.children;
            for(j = 0, len = ref2.length; j < len; j++){
                child = ref2[j];
                if (res = func(child)) return res;
                else {
                    res = this.foreachTreeNode(child, func);
                    if (res) return res;
                }
            }
        };
        return XMLNode;
    }();
}).call(module.exports);

});
parcelRegister("2T771", function(module, exports) {





// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLAttribute, XMLElement, XMLNamedNodeMap, XMLNode, getValue, isFunction, isObject, ref, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("gKutS")), isObject = ref.isObject, isFunction = ref.isFunction, getValue = ref.getValue;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    XMLAttribute = (parcelRequire("7h2wn"));
    XMLNamedNodeMap = (parcelRequire("5WtBN"));
    module.exports = XMLElement = function(superClass) {
        extend(XMLElement, superClass);
        function XMLElement(parent, name, attributes) {
            var child, j, len, ref1;
            XMLElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing element name. " + this.debugInfo());
            this.name = this.stringify.name(name);
            this.type = NodeType.Element;
            this.attribs = {};
            this.schemaTypeInfo = null;
            if (attributes != null) this.attribute(attributes);
            if (parent.type === NodeType.Document) {
                this.isRoot = true;
                this.documentObject = parent;
                parent.rootObject = this;
                if (parent.children) {
                    ref1 = parent.children;
                    for(j = 0, len = ref1.length; j < len; j++){
                        child = ref1[j];
                        if (child.type === NodeType.DocType) {
                            child.name = this.name;
                            break;
                        }
                    }
                }
            }
        }
        Object.defineProperty(XMLElement.prototype, "tagName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLElement.prototype, "namespaceURI", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLElement.prototype, "prefix", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLElement.prototype, "localName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLElement.prototype, "id", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, "className", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, "classList", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, "attributes", {
            get: function() {
                if (!this.attributeMap || !this.attributeMap.nodes) this.attributeMap = new XMLNamedNodeMap(this.attribs);
                return this.attributeMap;
            }
        });
        XMLElement.prototype.clone = function() {
            var att, attName, clonedSelf, ref1;
            clonedSelf = Object.create(this);
            if (clonedSelf.isRoot) clonedSelf.documentObject = null;
            clonedSelf.attribs = {};
            ref1 = this.attribs;
            for(attName in ref1){
                if (!hasProp.call(ref1, attName)) continue;
                att = ref1[attName];
                clonedSelf.attribs[attName] = att.clone();
            }
            clonedSelf.children = [];
            this.children.forEach(function(child) {
                var clonedChild;
                clonedChild = child.clone();
                clonedChild.parent = clonedSelf;
                return clonedSelf.children.push(clonedChild);
            });
            return clonedSelf;
        };
        XMLElement.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (this.options.keepNullAttributes && value == null) this.attribs[name] = new XMLAttribute(this, name, "");
                else if (value != null) this.attribs[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLElement.prototype.removeAttribute = function(name) {
            var attName, j, len;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo());
            name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                attName = name[j];
                delete this.attribs[attName];
            }
            else delete this.attribs[name];
            return this;
        };
        XMLElement.prototype.toString = function(options) {
            return this.options.writer.element(this, this.options.writer.filterOptions(options));
        };
        XMLElement.prototype.att = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.a = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.getAttribute = function(name) {
            if (this.attribs.hasOwnProperty(name)) return this.attribs[name].value;
            else return null;
        };
        XMLElement.prototype.setAttribute = function(name, value) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getAttributeNode = function(name) {
            if (this.attribs.hasOwnProperty(name)) return this.attribs[name];
            else return null;
        };
        XMLElement.prototype.setAttributeNode = function(newAttr) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.removeAttributeNode = function(oldAttr) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagName = function(name) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getAttributeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setAttributeNS = function(namespaceURI, qualifiedName, value) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.removeAttributeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getAttributeNodeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setAttributeNodeNS = function(newAttr) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagNameNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.hasAttribute = function(name) {
            return this.attribs.hasOwnProperty(name);
        };
        XMLElement.prototype.hasAttributeNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setIdAttribute = function(name, isId) {
            if (this.attribs.hasOwnProperty(name)) return this.attribs[name].isId;
            else return isId;
        };
        XMLElement.prototype.setIdAttributeNS = function(namespaceURI, localName, isId) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.setIdAttributeNode = function(idAttr, isId) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagName = function(tagname) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByTagNameNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.getElementsByClassName = function(classNames) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLElement.prototype.isEqualNode = function(node) {
            var i, j, ref1;
            if (!XMLElement.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.namespaceURI !== this.namespaceURI) return false;
            if (node.prefix !== this.prefix) return false;
            if (node.localName !== this.localName) return false;
            if (node.attribs.length !== this.attribs.length) return false;
            for(i = j = 0, ref1 = this.attribs.length - 1; 0 <= ref1 ? j <= ref1 : j >= ref1; i = 0 <= ref1 ? ++j : --j){
                if (!this.attribs[i].isEqualNode(node.attribs[i])) return false;
            }
            return true;
        };
        return XMLElement;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("78YVe", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports = {
        Element: 1,
        Attribute: 2,
        Text: 3,
        CData: 4,
        EntityReference: 5,
        EntityDeclaration: 6,
        ProcessingInstruction: 7,
        Comment: 8,
        Document: 9,
        DocType: 10,
        DocumentFragment: 11,
        NotationDeclaration: 12,
        Declaration: 201,
        Raw: 202,
        AttributeDeclaration: 203,
        ElementDeclaration: 204,
        Dummy: 205
    };
}).call(module.exports);

});

parcelRegister("7h2wn", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLAttribute, XMLNode;
    NodeType = (parcelRequire("78YVe"));
    XMLNode = (parcelRequire("gXtXl"));
    module.exports = XMLAttribute = function() {
        function XMLAttribute(parent, name, value) {
            this.parent = parent;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo(name));
            this.name = this.stringify.name(name);
            this.value = this.stringify.attValue(value);
            this.type = NodeType.Attribute;
            this.isId = false;
            this.schemaTypeInfo = null;
        }
        Object.defineProperty(XMLAttribute.prototype, "nodeType", {
            get: function() {
                return this.type;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "ownerElement", {
            get: function() {
                return this.parent;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "textContent", {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || "";
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "namespaceURI", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "prefix", {
            get: function() {
                return "";
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "localName", {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, "specified", {
            get: function() {
                return true;
            }
        });
        XMLAttribute.prototype.clone = function() {
            return Object.create(this);
        };
        XMLAttribute.prototype.toString = function(options) {
            return this.options.writer.attribute(this, this.options.writer.filterOptions(options));
        };
        XMLAttribute.prototype.debugInfo = function(name) {
            name = name || this.name;
            if (name == null) return "parent: <" + this.parent.name + ">";
            else return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
        };
        XMLAttribute.prototype.isEqualNode = function(node) {
            if (node.namespaceURI !== this.namespaceURI) return false;
            if (node.prefix !== this.prefix) return false;
            if (node.localName !== this.localName) return false;
            if (node.value !== this.value) return false;
            return true;
        };
        return XMLAttribute;
    }();
}).call(module.exports);

});

parcelRegister("5WtBN", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNamedNodeMap;
    module.exports = XMLNamedNodeMap = function() {
        function XMLNamedNodeMap(nodes) {
            this.nodes = nodes;
        }
        Object.defineProperty(XMLNamedNodeMap.prototype, "length", {
            get: function() {
                return Object.keys(this.nodes).length || 0;
            }
        });
        XMLNamedNodeMap.prototype.clone = function() {
            return this.nodes = null;
        };
        XMLNamedNodeMap.prototype.getNamedItem = function(name) {
            return this.nodes[name];
        };
        XMLNamedNodeMap.prototype.setNamedItem = function(node) {
            var oldNode;
            oldNode = this.nodes[node.nodeName];
            this.nodes[node.nodeName] = node;
            return oldNode || null;
        };
        XMLNamedNodeMap.prototype.removeNamedItem = function(name) {
            var oldNode;
            oldNode = this.nodes[name];
            delete this.nodes[name];
            return oldNode || null;
        };
        XMLNamedNodeMap.prototype.item = function(index) {
            return this.nodes[Object.keys(this.nodes)[index]] || null;
        };
        XMLNamedNodeMap.prototype.getNamedItemNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLNamedNodeMap.prototype.setNamedItemNS = function(node) {
            throw new Error("This DOM method is not implemented.");
        };
        XMLNamedNodeMap.prototype.removeNamedItemNS = function(namespaceURI, localName) {
            throw new Error("This DOM method is not implemented.");
        };
        return XMLNamedNodeMap;
    }();
}).call(module.exports);

});


parcelRegister("knRLU", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCData, XMLCharacterData, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = (parcelRequire("78YVe"));
    XMLCharacterData = (parcelRequire("iREAX"));
    module.exports = XMLCData = function(superClass) {
        extend(XMLCData, superClass);
        function XMLCData(parent, text) {
            XMLCData.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing CDATA text. " + this.debugInfo());
            this.name = "#cdata-section";
            this.type = NodeType.CData;
            this.value = this.stringify.cdata(text);
        }
        XMLCData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCData.prototype.toString = function(options) {
            return this.options.writer.cdata(this, this.options.writer.filterOptions(options));
        };
        return XMLCData;
    }(XMLCharacterData);
}).call(module.exports);

});
parcelRegister("iREAX", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCharacterData, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("gXtXl"));
    module.exports = XMLCharacterData = function(superClass) {
        extend(XMLCharacterData, superClass);
        function XMLCharacterData(parent) {
            XMLCharacterData.__super__.constructor.call(this, parent);
            this.value = "";
        }
        Object.defineProperty(XMLCharacterData.prototype, "data", {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || "";
            }
        });
        Object.defineProperty(XMLCharacterData.prototype, "length", {
            get: function() {
                return this.value.length;
            }
        });
        Object.defineProperty(XMLCharacterData.prototype, "textContent", {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || "";
            }
        });
        XMLCharacterData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCharacterData.prototype.substringData = function(offset, count) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.appendData = function(arg) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.insertData = function(offset, arg) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.deleteData = function(offset, count) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.replaceData = function(offset, count, arg) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLCharacterData.prototype.isEqualNode = function(node) {
            if (!XMLCharacterData.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.data !== this.data) return false;
            return true;
        };
        return XMLCharacterData;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("dNPBA", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCharacterData, XMLComment, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = (parcelRequire("78YVe"));
    XMLCharacterData = (parcelRequire("iREAX"));
    module.exports = XMLComment = function(superClass) {
        extend(XMLComment, superClass);
        function XMLComment(parent, text) {
            XMLComment.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing comment text. " + this.debugInfo());
            this.name = "#comment";
            this.type = NodeType.Comment;
            this.value = this.stringify.comment(text);
        }
        XMLComment.prototype.clone = function() {
            return Object.create(this);
        };
        XMLComment.prototype.toString = function(options) {
            return this.options.writer.comment(this, this.options.writer.filterOptions(options));
        };
        return XMLComment;
    }(XMLCharacterData);
}).call(module.exports);

});

parcelRegister("g5dMw", function(module, exports) {



// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDeclaration, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("gKutS")).isObject;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    module.exports = XMLDeclaration = function(superClass) {
        extend(XMLDeclaration, superClass);
        function XMLDeclaration(parent, version, encoding, standalone) {
            var ref;
            XMLDeclaration.__super__.constructor.call(this, parent);
            if (isObject(version)) ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
            if (!version) version = "1.0";
            this.type = NodeType.Declaration;
            this.version = this.stringify.xmlVersion(version);
            if (encoding != null) this.encoding = this.stringify.xmlEncoding(encoding);
            if (standalone != null) this.standalone = this.stringify.xmlStandalone(standalone);
        }
        XMLDeclaration.prototype.toString = function(options) {
            return this.options.writer.declaration(this, this.options.writer.filterOptions(options));
        };
        return XMLDeclaration;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("9dX79", function(module, exports) {








// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNamedNodeMap, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("gKutS")).isObject;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    XMLDTDAttList = (parcelRequire("dGin6"));
    XMLDTDEntity = (parcelRequire("7db3Y"));
    XMLDTDElement = (parcelRequire("cR6P7"));
    XMLDTDNotation = (parcelRequire("70Sbi"));
    XMLNamedNodeMap = (parcelRequire("5WtBN"));
    module.exports = XMLDocType = function(superClass) {
        extend(XMLDocType, superClass);
        function XMLDocType(parent, pubID, sysID) {
            var child, i, len, ref, ref1, ref2;
            XMLDocType.__super__.constructor.call(this, parent);
            this.type = NodeType.DocType;
            if (parent.children) {
                ref = parent.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.Element) {
                        this.name = child.name;
                        break;
                    }
                }
            }
            this.documentObject = parent;
            if (isObject(pubID)) ref1 = pubID, pubID = ref1.pubID, sysID = ref1.sysID;
            if (sysID == null) ref2 = [
                pubID,
                sysID
            ], sysID = ref2[0], pubID = ref2[1];
            if (pubID != null) this.pubID = this.stringify.dtdPubID(pubID);
            if (sysID != null) this.sysID = this.stringify.dtdSysID(sysID);
        }
        Object.defineProperty(XMLDocType.prototype, "entities", {
            get: function() {
                var child, i, len, nodes, ref;
                nodes = {};
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.EntityDeclaration && !child.pe) nodes[child.name] = child;
                }
                return new XMLNamedNodeMap(nodes);
            }
        });
        Object.defineProperty(XMLDocType.prototype, "notations", {
            get: function() {
                var child, i, len, nodes, ref;
                nodes = {};
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.NotationDeclaration) nodes[child.name] = child;
                }
                return new XMLNamedNodeMap(nodes);
            }
        });
        Object.defineProperty(XMLDocType.prototype, "publicId", {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDocType.prototype, "systemId", {
            get: function() {
                return this.sysID;
            }
        });
        Object.defineProperty(XMLDocType.prototype, "internalSubset", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        XMLDocType.prototype.element = function(name, value) {
            var child;
            child = new XMLDTDElement(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var child;
            child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.entity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, false, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.pEntity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, true, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.notation = function(name, value) {
            var child;
            child = new XMLDTDNotation(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.toString = function(options) {
            return this.options.writer.docType(this, this.options.writer.filterOptions(options));
        };
        XMLDocType.prototype.ele = function(name, value) {
            return this.element(name, value);
        };
        XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
        };
        XMLDocType.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocType.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocType.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        XMLDocType.prototype.up = function() {
            return this.root() || this.documentObject;
        };
        XMLDocType.prototype.isEqualNode = function(node) {
            if (!XMLDocType.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.name !== this.name) return false;
            if (node.publicId !== this.publicId) return false;
            if (node.systemId !== this.systemId) return false;
            return true;
        };
        return XMLDocType;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("dGin6", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDAttList, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    module.exports = XMLDTDAttList = function(superClass) {
        extend(XMLDTDAttList, superClass);
        function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            XMLDTDAttList.__super__.constructor.call(this, parent);
            if (elementName == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (attributeName == null) throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
            if (!attributeType) throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
            if (!defaultValueType) throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
            if (defaultValueType.indexOf("#") !== 0) defaultValueType = "#" + defaultValueType;
            if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            this.elementName = this.stringify.name(elementName);
            this.type = NodeType.AttributeDeclaration;
            this.attributeName = this.stringify.name(attributeName);
            this.attributeType = this.stringify.dtdAttType(attributeType);
            if (defaultValue) this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
            this.defaultValueType = defaultValueType;
        }
        XMLDTDAttList.prototype.toString = function(options) {
            return this.options.writer.dtdAttList(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDAttList;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("7db3Y", function(module, exports) {



// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDEntity, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("gKutS")).isObject;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    module.exports = XMLDTDEntity = function(superClass) {
        extend(XMLDTDEntity, superClass);
        function XMLDTDEntity(parent, pe, name, value) {
            XMLDTDEntity.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD entity name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing DTD entity value. " + this.debugInfo(name));
            this.pe = !!pe;
            this.name = this.stringify.name(name);
            this.type = NodeType.EntityDeclaration;
            if (!isObject(value)) {
                this.value = this.stringify.dtdEntityValue(value);
                this.internal = true;
            } else {
                if (!value.pubID && !value.sysID) throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
                if (value.pubID && !value.sysID) throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
                this.internal = false;
                if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
                if (value.nData != null) this.nData = this.stringify.dtdNData(value.nData);
                if (this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
            }
        }
        Object.defineProperty(XMLDTDEntity.prototype, "publicId", {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "systemId", {
            get: function() {
                return this.sysID;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "notationName", {
            get: function() {
                return this.nData || null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "inputEncoding", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "xmlEncoding", {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, "xmlVersion", {
            get: function() {
                return null;
            }
        });
        XMLDTDEntity.prototype.toString = function(options) {
            return this.options.writer.dtdEntity(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDEntity;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("cR6P7", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDElement, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    module.exports = XMLDTDElement = function(superClass) {
        extend(XMLDTDElement, superClass);
        function XMLDTDElement(parent, name, value) {
            XMLDTDElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (!value) value = "(#PCDATA)";
            if (Array.isArray(value)) value = "(" + value.join(",") + ")";
            this.name = this.stringify.name(name);
            this.type = NodeType.ElementDeclaration;
            this.value = this.stringify.dtdElementValue(value);
        }
        XMLDTDElement.prototype.toString = function(options) {
            return this.options.writer.dtdElement(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDElement;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("70Sbi", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDTDNotation, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    module.exports = XMLDTDNotation = function(superClass) {
        extend(XMLDTDNotation, superClass);
        function XMLDTDNotation(parent, name, value) {
            XMLDTDNotation.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD notation name. " + this.debugInfo(name));
            if (!value.pubID && !value.sysID) throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
            this.name = this.stringify.name(name);
            this.type = NodeType.NotationDeclaration;
            if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
            if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        Object.defineProperty(XMLDTDNotation.prototype, "publicId", {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDTDNotation.prototype, "systemId", {
            get: function() {
                return this.sysID;
            }
        });
        XMLDTDNotation.prototype.toString = function(options) {
            return this.options.writer.dtdNotation(this, this.options.writer.filterOptions(options));
        };
        return XMLDTDNotation;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("eLnmx", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLNode, XMLRaw, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = (parcelRequire("78YVe"));
    XMLNode = (parcelRequire("gXtXl"));
    module.exports = XMLRaw = function(superClass) {
        extend(XMLRaw, superClass);
        function XMLRaw(parent, text) {
            XMLRaw.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing raw text. " + this.debugInfo());
            this.type = NodeType.Raw;
            this.value = this.stringify.raw(text);
        }
        XMLRaw.prototype.clone = function() {
            return Object.create(this);
        };
        XMLRaw.prototype.toString = function(options) {
            return this.options.writer.raw(this, this.options.writer.filterOptions(options));
        };
        return XMLRaw;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("5NNmw", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCharacterData, XMLText, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = (parcelRequire("78YVe"));
    XMLCharacterData = (parcelRequire("iREAX"));
    module.exports = XMLText = function(superClass) {
        extend(XMLText, superClass);
        function XMLText(parent, text) {
            XMLText.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing element text. " + this.debugInfo());
            this.name = "#text";
            this.type = NodeType.Text;
            this.value = this.stringify.text(text);
        }
        Object.defineProperty(XMLText.prototype, "isElementContentWhitespace", {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLText.prototype, "wholeText", {
            get: function() {
                var next, prev, str;
                str = "";
                prev = this.previousSibling;
                while(prev){
                    str = prev.data + str;
                    prev = prev.previousSibling;
                }
                str += this.data;
                next = this.nextSibling;
                while(next){
                    str = str + next.data;
                    next = next.nextSibling;
                }
                return str;
            }
        });
        XMLText.prototype.clone = function() {
            return Object.create(this);
        };
        XMLText.prototype.toString = function(options) {
            return this.options.writer.text(this, this.options.writer.filterOptions(options));
        };
        XMLText.prototype.splitText = function(offset) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        XMLText.prototype.replaceWholeText = function(content) {
            throw new Error("This DOM method is not implemented." + this.debugInfo());
        };
        return XMLText;
    }(XMLCharacterData);
}).call(module.exports);

});

parcelRegister("9CnzI", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLCharacterData, XMLProcessingInstruction, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = (parcelRequire("78YVe"));
    XMLCharacterData = (parcelRequire("iREAX"));
    module.exports = XMLProcessingInstruction = function(superClass) {
        extend(XMLProcessingInstruction, superClass);
        function XMLProcessingInstruction(parent, target, value) {
            XMLProcessingInstruction.__super__.constructor.call(this, parent);
            if (target == null) throw new Error("Missing instruction target. " + this.debugInfo());
            this.type = NodeType.ProcessingInstruction;
            this.target = this.stringify.insTarget(target);
            this.name = this.target;
            if (value) this.value = this.stringify.insValue(value);
        }
        XMLProcessingInstruction.prototype.clone = function() {
            return Object.create(this);
        };
        XMLProcessingInstruction.prototype.toString = function(options) {
            return this.options.writer.processingInstruction(this, this.options.writer.filterOptions(options));
        };
        XMLProcessingInstruction.prototype.isEqualNode = function(node) {
            if (!XMLProcessingInstruction.__super__.isEqualNode.apply(this, arguments).isEqualNode(node)) return false;
            if (node.target !== this.target) return false;
            return true;
        };
        return XMLProcessingInstruction;
    }(XMLCharacterData);
}).call(module.exports);

});

parcelRegister("94OGd", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, XMLDummy, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("gXtXl"));
    NodeType = (parcelRequire("78YVe"));
    module.exports = XMLDummy = function(superClass) {
        extend(XMLDummy, superClass);
        function XMLDummy(parent) {
            XMLDummy.__super__.constructor.call(this, parent);
            this.type = NodeType.Dummy;
        }
        XMLDummy.prototype.clone = function() {
            return Object.create(this);
        };
        XMLDummy.prototype.toString = function(options) {
            return "";
        };
        return XMLDummy;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("l9pFx", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNodeList;
    module.exports = XMLNodeList = function() {
        function XMLNodeList(nodes) {
            this.nodes = nodes;
        }
        Object.defineProperty(XMLNodeList.prototype, "length", {
            get: function() {
                return this.nodes.length || 0;
            }
        });
        XMLNodeList.prototype.clone = function() {
            return this.nodes = null;
        };
        XMLNodeList.prototype.item = function(index) {
            return this.nodes[index] || null;
        };
        return XMLNodeList;
    }();
}).call(module.exports);

});

parcelRegister("1Sraf", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports = {
        Disconnected: 1,
        Preceding: 2,
        Following: 4,
        Contains: 8,
        ContainedBy: 16,
        ImplementationSpecific: 32
    };
}).call(module.exports);

});


parcelRegister("2vBMM", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringifier, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, hasProp = {}.hasOwnProperty;
    module.exports = XMLStringifier = function() {
        function XMLStringifier(options) {
            this.assertLegalName = bind(this.assertLegalName, this);
            this.assertLegalChar = bind(this.assertLegalChar, this);
            var key, ref, value;
            options || (options = {});
            this.options = options;
            if (!this.options.version) this.options.version = "1.0";
            ref = options.stringify || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
        }
        XMLStringifier.prototype.name = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalName("" + val || "");
        };
        XMLStringifier.prototype.text = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar(this.textEscape("" + val || ""));
        };
        XMLStringifier.prototype.cdata = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            val = val.replace("]]>", "]]]]><![CDATA[>");
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.comment = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (val.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.raw = function(val) {
            if (this.options.noValidation) return val;
            return "" + val || "";
        };
        XMLStringifier.prototype.attValue = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar(this.attEscape(val = "" + val || ""));
        };
        XMLStringifier.prototype.insTarget = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.insValue = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (val.match(/\?>/)) throw new Error("Invalid processing instruction value: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.xmlVersion = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (!val.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlEncoding = function(val) {
            if (this.options.noValidation) return val;
            val = "" + val || "";
            if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.xmlStandalone = function(val) {
            if (this.options.noValidation) return val;
            if (val) return "yes";
            else return "no";
        };
        XMLStringifier.prototype.dtdPubID = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdSysID = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdElementValue = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdAttType = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdAttDefault = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdEntityValue = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.dtdNData = function(val) {
            if (this.options.noValidation) return val;
            return this.assertLegalChar("" + val || "");
        };
        XMLStringifier.prototype.convertAttKey = "@";
        XMLStringifier.prototype.convertPIKey = "?";
        XMLStringifier.prototype.convertTextKey = "#text";
        XMLStringifier.prototype.convertCDataKey = "#cdata";
        XMLStringifier.prototype.convertCommentKey = "#comment";
        XMLStringifier.prototype.convertRawKey = "#raw";
        XMLStringifier.prototype.assertLegalChar = function(str) {
            var regex, res;
            if (this.options.noValidation) return str;
            regex = "";
            if (this.options.version === "1.0") {
                regex = /[\0-\x08\x0B\f\x0E-\x1F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
                if (res = str.match(regex)) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            } else if (this.options.version === "1.1") {
                regex = /[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
                if (res = str.match(regex)) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            }
            return str;
        };
        XMLStringifier.prototype.assertLegalName = function(str) {
            var regex;
            if (this.options.noValidation) return str;
            this.assertLegalChar(str);
            regex = /^([:A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])([\x2D\.0-:A-Z_a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*$/;
            if (!str.match(regex)) throw new Error("Invalid character in name");
            return str;
        };
        XMLStringifier.prototype.textEscape = function(str) {
            var ampregex;
            if (this.options.noValidation) return str;
            ampregex = this.options.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;");
        };
        XMLStringifier.prototype.attEscape = function(str) {
            var ampregex;
            if (this.options.noValidation) return str;
            ampregex = this.options.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
        };
        return XMLStringifier;
    }();
}).call(module.exports);

});

parcelRegister("anTpz", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringWriter, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLWriterBase = (parcelRequire("jsJbw"));
    module.exports = XMLStringWriter = function(superClass) {
        extend(XMLStringWriter, superClass);
        function XMLStringWriter(options) {
            XMLStringWriter.__super__.constructor.call(this, options);
        }
        XMLStringWriter.prototype.document = function(doc, options) {
            var child, i, len, r, ref;
            options = this.filterOptions(options);
            r = "";
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                r += this.writeChildNode(child, options, 0);
            }
            if (options.pretty && r.slice(-options.newline.length) === options.newline) r = r.slice(0, -options.newline.length);
            return r;
        };
        return XMLStringWriter;
    }(XMLWriterBase);
}).call(module.exports);

});
parcelRegister("jsJbw", function(module, exports) {
















// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLText, XMLWriterBase, assign, hasProp = {}.hasOwnProperty;
    assign = (parcelRequire("gKutS")).assign;
    NodeType = (parcelRequire("78YVe"));
    XMLDeclaration = (parcelRequire("g5dMw"));
    XMLDocType = (parcelRequire("9dX79"));
    XMLCData = (parcelRequire("knRLU"));
    XMLComment = (parcelRequire("dNPBA"));
    XMLElement = (parcelRequire("2T771"));
    XMLRaw = (parcelRequire("eLnmx"));
    XMLText = (parcelRequire("5NNmw"));
    XMLProcessingInstruction = (parcelRequire("9CnzI"));
    XMLDummy = (parcelRequire("94OGd"));
    XMLDTDAttList = (parcelRequire("dGin6"));
    XMLDTDElement = (parcelRequire("cR6P7"));
    XMLDTDEntity = (parcelRequire("7db3Y"));
    XMLDTDNotation = (parcelRequire("70Sbi"));
    WriterState = (parcelRequire("lGpn4"));
    module.exports = XMLWriterBase = function() {
        function XMLWriterBase(options) {
            var key, ref, value;
            options || (options = {});
            this.options = options;
            ref = options.writer || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this["_" + key] = this[key];
                this[key] = value;
            }
        }
        XMLWriterBase.prototype.filterOptions = function(options) {
            var filteredOptions, ref, ref1, ref2, ref3, ref4, ref5, ref6;
            options || (options = {});
            options = assign({}, this.options, options);
            filteredOptions = {
                writer: this
            };
            filteredOptions.pretty = options.pretty || false;
            filteredOptions.allowEmpty = options.allowEmpty || false;
            filteredOptions.indent = (ref = options.indent) != null ? ref : "  ";
            filteredOptions.newline = (ref1 = options.newline) != null ? ref1 : "\n";
            filteredOptions.offset = (ref2 = options.offset) != null ? ref2 : 0;
            filteredOptions.dontPrettyTextNodes = (ref3 = (ref4 = options.dontPrettyTextNodes) != null ? ref4 : options.dontprettytextnodes) != null ? ref3 : 0;
            filteredOptions.spaceBeforeSlash = (ref5 = (ref6 = options.spaceBeforeSlash) != null ? ref6 : options.spacebeforeslash) != null ? ref5 : "";
            if (filteredOptions.spaceBeforeSlash === true) filteredOptions.spaceBeforeSlash = " ";
            filteredOptions.suppressPrettyCount = 0;
            filteredOptions.user = {};
            filteredOptions.state = WriterState.None;
            return filteredOptions;
        };
        XMLWriterBase.prototype.indent = function(node, options, level) {
            var indentLevel;
            if (!options.pretty || options.suppressPrettyCount) return "";
            else if (options.pretty) {
                indentLevel = (level || 0) + options.offset + 1;
                if (indentLevel > 0) return new Array(indentLevel).join(options.indent);
            }
            return "";
        };
        XMLWriterBase.prototype.endline = function(node, options, level) {
            if (!options.pretty || options.suppressPrettyCount) return "";
            else return options.newline;
        };
        XMLWriterBase.prototype.attribute = function(att, options, level) {
            var r;
            this.openAttribute(att, options, level);
            r = " " + att.name + '="' + att.value + '"';
            this.closeAttribute(att, options, level);
            return r;
        };
        XMLWriterBase.prototype.cdata = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<![CDATA[";
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += "]]>" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.comment = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!-- ";
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += " -->" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.declaration = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<?xml";
            options.state = WriterState.InsideTag;
            r += ' version="' + node.version + '"';
            if (node.encoding != null) r += ' encoding="' + node.encoding + '"';
            if (node.standalone != null) r += ' standalone="' + node.standalone + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + "?>";
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.docType = function(node, options, level) {
            var child, i, len, r, ref;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            r += "<!DOCTYPE " + node.root().name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            if (node.children.length > 0) {
                r += " [";
                r += this.endline(node, options, level);
                options.state = WriterState.InsideTag;
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    r += this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                r += "]";
            }
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">";
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.element = function(node, options, level) {
            var att, child, childNodeCount, firstChildNode, i, j, len, len1, name, prettySuppressed, r, ref, ref1, ref2;
            level || (level = 0);
            prettySuppressed = false;
            r = "";
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r += this.indent(node, options, level) + "<" + node.name;
            ref = node.attribs;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                r += this.attribute(att, options, level);
            }
            childNodeCount = node.children.length;
            firstChildNode = childNodeCount === 0 ? null : node.children[0];
            if (childNodeCount === 0 || node.children.every(function(e) {
                return (e.type === NodeType.Text || e.type === NodeType.Raw) && e.value === "";
            })) {
                if (options.allowEmpty) {
                    r += ">";
                    options.state = WriterState.CloseTag;
                    r += "</" + node.name + ">" + this.endline(node, options, level);
                } else {
                    options.state = WriterState.CloseTag;
                    r += options.spaceBeforeSlash + "/>" + this.endline(node, options, level);
                }
            } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw) && firstChildNode.value != null) {
                r += ">";
                options.state = WriterState.InsideTag;
                options.suppressPrettyCount++;
                prettySuppressed = true;
                r += this.writeChildNode(firstChildNode, options, level + 1);
                options.suppressPrettyCount--;
                prettySuppressed = false;
                options.state = WriterState.CloseTag;
                r += "</" + node.name + ">" + this.endline(node, options, level);
            } else {
                if (options.dontPrettyTextNodes) {
                    ref1 = node.children;
                    for(i = 0, len = ref1.length; i < len; i++){
                        child = ref1[i];
                        if ((child.type === NodeType.Text || child.type === NodeType.Raw) && child.value != null) {
                            options.suppressPrettyCount++;
                            prettySuppressed = true;
                            break;
                        }
                    }
                }
                r += ">" + this.endline(node, options, level);
                options.state = WriterState.InsideTag;
                ref2 = node.children;
                for(j = 0, len1 = ref2.length; j < len1; j++){
                    child = ref2[j];
                    r += this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                r += this.indent(node, options, level) + "</" + node.name + ">";
                if (prettySuppressed) options.suppressPrettyCount--;
                r += this.endline(node, options, level);
                options.state = WriterState.None;
            }
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.writeChildNode = function(node, options, level) {
            switch(node.type){
                case NodeType.CData:
                    return this.cdata(node, options, level);
                case NodeType.Comment:
                    return this.comment(node, options, level);
                case NodeType.Element:
                    return this.element(node, options, level);
                case NodeType.Raw:
                    return this.raw(node, options, level);
                case NodeType.Text:
                    return this.text(node, options, level);
                case NodeType.ProcessingInstruction:
                    return this.processingInstruction(node, options, level);
                case NodeType.Dummy:
                    return "";
                case NodeType.Declaration:
                    return this.declaration(node, options, level);
                case NodeType.DocType:
                    return this.docType(node, options, level);
                case NodeType.AttributeDeclaration:
                    return this.dtdAttList(node, options, level);
                case NodeType.ElementDeclaration:
                    return this.dtdElement(node, options, level);
                case NodeType.EntityDeclaration:
                    return this.dtdEntity(node, options, level);
                case NodeType.NotationDeclaration:
                    return this.dtdNotation(node, options, level);
                default:
                    throw new Error("Unknown XML node type: " + node.constructor.name);
            }
        };
        XMLWriterBase.prototype.processingInstruction = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<?";
            options.state = WriterState.InsideTag;
            r += node.target;
            if (node.value) r += " " + node.value;
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + "?>";
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.raw = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.text = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdAttList = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!ATTLIST";
            options.state = WriterState.InsideTag;
            r += " " + node.elementName + " " + node.attributeName + " " + node.attributeType;
            if (node.defaultValueType !== "#DEFAULT") r += " " + node.defaultValueType;
            if (node.defaultValue) r += ' "' + node.defaultValue + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdElement = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!ELEMENT";
            options.state = WriterState.InsideTag;
            r += " " + node.name + " " + node.value;
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdEntity = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!ENTITY";
            options.state = WriterState.InsideTag;
            if (node.pe) r += " %";
            r += " " + node.name;
            if (node.value) r += ' "' + node.value + '"';
            else {
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                if (node.nData) r += " NDATA " + node.nData;
            }
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.dtdNotation = function(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + "<!NOTATION";
            options.state = WriterState.InsideTag;
            r += " " + node.name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.pubID) r += ' PUBLIC "' + node.pubID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + ">" + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        };
        XMLWriterBase.prototype.openNode = function(node, options, level) {};
        XMLWriterBase.prototype.closeNode = function(node, options, level) {};
        XMLWriterBase.prototype.openAttribute = function(att, options, level) {};
        XMLWriterBase.prototype.closeAttribute = function(att, options, level) {};
        return XMLWriterBase;
    }();
}).call(module.exports);

});
parcelRegister("lGpn4", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    module.exports = {
        None: 0,
        OpenTag: 1,
        InsideTag: 2,
        CloseTag: 3
    };
}).call(module.exports);

});




parcelRegister("in7R2", function(module, exports) {



















// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocument, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("gKutS")), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject, getValue = ref.getValue;
    NodeType = (parcelRequire("78YVe"));
    XMLDocument = (parcelRequire("jvyHT"));
    XMLElement = (parcelRequire("2T771"));
    XMLCData = (parcelRequire("knRLU"));
    XMLComment = (parcelRequire("dNPBA"));
    XMLRaw = (parcelRequire("eLnmx"));
    XMLText = (parcelRequire("5NNmw"));
    XMLProcessingInstruction = (parcelRequire("9CnzI"));
    XMLDeclaration = (parcelRequire("g5dMw"));
    XMLDocType = (parcelRequire("9dX79"));
    XMLDTDAttList = (parcelRequire("dGin6"));
    XMLDTDEntity = (parcelRequire("7db3Y"));
    XMLDTDElement = (parcelRequire("cR6P7"));
    XMLDTDNotation = (parcelRequire("70Sbi"));
    XMLAttribute = (parcelRequire("7h2wn"));
    XMLStringifier = (parcelRequire("2vBMM"));
    XMLStringWriter = (parcelRequire("anTpz"));
    WriterState = (parcelRequire("lGpn4"));
    module.exports = XMLDocumentCB = function() {
        function XMLDocumentCB(options, onData, onEnd) {
            var writerOptions;
            this.name = "?xml";
            this.type = NodeType.Document;
            options || (options = {});
            writerOptions = {};
            if (!options.writer) options.writer = new XMLStringWriter();
            else if (isPlainObject(options.writer)) {
                writerOptions = options.writer;
                options.writer = new XMLStringWriter();
            }
            this.options = options;
            this.writer = options.writer;
            this.writerOptions = this.writer.filterOptions(writerOptions);
            this.stringify = new XMLStringifier(options);
            this.onDataCallback = onData || function() {};
            this.onEndCallback = onEnd || function() {};
            this.currentNode = null;
            this.currentLevel = -1;
            this.openTags = {};
            this.documentStarted = false;
            this.documentCompleted = false;
            this.root = null;
        }
        XMLDocumentCB.prototype.createChildNode = function(node) {
            var att, attName, attributes, child, i, len, ref1, ref2;
            switch(node.type){
                case NodeType.CData:
                    this.cdata(node.value);
                    break;
                case NodeType.Comment:
                    this.comment(node.value);
                    break;
                case NodeType.Element:
                    attributes = {};
                    ref1 = node.attribs;
                    for(attName in ref1){
                        if (!hasProp.call(ref1, attName)) continue;
                        att = ref1[attName];
                        attributes[attName] = att.value;
                    }
                    this.node(node.name, attributes);
                    break;
                case NodeType.Dummy:
                    this.dummy();
                    break;
                case NodeType.Raw:
                    this.raw(node.value);
                    break;
                case NodeType.Text:
                    this.text(node.value);
                    break;
                case NodeType.ProcessingInstruction:
                    this.instruction(node.target, node.value);
                    break;
                default:
                    throw new Error("This XML node type is not supported in a JS object: " + node.constructor.name);
            }
            ref2 = node.children;
            for(i = 0, len = ref2.length; i < len; i++){
                child = ref2[i];
                this.createChildNode(child);
                if (child.type === NodeType.Element) this.up();
            }
            return this;
        };
        XMLDocumentCB.prototype.dummy = function() {
            return this;
        };
        XMLDocumentCB.prototype.node = function(name, attributes, text) {
            var ref1;
            if (name == null) throw new Error("Missing node name.");
            if (this.root && this.currentLevel === -1) throw new Error("Document can only have one root node. " + this.debugInfo(name));
            this.openCurrent();
            name = getValue(name);
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref1 = [
                attributes,
                text
            ], text = ref1[0], attributes = ref1[1];
            this.currentNode = new XMLElement(this, name, attributes);
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            if (text != null) this.text(text);
            return this;
        };
        XMLDocumentCB.prototype.element = function(name, attributes, text) {
            var child, i, len, oldValidationFlag, ref1, root;
            if (this.currentNode && this.currentNode.type === NodeType.DocType) this.dtdElement.apply(this, arguments);
            else if (Array.isArray(name) || isObject(name) || isFunction(name)) {
                oldValidationFlag = this.options.noValidation;
                this.options.noValidation = true;
                root = new XMLDocument(this.options).element("TEMP_ROOT");
                root.element(name);
                this.options.noValidation = oldValidationFlag;
                ref1 = root.children;
                for(i = 0, len = ref1.length; i < len; i++){
                    child = ref1[i];
                    this.createChildNode(child);
                    if (child.type === NodeType.Element) this.up();
                }
            } else this.node(name, attributes, text);
            return this;
        };
        XMLDocumentCB.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (this.options.keepNullAttributes && value == null) this.currentNode.attribs[name] = new XMLAttribute(this, name, "");
                else if (value != null) this.currentNode.attribs[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLDocumentCB.prototype.text = function(value) {
            var node;
            this.openCurrent();
            node = new XMLText(this, value);
            this.onData(this.writer.text(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.cdata = function(value) {
            var node;
            this.openCurrent();
            node = new XMLCData(this, value);
            this.onData(this.writer.cdata(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.comment = function(value) {
            var node;
            this.openCurrent();
            node = new XMLComment(this, value);
            this.onData(this.writer.comment(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.raw = function(value) {
            var node;
            this.openCurrent();
            node = new XMLRaw(this, value);
            this.onData(this.writer.raw(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.instruction = function(target, value) {
            var i, insTarget, insValue, len, node;
            this.openCurrent();
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(i = 0, len = target.length; i < len; i++){
                insTarget = target[i];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                node = new XMLProcessingInstruction(this, target, value);
                this.onData(this.writer.processingInstruction(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            }
            return this;
        };
        XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
            var node;
            this.openCurrent();
            if (this.documentStarted) throw new Error("declaration() must be the first node.");
            node = new XMLDeclaration(this, version, encoding, standalone);
            this.onData(this.writer.declaration(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
            this.openCurrent();
            if (root == null) throw new Error("Missing root node name.");
            if (this.root) throw new Error("dtd() must come before the root node.");
            this.currentNode = new XMLDocType(this, pubID, sysID);
            this.currentNode.rootNodeName = root;
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            return this;
        };
        XMLDocumentCB.prototype.dtdElement = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDElement(this, name, value);
            this.onData(this.writer.dtdElement(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var node;
            this.openCurrent();
            node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.onData(this.writer.dtdAttList(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.entity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, false, name, value);
            this.onData(this.writer.dtdEntity(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.pEntity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, true, name, value);
            this.onData(this.writer.dtdEntity(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.notation = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDNotation(this, name, value);
            this.onData(this.writer.dtdNotation(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.up = function() {
            if (this.currentLevel < 0) throw new Error("The document node has no parent.");
            if (this.currentNode) {
                if (this.currentNode.children) this.closeNode(this.currentNode);
                else this.openNode(this.currentNode);
                this.currentNode = null;
            } else this.closeNode(this.openTags[this.currentLevel]);
            delete this.openTags[this.currentLevel];
            this.currentLevel--;
            return this;
        };
        XMLDocumentCB.prototype.end = function() {
            while(this.currentLevel >= 0)this.up();
            return this.onEnd();
        };
        XMLDocumentCB.prototype.openCurrent = function() {
            if (this.currentNode) {
                this.currentNode.children = true;
                return this.openNode(this.currentNode);
            }
        };
        XMLDocumentCB.prototype.openNode = function(node) {
            var att, chunk, name, ref1;
            if (!node.isOpen) {
                if (!this.root && this.currentLevel === 0 && node.type === NodeType.Element) this.root = node;
                chunk = "";
                if (node.type === NodeType.Element) {
                    this.writerOptions.state = WriterState.OpenTag;
                    chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "<" + node.name;
                    ref1 = node.attribs;
                    for(name in ref1){
                        if (!hasProp.call(ref1, name)) continue;
                        att = ref1[name];
                        chunk += this.writer.attribute(att, this.writerOptions, this.currentLevel);
                    }
                    chunk += (node.children ? ">" : "/>") + this.writer.endline(node, this.writerOptions, this.currentLevel);
                    this.writerOptions.state = WriterState.InsideTag;
                } else {
                    this.writerOptions.state = WriterState.OpenTag;
                    chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "<!DOCTYPE " + node.rootNodeName;
                    if (node.pubID && node.sysID) chunk += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                    else if (node.sysID) chunk += ' SYSTEM "' + node.sysID + '"';
                    if (node.children) {
                        chunk += " [";
                        this.writerOptions.state = WriterState.InsideTag;
                    } else {
                        this.writerOptions.state = WriterState.CloseTag;
                        chunk += ">";
                    }
                    chunk += this.writer.endline(node, this.writerOptions, this.currentLevel);
                }
                this.onData(chunk, this.currentLevel);
                return node.isOpen = true;
            }
        };
        XMLDocumentCB.prototype.closeNode = function(node) {
            var chunk;
            if (!node.isClosed) {
                chunk = "";
                this.writerOptions.state = WriterState.CloseTag;
                if (node.type === NodeType.Element) chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "</" + node.name + ">" + this.writer.endline(node, this.writerOptions, this.currentLevel);
                else chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + "]>" + this.writer.endline(node, this.writerOptions, this.currentLevel);
                this.writerOptions.state = WriterState.None;
                this.onData(chunk, this.currentLevel);
                return node.isClosed = true;
            }
        };
        XMLDocumentCB.prototype.onData = function(chunk, level) {
            this.documentStarted = true;
            return this.onDataCallback(chunk, level + 1);
        };
        XMLDocumentCB.prototype.onEnd = function() {
            this.documentCompleted = true;
            return this.onEndCallback();
        };
        XMLDocumentCB.prototype.debugInfo = function(name) {
            if (name == null) return "";
            else return "node: <" + name + ">";
        };
        XMLDocumentCB.prototype.ele = function() {
            return this.element.apply(this, arguments);
        };
        XMLDocumentCB.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
            return this.doctype(root, pubID, sysID);
        };
        XMLDocumentCB.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLDocumentCB.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.t = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLDocumentCB.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.att = function() {
            if (this.currentNode && this.currentNode.type === NodeType.DocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.a = function() {
            if (this.currentNode && this.currentNode.type === NodeType.DocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocumentCB.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocumentCB.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        return XMLDocumentCB;
    }();
}).call(module.exports);

});

parcelRegister("cdCBO", function(module, exports) {



// Generated by CoffeeScript 1.12.7
(function() {
    var NodeType, WriterState, XMLStreamWriter, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    NodeType = (parcelRequire("78YVe"));
    XMLWriterBase = (parcelRequire("jsJbw"));
    WriterState = (parcelRequire("lGpn4"));
    module.exports = XMLStreamWriter = function(superClass) {
        extend(XMLStreamWriter, superClass);
        function XMLStreamWriter(stream, options) {
            this.stream = stream;
            XMLStreamWriter.__super__.constructor.call(this, options);
        }
        XMLStreamWriter.prototype.endline = function(node, options, level) {
            if (node.isLastRootNode && options.state === WriterState.CloseTag) return "";
            else return XMLStreamWriter.__super__.endline.call(this, node, options, level);
        };
        XMLStreamWriter.prototype.document = function(doc, options) {
            var child, i, j, k, len, len1, ref, ref1, results;
            ref = doc.children;
            for(i = j = 0, len = ref.length; j < len; i = ++j){
                child = ref[i];
                child.isLastRootNode = i === doc.children.length - 1;
            }
            options = this.filterOptions(options);
            ref1 = doc.children;
            results = [];
            for(k = 0, len1 = ref1.length; k < len1; k++){
                child = ref1[k];
                results.push(this.writeChildNode(child, options, 0));
            }
            return results;
        };
        XMLStreamWriter.prototype.attribute = function(att, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.attribute.call(this, att, options, level));
        };
        XMLStreamWriter.prototype.cdata = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.cdata.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.comment = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.comment.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.declaration = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.declaration.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.docType = function(node, options, level) {
            var child, j, len, ref;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            this.stream.write(this.indent(node, options, level));
            this.stream.write("<!DOCTYPE " + node.root().name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            if (node.children.length > 0) {
                this.stream.write(" [");
                this.stream.write(this.endline(node, options, level));
                options.state = WriterState.InsideTag;
                ref = node.children;
                for(j = 0, len = ref.length; j < len; j++){
                    child = ref[j];
                    this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                this.stream.write("]");
            }
            options.state = WriterState.CloseTag;
            this.stream.write(options.spaceBeforeSlash + ">");
            this.stream.write(this.endline(node, options, level));
            options.state = WriterState.None;
            return this.closeNode(node, options, level);
        };
        XMLStreamWriter.prototype.element = function(node, options, level) {
            var att, child, childNodeCount, firstChildNode, j, len, name, prettySuppressed, ref, ref1;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            this.stream.write(this.indent(node, options, level) + "<" + node.name);
            ref = node.attribs;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                this.attribute(att, options, level);
            }
            childNodeCount = node.children.length;
            firstChildNode = childNodeCount === 0 ? null : node.children[0];
            if (childNodeCount === 0 || node.children.every(function(e) {
                return (e.type === NodeType.Text || e.type === NodeType.Raw) && e.value === "";
            })) {
                if (options.allowEmpty) {
                    this.stream.write(">");
                    options.state = WriterState.CloseTag;
                    this.stream.write("</" + node.name + ">");
                } else {
                    options.state = WriterState.CloseTag;
                    this.stream.write(options.spaceBeforeSlash + "/>");
                }
            } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw) && firstChildNode.value != null) {
                this.stream.write(">");
                options.state = WriterState.InsideTag;
                options.suppressPrettyCount++;
                prettySuppressed = true;
                this.writeChildNode(firstChildNode, options, level + 1);
                options.suppressPrettyCount--;
                prettySuppressed = false;
                options.state = WriterState.CloseTag;
                this.stream.write("</" + node.name + ">");
            } else {
                this.stream.write(">" + this.endline(node, options, level));
                options.state = WriterState.InsideTag;
                ref1 = node.children;
                for(j = 0, len = ref1.length; j < len; j++){
                    child = ref1[j];
                    this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                this.stream.write(this.indent(node, options, level) + "</" + node.name + ">");
            }
            this.stream.write(this.endline(node, options, level));
            options.state = WriterState.None;
            return this.closeNode(node, options, level);
        };
        XMLStreamWriter.prototype.processingInstruction = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.processingInstruction.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.raw = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.raw.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.text = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.text.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdAttList = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdAttList.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdElement = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdElement.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdEntity = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdEntity.call(this, node, options, level));
        };
        XMLStreamWriter.prototype.dtdNotation = function(node, options, level) {
            return this.stream.write(XMLStreamWriter.__super__.dtdNotation.call(this, node, options, level));
        };
        return XMLStreamWriter;
    }(XMLWriterBase);
}).call(module.exports);

});



parcelRegister("lUgJQ", function(module, exports) {






// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var bom, defaults, defineProperty, events, isEmpty, processItem, processors, sax, setImmediate, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    sax = (parcelRequire("2l4LK"));
    events = (parcelRequire("5nsYU"));
    bom = (parcelRequire("2Tz2T"));
    processors = (parcelRequire("aUA6y"));
    setImmediate = (parcelRequire("2E3Dc")).setImmediate;
    defaults = (parcelRequire("7E3cb")).defaults;
    isEmpty = function(thing) {
        return typeof thing === "object" && thing != null && Object.keys(thing).length === 0;
    };
    processItem = function(processors, item, key) {
        var i, len, process;
        for(i = 0, len = processors.length; i < len; i++){
            process = processors[i];
            item = process(item, key);
        }
        return item;
    };
    defineProperty = function(obj, key, value) {
        var descriptor;
        descriptor = Object.create(null);
        descriptor.value = value;
        descriptor.writable = true;
        descriptor.enumerable = true;
        descriptor.configurable = true;
        return Object.defineProperty(obj, key, descriptor);
    };
    exports.Parser = function(superClass) {
        extend(Parser, superClass);
        function Parser(opts) {
            this.parseStringPromise = bind(this.parseStringPromise, this);
            this.parseString = bind(this.parseString, this);
            this.reset = bind(this.reset, this);
            this.assignOrPush = bind(this.assignOrPush, this);
            this.processAsync = bind(this.processAsync, this);
            var key, ref, value;
            if (!(this instanceof exports.Parser)) return new exports.Parser(opts);
            this.options = {};
            ref = defaults["0.2"];
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this.options[key] = value;
            }
            for(key in opts){
                if (!hasProp.call(opts, key)) continue;
                value = opts[key];
                this.options[key] = value;
            }
            if (this.options.xmlns) this.options.xmlnskey = this.options.attrkey + "ns";
            if (this.options.normalizeTags) {
                if (!this.options.tagNameProcessors) this.options.tagNameProcessors = [];
                this.options.tagNameProcessors.unshift(processors.normalize);
            }
            this.reset();
        }
        Parser.prototype.processAsync = function() {
            var chunk, err;
            try {
                if (this.remaining.length <= this.options.chunkSize) {
                    chunk = this.remaining;
                    this.remaining = "";
                    this.saxParser = this.saxParser.write(chunk);
                    return this.saxParser.close();
                } else {
                    chunk = this.remaining.substr(0, this.options.chunkSize);
                    this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length);
                    this.saxParser = this.saxParser.write(chunk);
                    return setImmediate(this.processAsync);
                }
            } catch (error1) {
                err = error1;
                if (!this.saxParser.errThrown) {
                    this.saxParser.errThrown = true;
                    return this.emit(err);
                }
            }
        };
        Parser.prototype.assignOrPush = function(obj, key, newValue) {
            if (!(key in obj)) {
                if (!this.options.explicitArray) return defineProperty(obj, key, newValue);
                else return defineProperty(obj, key, [
                    newValue
                ]);
            } else {
                if (!(obj[key] instanceof Array)) defineProperty(obj, key, [
                    obj[key]
                ]);
                return obj[key].push(newValue);
            }
        };
        Parser.prototype.reset = function() {
            var attrkey, charkey, ontext, stack;
            this.removeAllListeners();
            this.saxParser = sax.parser(this.options.strict, {
                trim: false,
                normalize: false,
                xmlns: this.options.xmlns
            });
            this.saxParser.errThrown = false;
            this.saxParser.onerror = function(_this) {
                return function(error) {
                    _this.saxParser.resume();
                    if (!_this.saxParser.errThrown) {
                        _this.saxParser.errThrown = true;
                        return _this.emit("error", error);
                    }
                };
            }(this);
            this.saxParser.onend = function(_this) {
                return function() {
                    if (!_this.saxParser.ended) {
                        _this.saxParser.ended = true;
                        return _this.emit("end", _this.resultObject);
                    }
                };
            }(this);
            this.saxParser.ended = false;
            this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
            this.resultObject = null;
            stack = [];
            attrkey = this.options.attrkey;
            charkey = this.options.charkey;
            this.saxParser.onopentag = function(_this) {
                return function(node) {
                    var key, newValue, obj, processedKey, ref;
                    obj = {};
                    obj[charkey] = "";
                    if (!_this.options.ignoreAttrs) {
                        ref = node.attributes;
                        for(key in ref){
                            if (!hasProp.call(ref, key)) continue;
                            if (!(attrkey in obj) && !_this.options.mergeAttrs) obj[attrkey] = {};
                            newValue = _this.options.attrValueProcessors ? processItem(_this.options.attrValueProcessors, node.attributes[key], key) : node.attributes[key];
                            processedKey = _this.options.attrNameProcessors ? processItem(_this.options.attrNameProcessors, key) : key;
                            if (_this.options.mergeAttrs) _this.assignOrPush(obj, processedKey, newValue);
                            else defineProperty(obj[attrkey], processedKey, newValue);
                        }
                    }
                    obj["#name"] = _this.options.tagNameProcessors ? processItem(_this.options.tagNameProcessors, node.name) : node.name;
                    if (_this.options.xmlns) obj[_this.options.xmlnskey] = {
                        uri: node.uri,
                        local: node.local
                    };
                    return stack.push(obj);
                };
            }(this);
            this.saxParser.onclosetag = function(_this) {
                return function() {
                    var cdata, emptyStr, key, node, nodeName, obj, objClone, old, s, xpath;
                    obj = stack.pop();
                    nodeName = obj["#name"];
                    if (!_this.options.explicitChildren || !_this.options.preserveChildrenOrder) delete obj["#name"];
                    if (obj.cdata === true) {
                        cdata = obj.cdata;
                        delete obj.cdata;
                    }
                    s = stack[stack.length - 1];
                    if (obj[charkey].match(/^\s*$/) && !cdata) {
                        emptyStr = obj[charkey];
                        delete obj[charkey];
                    } else {
                        if (_this.options.trim) obj[charkey] = obj[charkey].trim();
                        if (_this.options.normalize) obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
                        obj[charkey] = _this.options.valueProcessors ? processItem(_this.options.valueProcessors, obj[charkey], nodeName) : obj[charkey];
                        if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) obj = obj[charkey];
                    }
                    if (isEmpty(obj)) {
                        if (typeof _this.options.emptyTag === "function") obj = _this.options.emptyTag();
                        else obj = _this.options.emptyTag !== "" ? _this.options.emptyTag : emptyStr;
                    }
                    if (_this.options.validator != null) {
                        xpath = "/" + (function() {
                            var i, len, results;
                            results = [];
                            for(i = 0, len = stack.length; i < len; i++){
                                node = stack[i];
                                results.push(node["#name"]);
                            }
                            return results;
                        })().concat(nodeName).join("/");
                        (function() {
                            var err;
                            try {
                                return obj = _this.options.validator(xpath, s && s[nodeName], obj);
                            } catch (error1) {
                                err = error1;
                                return _this.emit("error", err);
                            }
                        })();
                    }
                    if (_this.options.explicitChildren && !_this.options.mergeAttrs && typeof obj === "object") {
                        if (!_this.options.preserveChildrenOrder) {
                            node = {};
                            if (_this.options.attrkey in obj) {
                                node[_this.options.attrkey] = obj[_this.options.attrkey];
                                delete obj[_this.options.attrkey];
                            }
                            if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
                                node[_this.options.charkey] = obj[_this.options.charkey];
                                delete obj[_this.options.charkey];
                            }
                            if (Object.getOwnPropertyNames(obj).length > 0) node[_this.options.childkey] = obj;
                            obj = node;
                        } else if (s) {
                            s[_this.options.childkey] = s[_this.options.childkey] || [];
                            objClone = {};
                            for(key in obj){
                                if (!hasProp.call(obj, key)) continue;
                                defineProperty(objClone, key, obj[key]);
                            }
                            s[_this.options.childkey].push(objClone);
                            delete obj["#name"];
                            if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) obj = obj[charkey];
                        }
                    }
                    if (stack.length > 0) return _this.assignOrPush(s, nodeName, obj);
                    else {
                        if (_this.options.explicitRoot) {
                            old = obj;
                            obj = {};
                            defineProperty(obj, nodeName, old);
                        }
                        _this.resultObject = obj;
                        _this.saxParser.ended = true;
                        return _this.emit("end", _this.resultObject);
                    }
                };
            }(this);
            ontext = function(_this) {
                return function(text) {
                    var charChild, s;
                    s = stack[stack.length - 1];
                    if (s) {
                        s[charkey] += text;
                        if (_this.options.explicitChildren && _this.options.preserveChildrenOrder && _this.options.charsAsChildren && (_this.options.includeWhiteChars || text.replace(/\\n/g, "").trim() !== "")) {
                            s[_this.options.childkey] = s[_this.options.childkey] || [];
                            charChild = {
                                "#name": "__text__"
                            };
                            charChild[charkey] = text;
                            if (_this.options.normalize) charChild[charkey] = charChild[charkey].replace(/\s{2,}/g, " ").trim();
                            s[_this.options.childkey].push(charChild);
                        }
                        return s;
                    }
                };
            }(this);
            this.saxParser.ontext = ontext;
            return this.saxParser.oncdata = function(_this) {
                return function(text) {
                    var s;
                    s = ontext(text);
                    if (s) return s.cdata = true;
                };
            }(this);
        };
        Parser.prototype.parseString = function(str, cb) {
            var err;
            if (cb != null && typeof cb === "function") {
                this.on("end", function(result) {
                    this.reset();
                    return cb(null, result);
                });
                this.on("error", function(err) {
                    this.reset();
                    return cb(err);
                });
            }
            try {
                str = str.toString();
                if (str.trim() === "") {
                    this.emit("end", null);
                    return true;
                }
                str = bom.stripBOM(str);
                if (this.options.async) {
                    this.remaining = str;
                    setImmediate(this.processAsync);
                    return this.saxParser;
                }
                return this.saxParser.write(str).close();
            } catch (error1) {
                err = error1;
                if (!(this.saxParser.errThrown || this.saxParser.ended)) {
                    this.emit("error", err);
                    return this.saxParser.errThrown = true;
                } else if (this.saxParser.ended) throw err;
            }
        };
        Parser.prototype.parseStringPromise = function(str) {
            return new Promise(function(_this) {
                return function(resolve, reject) {
                    return _this.parseString(str, function(err, value) {
                        if (err) return reject(err);
                        else return resolve(value);
                    });
                };
            }(this));
        };
        return Parser;
    }(events);
    exports.parseString = function(str, a, b) {
        var cb, options, parser;
        if (b != null) {
            if (typeof b === "function") cb = b;
            if (typeof a === "object") options = a;
        } else {
            if (typeof a === "function") cb = a;
            options = {};
        }
        parser = new exports.Parser(options);
        return parser.parseString(str, cb);
    };
    exports.parseStringPromise = function(str, a) {
        var options, parser;
        if (typeof a === "object") options = a;
        parser = new exports.Parser(options);
        return parser.parseStringPromise(str);
    };
}).call(this);

});
parcelRegister("2l4LK", function(module, exports) {

var $1bZtd = parcelRequire("1bZtd");
var $1b413dffeafcec26$require$Buffer = $1bZtd.Buffer;


(function(sax) {
    sax.parser = function(strict, opt) {
        return new SAXParser(strict, opt);
    };
    sax.SAXParser = SAXParser;
    sax.SAXStream = SAXStream;
    sax.createStream = createStream;
    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
    // since that's the earliest that a buffer overrun could occur.  This way, checks are
    // as rare as required, but as often as necessary to ensure never crossing this bound.
    // Furthermore, buffers are only tested at most once per write(), so passing a very
    // large string into write() might have undesirable effects, but this is manageable by
    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
    // edge case, result in creating at most one complete copy of the string passed in.
    // Set to Infinity to have unlimited buffers.
    sax.MAX_BUFFER_LENGTH = 65536;
    var buffers = [
        "comment",
        "sgmlDecl",
        "textNode",
        "tagName",
        "doctype",
        "procInstName",
        "procInstBody",
        "entity",
        "attribName",
        "attribValue",
        "cdata",
        "script"
    ];
    sax.EVENTS = [
        "text",
        "processinginstruction",
        "sgmldeclaration",
        "doctype",
        "comment",
        "opentagstart",
        "attribute",
        "opentag",
        "closetag",
        "opencdata",
        "cdata",
        "closecdata",
        "error",
        "end",
        "ready",
        "script",
        "opennamespace",
        "closenamespace"
    ];
    function SAXParser(strict, opt) {
        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
        var parser = this;
        clearBuffers(parser);
        parser.q = parser.c = "";
        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
        parser.opt = opt || {};
        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
        parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
        parser.tags = [];
        parser.closed = parser.closedRoot = parser.sawRoot = false;
        parser.tag = parser.error = null;
        parser.strict = !!strict;
        parser.noscript = !!(strict || parser.opt.noscript);
        parser.state = S.BEGIN;
        parser.strictEntities = parser.opt.strictEntities;
        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
        parser.attribList = [];
        // namespaces form a prototype chain.
        // it always points at the current tag,
        // which protos to its parent tag.
        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
        // mostly just for error reporting
        parser.trackPosition = parser.opt.position !== false;
        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
        emit(parser, "onready");
    }
    if (!Object.create) Object.create = function(o) {
        function F() {}
        F.prototype = o;
        var newf = new F();
        return newf;
    };
    if (!Object.keys) Object.keys = function(o) {
        var a = [];
        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
        return a;
    };
    function checkBufferLength(parser) {
        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
        var maxActual = 0;
        for(var i = 0, l = buffers.length; i < l; i++){
            var len = parser[buffers[i]].length;
            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
            // we can get here under normal conditions.
            // Avoid issues by emitting the text node now,
            // so at least it won't get any bigger.
            switch(buffers[i]){
                case "textNode":
                    closeText(parser);
                    break;
                case "cdata":
                    emitNode(parser, "oncdata", parser.cdata);
                    parser.cdata = "";
                    break;
                case "script":
                    emitNode(parser, "onscript", parser.script);
                    parser.script = "";
                    break;
                default:
                    error(parser, "Max buffer length exceeded: " + buffers[i]);
            }
            maxActual = Math.max(maxActual, len);
        }
        // schedule the next check for the earliest possible buffer overrun.
        var m = sax.MAX_BUFFER_LENGTH - maxActual;
        parser.bufferCheckPosition = m + parser.position;
    }
    function clearBuffers(parser) {
        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
    }
    function flushBuffers(parser) {
        closeText(parser);
        if (parser.cdata !== "") {
            emitNode(parser, "oncdata", parser.cdata);
            parser.cdata = "";
        }
        if (parser.script !== "") {
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
    }
    SAXParser.prototype = {
        end: function() {
            end(this);
        },
        write: write,
        resume: function() {
            this.error = null;
            return this;
        },
        close: function() {
            return this.write(null);
        },
        flush: function() {
            flushBuffers(this);
        }
    };
    var Stream;
    try {
        Stream = (parcelRequire("gAg9R")).Stream;
    } catch (ex) {
        Stream = function() {};
    }
    if (!Stream) Stream = function() {};
    var streamWraps = sax.EVENTS.filter(function(ev) {
        return ev !== "error" && ev !== "end";
    });
    function createStream(strict, opt) {
        return new SAXStream(strict, opt);
    }
    function SAXStream(strict, opt) {
        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
        Stream.apply(this);
        this._parser = new SAXParser(strict, opt);
        this.writable = true;
        this.readable = true;
        var me = this;
        this._parser.onend = function() {
            me.emit("end");
        };
        this._parser.onerror = function(er) {
            me.emit("error", er);
            // if didn't throw, then means error was handled.
            // go ahead and clear error, so we can write again.
            me._parser.error = null;
        };
        this._decoder = null;
        streamWraps.forEach(function(ev) {
            Object.defineProperty(me, "on" + ev, {
                get: function() {
                    return me._parser["on" + ev];
                },
                set: function(h) {
                    if (!h) {
                        me.removeAllListeners(ev);
                        me._parser["on" + ev] = h;
                        return h;
                    }
                    me.on(ev, h);
                },
                enumerable: true,
                configurable: false
            });
        });
    }
    SAXStream.prototype = Object.create(Stream.prototype, {
        constructor: {
            value: SAXStream
        }
    });
    SAXStream.prototype.write = function(data) {
        if (typeof $1b413dffeafcec26$require$Buffer === "function" && typeof $1b413dffeafcec26$require$Buffer.isBuffer === "function" && $1b413dffeafcec26$require$Buffer.isBuffer(data)) {
            if (!this._decoder) {
                var SD = (parcelRequire("1ybPW")).StringDecoder;
                this._decoder = new SD("utf8");
            }
            data = this._decoder.write(data);
        }
        this._parser.write(data.toString());
        this.emit("data", data);
        return true;
    };
    SAXStream.prototype.end = function(chunk) {
        if (chunk && chunk.length) this.write(chunk);
        this._parser.end();
        return true;
    };
    SAXStream.prototype.on = function(ev, handler) {
        var me = this;
        if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
            var args = arguments.length === 1 ? [
                arguments[0]
            ] : Array.apply(null, arguments);
            args.splice(0, 0, ev);
            me.emit.apply(me, args);
        };
        return Stream.prototype.on.call(me, ev, handler);
    };
    // this really needs to be replaced with character classes.
    // XML allows all manner of ridiculous numbers and digits.
    var CDATA = "[CDATA[";
    var DOCTYPE = "DOCTYPE";
    var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
    var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
    var rootNS = {
        xml: XML_NAMESPACE,
        xmlns: XMLNS_NAMESPACE
    };
    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
    // This implementation works on strings, a single character at a time
    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
    // without a significant breaking change to either this  parser, or the
    // JavaScript language.  Implementation of an emoji-capable xml parser
    // is left as an exercise for the reader.
    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function isWhitespace(c) {
        return c === " " || c === "\n" || c === "\r" || c === "	";
    }
    function isQuote(c) {
        return c === '"' || c === "'";
    }
    function isAttribEnd(c) {
        return c === ">" || isWhitespace(c);
    }
    function isMatch(regex, c) {
        return regex.test(c);
    }
    function notMatch(regex, c) {
        return !isMatch(regex, c);
    }
    var S = 0;
    sax.STATE = {
        BEGIN: S++,
        BEGIN_WHITESPACE: S++,
        TEXT: S++,
        TEXT_ENTITY: S++,
        OPEN_WAKA: S++,
        SGML_DECL: S++,
        SGML_DECL_QUOTED: S++,
        DOCTYPE: S++,
        DOCTYPE_QUOTED: S++,
        DOCTYPE_DTD: S++,
        DOCTYPE_DTD_QUOTED: S++,
        COMMENT_STARTING: S++,
        COMMENT: S++,
        COMMENT_ENDING: S++,
        COMMENT_ENDED: S++,
        CDATA: S++,
        CDATA_ENDING: S++,
        CDATA_ENDING_2: S++,
        PROC_INST: S++,
        PROC_INST_BODY: S++,
        PROC_INST_ENDING: S++,
        OPEN_TAG: S++,
        OPEN_TAG_SLASH: S++,
        ATTRIB: S++,
        ATTRIB_NAME: S++,
        ATTRIB_NAME_SAW_WHITE: S++,
        ATTRIB_VALUE: S++,
        ATTRIB_VALUE_QUOTED: S++,
        ATTRIB_VALUE_CLOSED: S++,
        ATTRIB_VALUE_UNQUOTED: S++,
        ATTRIB_VALUE_ENTITY_Q: S++,
        ATTRIB_VALUE_ENTITY_U: S++,
        CLOSE_TAG: S++,
        CLOSE_TAG_SAW_WHITE: S++,
        SCRIPT: S++,
        SCRIPT_ENDING: S++ // <script> ... <
    };
    sax.XML_ENTITIES = {
        "amp": "&",
        "gt": ">",
        "lt": "<",
        "quot": '"',
        "apos": "'"
    };
    sax.ENTITIES = {
        "amp": "&",
        "gt": ">",
        "lt": "<",
        "quot": '"',
        "apos": "'",
        "AElig": 198,
        "Aacute": 193,
        "Acirc": 194,
        "Agrave": 192,
        "Aring": 197,
        "Atilde": 195,
        "Auml": 196,
        "Ccedil": 199,
        "ETH": 208,
        "Eacute": 201,
        "Ecirc": 202,
        "Egrave": 200,
        "Euml": 203,
        "Iacute": 205,
        "Icirc": 206,
        "Igrave": 204,
        "Iuml": 207,
        "Ntilde": 209,
        "Oacute": 211,
        "Ocirc": 212,
        "Ograve": 210,
        "Oslash": 216,
        "Otilde": 213,
        "Ouml": 214,
        "THORN": 222,
        "Uacute": 218,
        "Ucirc": 219,
        "Ugrave": 217,
        "Uuml": 220,
        "Yacute": 221,
        "aacute": 225,
        "acirc": 226,
        "aelig": 230,
        "agrave": 224,
        "aring": 229,
        "atilde": 227,
        "auml": 228,
        "ccedil": 231,
        "eacute": 233,
        "ecirc": 234,
        "egrave": 232,
        "eth": 240,
        "euml": 235,
        "iacute": 237,
        "icirc": 238,
        "igrave": 236,
        "iuml": 239,
        "ntilde": 241,
        "oacute": 243,
        "ocirc": 244,
        "ograve": 242,
        "oslash": 248,
        "otilde": 245,
        "ouml": 246,
        "szlig": 223,
        "thorn": 254,
        "uacute": 250,
        "ucirc": 251,
        "ugrave": 249,
        "uuml": 252,
        "yacute": 253,
        "yuml": 255,
        "copy": 169,
        "reg": 174,
        "nbsp": 160,
        "iexcl": 161,
        "cent": 162,
        "pound": 163,
        "curren": 164,
        "yen": 165,
        "brvbar": 166,
        "sect": 167,
        "uml": 168,
        "ordf": 170,
        "laquo": 171,
        "not": 172,
        "shy": 173,
        "macr": 175,
        "deg": 176,
        "plusmn": 177,
        "sup1": 185,
        "sup2": 178,
        "sup3": 179,
        "acute": 180,
        "micro": 181,
        "para": 182,
        "middot": 183,
        "cedil": 184,
        "ordm": 186,
        "raquo": 187,
        "frac14": 188,
        "frac12": 189,
        "frac34": 190,
        "iquest": 191,
        "times": 215,
        "divide": 247,
        "OElig": 338,
        "oelig": 339,
        "Scaron": 352,
        "scaron": 353,
        "Yuml": 376,
        "fnof": 402,
        "circ": 710,
        "tilde": 732,
        "Alpha": 913,
        "Beta": 914,
        "Gamma": 915,
        "Delta": 916,
        "Epsilon": 917,
        "Zeta": 918,
        "Eta": 919,
        "Theta": 920,
        "Iota": 921,
        "Kappa": 922,
        "Lambda": 923,
        "Mu": 924,
        "Nu": 925,
        "Xi": 926,
        "Omicron": 927,
        "Pi": 928,
        "Rho": 929,
        "Sigma": 931,
        "Tau": 932,
        "Upsilon": 933,
        "Phi": 934,
        "Chi": 935,
        "Psi": 936,
        "Omega": 937,
        "alpha": 945,
        "beta": 946,
        "gamma": 947,
        "delta": 948,
        "epsilon": 949,
        "zeta": 950,
        "eta": 951,
        "theta": 952,
        "iota": 953,
        "kappa": 954,
        "lambda": 955,
        "mu": 956,
        "nu": 957,
        "xi": 958,
        "omicron": 959,
        "pi": 960,
        "rho": 961,
        "sigmaf": 962,
        "sigma": 963,
        "tau": 964,
        "upsilon": 965,
        "phi": 966,
        "chi": 967,
        "psi": 968,
        "omega": 969,
        "thetasym": 977,
        "upsih": 978,
        "piv": 982,
        "ensp": 8194,
        "emsp": 8195,
        "thinsp": 8201,
        "zwnj": 8204,
        "zwj": 8205,
        "lrm": 8206,
        "rlm": 8207,
        "ndash": 8211,
        "mdash": 8212,
        "lsquo": 8216,
        "rsquo": 8217,
        "sbquo": 8218,
        "ldquo": 8220,
        "rdquo": 8221,
        "bdquo": 8222,
        "dagger": 8224,
        "Dagger": 8225,
        "bull": 8226,
        "hellip": 8230,
        "permil": 8240,
        "prime": 8242,
        "Prime": 8243,
        "lsaquo": 8249,
        "rsaquo": 8250,
        "oline": 8254,
        "frasl": 8260,
        "euro": 8364,
        "image": 8465,
        "weierp": 8472,
        "real": 8476,
        "trade": 8482,
        "alefsym": 8501,
        "larr": 8592,
        "uarr": 8593,
        "rarr": 8594,
        "darr": 8595,
        "harr": 8596,
        "crarr": 8629,
        "lArr": 8656,
        "uArr": 8657,
        "rArr": 8658,
        "dArr": 8659,
        "hArr": 8660,
        "forall": 8704,
        "part": 8706,
        "exist": 8707,
        "empty": 8709,
        "nabla": 8711,
        "isin": 8712,
        "notin": 8713,
        "ni": 8715,
        "prod": 8719,
        "sum": 8721,
        "minus": 8722,
        "lowast": 8727,
        "radic": 8730,
        "prop": 8733,
        "infin": 8734,
        "ang": 8736,
        "and": 8743,
        "or": 8744,
        "cap": 8745,
        "cup": 8746,
        "int": 8747,
        "there4": 8756,
        "sim": 8764,
        "cong": 8773,
        "asymp": 8776,
        "ne": 8800,
        "equiv": 8801,
        "le": 8804,
        "ge": 8805,
        "sub": 8834,
        "sup": 8835,
        "nsub": 8836,
        "sube": 8838,
        "supe": 8839,
        "oplus": 8853,
        "otimes": 8855,
        "perp": 8869,
        "sdot": 8901,
        "lceil": 8968,
        "rceil": 8969,
        "lfloor": 8970,
        "rfloor": 8971,
        "lang": 9001,
        "rang": 9002,
        "loz": 9674,
        "spades": 9824,
        "clubs": 9827,
        "hearts": 9829,
        "diams": 9830
    };
    Object.keys(sax.ENTITIES).forEach(function(key) {
        var e = sax.ENTITIES[key];
        var s = typeof e === "number" ? String.fromCharCode(e) : e;
        sax.ENTITIES[key] = s;
    });
    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
    // shorthand
    S = sax.STATE;
    function emit(parser, event, data) {
        parser[event] && parser[event](data);
    }
    function emitNode(parser, nodeType, data) {
        if (parser.textNode) closeText(parser);
        emit(parser, nodeType, data);
    }
    function closeText(parser) {
        parser.textNode = textopts(parser.opt, parser.textNode);
        if (parser.textNode) emit(parser, "ontext", parser.textNode);
        parser.textNode = "";
    }
    function textopts(opt, text) {
        if (opt.trim) text = text.trim();
        if (opt.normalize) text = text.replace(/\s+/g, " ");
        return text;
    }
    function error(parser, er) {
        closeText(parser);
        if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
        er = new Error(er);
        parser.error = er;
        emit(parser, "onerror", er);
        return parser;
    }
    function end(parser) {
        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
        closeText(parser);
        parser.c = "";
        parser.closed = true;
        emit(parser, "onend");
        SAXParser.call(parser, parser.strict, parser.opt);
        return parser;
    }
    function strictFail(parser, message) {
        if (typeof parser !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
        if (parser.strict) error(parser, message);
    }
    function newTag(parser) {
        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
        var parent = parser.tags[parser.tags.length - 1] || parser;
        var tag = parser.tag = {
            name: parser.tagName,
            attributes: {}
        };
        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
        if (parser.opt.xmlns) tag.ns = parent.ns;
        parser.attribList.length = 0;
        emitNode(parser, "onopentagstart", tag);
    }
    function qname(name, attribute) {
        var i = name.indexOf(":");
        var qualName = i < 0 ? [
            "",
            name
        ] : name.split(":");
        var prefix = qualName[0];
        var local = qualName[1];
        // <x "xmlns"="http://foo">
        if (attribute && name === "xmlns") {
            prefix = "xmlns";
            local = "";
        }
        return {
            prefix: prefix,
            local: local
        };
    }
    function attrib(parser) {
        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
            parser.attribName = parser.attribValue = "";
            return;
        }
        if (parser.opt.xmlns) {
            var qn = qname(parser.attribName, true);
            var prefix = qn.prefix;
            var local = qn.local;
            if (prefix === "xmlns") {
                // namespace binding attribute. push the binding into scope
                if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else {
                    var tag = parser.tag;
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                    tag.ns[local] = parser.attribValue;
                }
            }
            // defer onattribute events until all attributes have been seen
            // so any new bindings can take effect. preserve attribute order
            // so deferred events can be emitted in document order
            parser.attribList.push([
                parser.attribName,
                parser.attribValue
            ]);
        } else {
            // in non-xmlns mode, we can emit the event right away
            parser.tag.attributes[parser.attribName] = parser.attribValue;
            emitNode(parser, "onattribute", {
                name: parser.attribName,
                value: parser.attribValue
            });
        }
        parser.attribName = parser.attribValue = "";
    }
    function openTag(parser, selfClosing) {
        if (parser.opt.xmlns) {
            // emit namespace binding events
            var tag = parser.tag;
            // add namespace info to tag
            var qn = qname(parser.tagName);
            tag.prefix = qn.prefix;
            tag.local = qn.local;
            tag.uri = tag.ns[qn.prefix] || "";
            if (tag.prefix && !tag.uri) {
                strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                tag.uri = qn.prefix;
            }
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                emitNode(parser, "onopennamespace", {
                    prefix: p,
                    uri: tag.ns[p]
                });
            });
            // handle deferred onattribute events
            // Note: do not apply default ns to attributes:
            //   http://www.w3.org/TR/REC-xml-names/#defaulting
            for(var i = 0, l = parser.attribList.length; i < l; i++){
                var nv = parser.attribList[i];
                var name = nv[0];
                var value = nv[1];
                var qualName = qname(name, true);
                var prefix = qualName.prefix;
                var local = qualName.local;
                var uri = prefix === "" ? "" : tag.ns[prefix] || "";
                var a = {
                    name: name,
                    value: value,
                    prefix: prefix,
                    local: local,
                    uri: uri
                };
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (prefix && prefix !== "xmlns" && !uri) {
                    strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                    a.uri = prefix;
                }
                parser.tag.attributes[name] = a;
                emitNode(parser, "onattribute", a);
            }
            parser.attribList.length = 0;
        }
        parser.tag.isSelfClosing = !!selfClosing;
        // process the tag
        parser.sawRoot = true;
        parser.tags.push(parser.tag);
        emitNode(parser, "onopentag", parser.tag);
        if (!selfClosing) {
            // special case for <script> in non-strict mode.
            if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
            else parser.state = S.TEXT;
            parser.tag = null;
            parser.tagName = "";
        }
        parser.attribName = parser.attribValue = "";
        parser.attribList.length = 0;
    }
    function closeTag(parser) {
        if (!parser.tagName) {
            strictFail(parser, "Weird empty close tag.");
            parser.textNode += "</>";
            parser.state = S.TEXT;
            return;
        }
        if (parser.script) {
            if (parser.tagName !== "script") {
                parser.script += "</" + parser.tagName + ">";
                parser.tagName = "";
                parser.state = S.SCRIPT;
                return;
            }
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
        // first make sure that the closing tag actually exists.
        // <a><b></c></b></a> will close everything, otherwise.
        var t = parser.tags.length;
        var tagName = parser.tagName;
        if (!parser.strict) tagName = tagName[parser.looseCase]();
        var closeTo = tagName;
        while(t--){
            var close = parser.tags[t];
            if (close.name !== closeTo) // fail the first time in strict mode
            strictFail(parser, "Unexpected close tag");
            else break;
        }
        // didn't find it.  we already failed for strict, so just abort.
        if (t < 0) {
            strictFail(parser, "Unmatched closing tag: " + parser.tagName);
            parser.textNode += "</" + parser.tagName + ">";
            parser.state = S.TEXT;
            return;
        }
        parser.tagName = tagName;
        var s = parser.tags.length;
        while(s-- > t){
            var tag = parser.tag = parser.tags.pop();
            parser.tagName = parser.tag.name;
            emitNode(parser, "onclosetag", parser.tagName);
            var x = {};
            for(var i in tag.ns)x[i] = tag.ns[i];
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
            Object.keys(tag.ns).forEach(function(p) {
                var n = tag.ns[p];
                emitNode(parser, "onclosenamespace", {
                    prefix: p,
                    uri: n
                });
            });
        }
        if (t === 0) parser.closedRoot = true;
        parser.tagName = parser.attribValue = parser.attribName = "";
        parser.attribList.length = 0;
        parser.state = S.TEXT;
    }
    function parseEntity(parser) {
        var entity = parser.entity;
        var entityLC = entity.toLowerCase();
        var num;
        var numStr = "";
        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
        entity = entityLC;
        if (entity.charAt(0) === "#") {
            if (entity.charAt(1) === "x") {
                entity = entity.slice(2);
                num = parseInt(entity, 16);
                numStr = num.toString(16);
            } else {
                entity = entity.slice(1);
                num = parseInt(entity, 10);
                numStr = num.toString(10);
            }
        }
        entity = entity.replace(/^0+/, "");
        if (isNaN(num) || numStr.toLowerCase() !== entity) {
            strictFail(parser, "Invalid character entity");
            return "&" + parser.entity + ";";
        }
        return String.fromCodePoint(num);
    }
    function beginWhiteSpace(parser, c) {
        if (c === "<") {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
        } else if (!isWhitespace(c)) {
            // have to process this as a text node.
            // weird, but happens.
            strictFail(parser, "Non-whitespace before first tag.");
            parser.textNode = c;
            parser.state = S.TEXT;
        }
    }
    function charAt(chunk, i) {
        var result = "";
        if (i < chunk.length) result = chunk.charAt(i);
        return result;
    }
    function write(chunk) {
        var parser = this;
        if (this.error) throw this.error;
        if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
        if (chunk === null) return end(parser);
        if (typeof chunk === "object") chunk = chunk.toString();
        var i = 0;
        var c = "";
        while(true){
            c = charAt(chunk, i++);
            parser.c = c;
            if (!c) break;
            if (parser.trackPosition) {
                parser.position++;
                if (c === "\n") {
                    parser.line++;
                    parser.column = 0;
                } else parser.column++;
            }
            switch(parser.state){
                case S.BEGIN:
                    parser.state = S.BEGIN_WHITESPACE;
                    if (c === "\uFEFF") continue;
                    beginWhiteSpace(parser, c);
                    continue;
                case S.BEGIN_WHITESPACE:
                    beginWhiteSpace(parser, c);
                    continue;
                case S.TEXT:
                    if (parser.sawRoot && !parser.closedRoot) {
                        var starti = i - 1;
                        while(c && c !== "<" && c !== "&"){
                            c = charAt(chunk, i++);
                            if (c && parser.trackPosition) {
                                parser.position++;
                                if (c === "\n") {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                        }
                        parser.textNode += chunk.substring(starti, i - 1);
                    }
                    if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                        parser.state = S.OPEN_WAKA;
                        parser.startTagPosition = parser.position;
                    } else {
                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                        if (c === "&") parser.state = S.TEXT_ENTITY;
                        else parser.textNode += c;
                    }
                    continue;
                case S.SCRIPT:
                    // only non-strict
                    if (c === "<") parser.state = S.SCRIPT_ENDING;
                    else parser.script += c;
                    continue;
                case S.SCRIPT_ENDING:
                    if (c === "/") parser.state = S.CLOSE_TAG;
                    else {
                        parser.script += "<" + c;
                        parser.state = S.SCRIPT;
                    }
                    continue;
                case S.OPEN_WAKA:
                    // either a /, ?, !, or text is coming next.
                    if (c === "!") {
                        parser.state = S.SGML_DECL;
                        parser.sgmlDecl = "";
                    } else if (isWhitespace(c)) ;
                    else if (isMatch(nameStart, c)) {
                        parser.state = S.OPEN_TAG;
                        parser.tagName = c;
                    } else if (c === "/") {
                        parser.state = S.CLOSE_TAG;
                        parser.tagName = "";
                    } else if (c === "?") {
                        parser.state = S.PROC_INST;
                        parser.procInstName = parser.procInstBody = "";
                    } else {
                        strictFail(parser, "Unencoded <");
                        // if there was some whitespace, then add that in.
                        if (parser.startTagPosition + 1 < parser.position) {
                            var pad = parser.position - parser.startTagPosition;
                            c = new Array(pad).join(" ") + c;
                        }
                        parser.textNode += "<" + c;
                        parser.state = S.TEXT;
                    }
                    continue;
                case S.SGML_DECL:
                    if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                        emitNode(parser, "onopencdata");
                        parser.state = S.CDATA;
                        parser.sgmlDecl = "";
                        parser.cdata = "";
                    } else if (parser.sgmlDecl + c === "--") {
                        parser.state = S.COMMENT;
                        parser.comment = "";
                        parser.sgmlDecl = "";
                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                        parser.state = S.DOCTYPE;
                        if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                        parser.doctype = "";
                        parser.sgmlDecl = "";
                    } else if (c === ">") {
                        emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                        parser.sgmlDecl = "";
                        parser.state = S.TEXT;
                    } else if (isQuote(c)) {
                        parser.state = S.SGML_DECL_QUOTED;
                        parser.sgmlDecl += c;
                    } else parser.sgmlDecl += c;
                    continue;
                case S.SGML_DECL_QUOTED:
                    if (c === parser.q) {
                        parser.state = S.SGML_DECL;
                        parser.q = "";
                    }
                    parser.sgmlDecl += c;
                    continue;
                case S.DOCTYPE:
                    if (c === ">") {
                        parser.state = S.TEXT;
                        emitNode(parser, "ondoctype", parser.doctype);
                        parser.doctype = true // just remember that we saw it.
                        ;
                    } else {
                        parser.doctype += c;
                        if (c === "[") parser.state = S.DOCTYPE_DTD;
                        else if (isQuote(c)) {
                            parser.state = S.DOCTYPE_QUOTED;
                            parser.q = c;
                        }
                    }
                    continue;
                case S.DOCTYPE_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.q = "";
                        parser.state = S.DOCTYPE;
                    }
                    continue;
                case S.DOCTYPE_DTD:
                    parser.doctype += c;
                    if (c === "]") parser.state = S.DOCTYPE;
                    else if (isQuote(c)) {
                        parser.state = S.DOCTYPE_DTD_QUOTED;
                        parser.q = c;
                    }
                    continue;
                case S.DOCTYPE_DTD_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.state = S.DOCTYPE_DTD;
                        parser.q = "";
                    }
                    continue;
                case S.COMMENT:
                    if (c === "-") parser.state = S.COMMENT_ENDING;
                    else parser.comment += c;
                    continue;
                case S.COMMENT_ENDING:
                    if (c === "-") {
                        parser.state = S.COMMENT_ENDED;
                        parser.comment = textopts(parser.opt, parser.comment);
                        if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                        parser.comment = "";
                    } else {
                        parser.comment += "-" + c;
                        parser.state = S.COMMENT;
                    }
                    continue;
                case S.COMMENT_ENDED:
                    if (c !== ">") {
                        strictFail(parser, "Malformed comment");
                        // allow <!-- blah -- bloo --> in non-strict mode,
                        // which is a comment of " blah -- bloo "
                        parser.comment += "--" + c;
                        parser.state = S.COMMENT;
                    } else parser.state = S.TEXT;
                    continue;
                case S.CDATA:
                    if (c === "]") parser.state = S.CDATA_ENDING;
                    else parser.cdata += c;
                    continue;
                case S.CDATA_ENDING:
                    if (c === "]") parser.state = S.CDATA_ENDING_2;
                    else {
                        parser.cdata += "]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.CDATA_ENDING_2:
                    if (c === ">") {
                        if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                        emitNode(parser, "onclosecdata");
                        parser.cdata = "";
                        parser.state = S.TEXT;
                    } else if (c === "]") parser.cdata += "]";
                    else {
                        parser.cdata += "]]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.PROC_INST:
                    if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                    else parser.procInstName += c;
                    continue;
                case S.PROC_INST_BODY:
                    if (!parser.procInstBody && isWhitespace(c)) continue;
                    else if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else parser.procInstBody += c;
                    continue;
                case S.PROC_INST_ENDING:
                    if (c === ">") {
                        emitNode(parser, "onprocessinginstruction", {
                            name: parser.procInstName,
                            body: parser.procInstBody
                        });
                        parser.procInstName = parser.procInstBody = "";
                        parser.state = S.TEXT;
                    } else {
                        parser.procInstBody += "?" + c;
                        parser.state = S.PROC_INST_BODY;
                    }
                    continue;
                case S.OPEN_TAG:
                    if (isMatch(nameBody, c)) parser.tagName += c;
                    else {
                        newTag(parser);
                        if (c === ">") openTag(parser);
                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                        else {
                            if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.OPEN_TAG_SLASH:
                    if (c === ">") {
                        openTag(parser, true);
                        closeTag(parser);
                    } else {
                        strictFail(parser, "Forward-slash in opening tag not followed by >");
                        parser.state = S.ATTRIB;
                    }
                    continue;
                case S.ATTRIB:
                    // haven't read the attribute name yet.
                    if (isWhitespace(c)) continue;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (c === ">") {
                        strictFail(parser, "Attribute without value");
                        parser.attribValue = parser.attribName;
                        attrib(parser);
                        openTag(parser);
                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                    else if (isMatch(nameBody, c)) parser.attribName += c;
                    else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME_SAW_WHITE:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (isWhitespace(c)) continue;
                    else {
                        strictFail(parser, "Attribute without value");
                        parser.tag.attributes[parser.attribName] = "";
                        parser.attribValue = "";
                        emitNode(parser, "onattribute", {
                            name: parser.attribName,
                            value: ""
                        });
                        parser.attribName = "";
                        if (c === ">") openTag(parser);
                        else if (isMatch(nameStart, c)) {
                            parser.attribName = c;
                            parser.state = S.ATTRIB_NAME;
                        } else {
                            strictFail(parser, "Invalid attribute name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.ATTRIB_VALUE:
                    if (isWhitespace(c)) continue;
                    else if (isQuote(c)) {
                        parser.q = c;
                        parser.state = S.ATTRIB_VALUE_QUOTED;
                    } else {
                        strictFail(parser, "Unquoted attribute value");
                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                        parser.attribValue = c;
                    }
                    continue;
                case S.ATTRIB_VALUE_QUOTED:
                    if (c !== parser.q) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    parser.q = "";
                    parser.state = S.ATTRIB_VALUE_CLOSED;
                    continue;
                case S.ATTRIB_VALUE_CLOSED:
                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        strictFail(parser, "No whitespace between attributes");
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_VALUE_UNQUOTED:
                    if (!isAttribEnd(c)) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    if (c === ">") openTag(parser);
                    else parser.state = S.ATTRIB;
                    continue;
                case S.CLOSE_TAG:
                    if (!parser.tagName) {
                        if (isWhitespace(c)) continue;
                        else if (notMatch(nameStart, c)) {
                            if (parser.script) {
                                parser.script += "</" + c;
                                parser.state = S.SCRIPT;
                            } else strictFail(parser, "Invalid tagname in closing tag.");
                        } else parser.tagName = c;
                    } else if (c === ">") closeTag(parser);
                    else if (isMatch(nameBody, c)) parser.tagName += c;
                    else if (parser.script) {
                        parser.script += "</" + parser.tagName;
                        parser.tagName = "";
                        parser.state = S.SCRIPT;
                    } else {
                        if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                    }
                    continue;
                case S.CLOSE_TAG_SAW_WHITE:
                    if (isWhitespace(c)) continue;
                    if (c === ">") closeTag(parser);
                    else strictFail(parser, "Invalid characters in closing tag");
                    continue;
                case S.TEXT_ENTITY:
                case S.ATTRIB_VALUE_ENTITY_Q:
                case S.ATTRIB_VALUE_ENTITY_U:
                    var returnState;
                    var buffer;
                    switch(parser.state){
                        case S.TEXT_ENTITY:
                            returnState = S.TEXT;
                            buffer = "textNode";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_Q:
                            returnState = S.ATTRIB_VALUE_QUOTED;
                            buffer = "attribValue";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_U:
                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                            buffer = "attribValue";
                            break;
                    }
                    if (c === ";") {
                        if (parser.opt.unparsedEntities) {
                            var parsedEntity = parseEntity(parser);
                            parser.entity = "";
                            parser.state = returnState;
                            parser.write(parsedEntity);
                        } else {
                            parser[buffer] += parseEntity(parser);
                            parser.entity = "";
                            parser.state = returnState;
                        }
                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                    else {
                        strictFail(parser, "Invalid character in entity name");
                        parser[buffer] += "&" + parser.entity + c;
                        parser.entity = "";
                        parser.state = returnState;
                    }
                    continue;
                default:
                    throw new Error(parser, "Unknown state: " + parser.state);
            }
        } // while
        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
        return parser;
    }
    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        var fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return "";
            var result = "";
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10FFFF || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) throw RangeError("Invalid code point: " + codePoint);
                if (codePoint <= 0xFFFF) codeUnits.push(codePoint);
                else {
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xD800;
                    lowSurrogate = codePoint % 0x400 + 0xDC00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
            value: fromCodePoint,
            configurable: true,
            writable: true
        });
        else String.fromCodePoint = fromCodePoint;
    })();
})(module.exports);

});
parcelRegister("1bZtd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $0de6803f9295a957$export$a143d493d941bafc; }, function (v) { return $0de6803f9295a957$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $0de6803f9295a957$export$e4cf37d7f6fb9e0a; }, function (v) { return $0de6803f9295a957$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $0de6803f9295a957$export$f99ded8fe4b79145; }, function (v) { return $0de6803f9295a957$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $0de6803f9295a957$export$599f31c3813fae4d; }, function (v) { return $0de6803f9295a957$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0de6803f9295a957$export$a143d493d941bafc;
var $0de6803f9295a957$export$e4cf37d7f6fb9e0a;
var $0de6803f9295a957$export$f99ded8fe4b79145;
var $0de6803f9295a957$export$599f31c3813fae4d;
"use strict";

var $1BiLz = parcelRequire("1BiLz");

var $iug7o = parcelRequire("iug7o");
const $0de6803f9295a957$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0de6803f9295a957$export$a143d493d941bafc = $0de6803f9295a957$var$Buffer;
$0de6803f9295a957$export$e4cf37d7f6fb9e0a = $0de6803f9295a957$var$SlowBuffer;
$0de6803f9295a957$export$f99ded8fe4b79145 = 50;
const $0de6803f9295a957$var$K_MAX_LENGTH = 0x7fffffff;
$0de6803f9295a957$export$599f31c3813fae4d = $0de6803f9295a957$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0de6803f9295a957$var$Buffer.TYPED_ARRAY_SUPPORT = $0de6803f9295a957$var$typedArraySupport();
if (!$0de6803f9295a957$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0de6803f9295a957$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0de6803f9295a957$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0de6803f9295a957$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0de6803f9295a957$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0de6803f9295a957$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0de6803f9295a957$var$createBuffer(length) {
    if (length > $0de6803f9295a957$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0de6803f9295a957$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0de6803f9295a957$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0de6803f9295a957$var$allocUnsafe(arg);
    }
    return $0de6803f9295a957$var$from(arg, encodingOrOffset, length);
}
$0de6803f9295a957$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0de6803f9295a957$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0de6803f9295a957$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0de6803f9295a957$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0de6803f9295a957$var$isInstance(value, ArrayBuffer) || value && $0de6803f9295a957$var$isInstance(value.buffer, ArrayBuffer)) return $0de6803f9295a957$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0de6803f9295a957$var$isInstance(value, SharedArrayBuffer) || value && $0de6803f9295a957$var$isInstance(value.buffer, SharedArrayBuffer))) return $0de6803f9295a957$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0de6803f9295a957$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0de6803f9295a957$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0de6803f9295a957$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0de6803f9295a957$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0de6803f9295a957$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0de6803f9295a957$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0de6803f9295a957$var$Buffer, Uint8Array);
function $0de6803f9295a957$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0de6803f9295a957$var$alloc(size, fill, encoding) {
    $0de6803f9295a957$var$assertSize(size);
    if (size <= 0) return $0de6803f9295a957$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0de6803f9295a957$var$createBuffer(size).fill(fill, encoding) : $0de6803f9295a957$var$createBuffer(size).fill(fill);
    return $0de6803f9295a957$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0de6803f9295a957$var$Buffer.alloc = function(size, fill, encoding) {
    return $0de6803f9295a957$var$alloc(size, fill, encoding);
};
function $0de6803f9295a957$var$allocUnsafe(size) {
    $0de6803f9295a957$var$assertSize(size);
    return $0de6803f9295a957$var$createBuffer(size < 0 ? 0 : $0de6803f9295a957$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0de6803f9295a957$var$Buffer.allocUnsafe = function(size) {
    return $0de6803f9295a957$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0de6803f9295a957$var$Buffer.allocUnsafeSlow = function(size) {
    return $0de6803f9295a957$var$allocUnsafe(size);
};
function $0de6803f9295a957$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0de6803f9295a957$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0de6803f9295a957$var$byteLength(string, encoding) | 0;
    let buf = $0de6803f9295a957$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0de6803f9295a957$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0de6803f9295a957$var$checked(array.length) | 0;
    const buf = $0de6803f9295a957$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0de6803f9295a957$var$fromArrayView(arrayView) {
    if ($0de6803f9295a957$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0de6803f9295a957$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0de6803f9295a957$var$fromArrayLike(arrayView);
}
function $0de6803f9295a957$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0de6803f9295a957$var$Buffer.prototype);
    return buf;
}
function $0de6803f9295a957$var$fromObject(obj) {
    if ($0de6803f9295a957$var$Buffer.isBuffer(obj)) {
        const len = $0de6803f9295a957$var$checked(obj.length) | 0;
        const buf = $0de6803f9295a957$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0de6803f9295a957$var$numberIsNaN(obj.length)) return $0de6803f9295a957$var$createBuffer(0);
        return $0de6803f9295a957$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0de6803f9295a957$var$fromArrayLike(obj.data);
}
function $0de6803f9295a957$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0de6803f9295a957$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0de6803f9295a957$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0de6803f9295a957$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0de6803f9295a957$var$Buffer.alloc(+length);
}
$0de6803f9295a957$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0de6803f9295a957$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0de6803f9295a957$var$Buffer.compare = function compare(a, b) {
    if ($0de6803f9295a957$var$isInstance(a, Uint8Array)) a = $0de6803f9295a957$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0de6803f9295a957$var$isInstance(b, Uint8Array)) b = $0de6803f9295a957$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0de6803f9295a957$var$Buffer.isBuffer(a) || !$0de6803f9295a957$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0de6803f9295a957$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0de6803f9295a957$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0de6803f9295a957$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0de6803f9295a957$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0de6803f9295a957$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0de6803f9295a957$var$Buffer.isBuffer(buf)) buf = $0de6803f9295a957$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0de6803f9295a957$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0de6803f9295a957$var$byteLength(string, encoding) {
    if ($0de6803f9295a957$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0de6803f9295a957$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0de6803f9295a957$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0de6803f9295a957$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0de6803f9295a957$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0de6803f9295a957$var$Buffer.byteLength = $0de6803f9295a957$var$byteLength;
function $0de6803f9295a957$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0de6803f9295a957$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0de6803f9295a957$var$utf8Slice(this, start, end);
        case "ascii":
            return $0de6803f9295a957$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0de6803f9295a957$var$latin1Slice(this, start, end);
        case "base64":
            return $0de6803f9295a957$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0de6803f9295a957$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0de6803f9295a957$var$Buffer.prototype._isBuffer = true;
function $0de6803f9295a957$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0de6803f9295a957$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0de6803f9295a957$var$swap(this, i, i + 1);
    return this;
};
$0de6803f9295a957$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0de6803f9295a957$var$swap(this, i, i + 3);
        $0de6803f9295a957$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0de6803f9295a957$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0de6803f9295a957$var$swap(this, i, i + 7);
        $0de6803f9295a957$var$swap(this, i + 1, i + 6);
        $0de6803f9295a957$var$swap(this, i + 2, i + 5);
        $0de6803f9295a957$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0de6803f9295a957$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0de6803f9295a957$var$utf8Slice(this, 0, length);
    return $0de6803f9295a957$var$slowToString.apply(this, arguments);
};
$0de6803f9295a957$var$Buffer.prototype.toLocaleString = $0de6803f9295a957$var$Buffer.prototype.toString;
$0de6803f9295a957$var$Buffer.prototype.equals = function equals(b) {
    if (!$0de6803f9295a957$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0de6803f9295a957$var$Buffer.compare(this, b) === 0;
};
$0de6803f9295a957$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0de6803f9295a957$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0de6803f9295a957$var$customInspectSymbol) $0de6803f9295a957$var$Buffer.prototype[$0de6803f9295a957$var$customInspectSymbol] = $0de6803f9295a957$var$Buffer.prototype.inspect;
$0de6803f9295a957$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0de6803f9295a957$var$isInstance(target, Uint8Array)) target = $0de6803f9295a957$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0de6803f9295a957$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0de6803f9295a957$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0de6803f9295a957$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0de6803f9295a957$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0de6803f9295a957$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0de6803f9295a957$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0de6803f9295a957$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0de6803f9295a957$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0de6803f9295a957$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0de6803f9295a957$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0de6803f9295a957$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0de6803f9295a957$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0de6803f9295a957$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0de6803f9295a957$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0de6803f9295a957$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0de6803f9295a957$var$utf8Write(buf, string, offset, length) {
    return $0de6803f9295a957$var$blitBuffer($0de6803f9295a957$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0de6803f9295a957$var$asciiWrite(buf, string, offset, length) {
    return $0de6803f9295a957$var$blitBuffer($0de6803f9295a957$var$asciiToBytes(string), buf, offset, length);
}
function $0de6803f9295a957$var$base64Write(buf, string, offset, length) {
    return $0de6803f9295a957$var$blitBuffer($0de6803f9295a957$var$base64ToBytes(string), buf, offset, length);
}
function $0de6803f9295a957$var$ucs2Write(buf, string, offset, length) {
    return $0de6803f9295a957$var$blitBuffer($0de6803f9295a957$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0de6803f9295a957$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0de6803f9295a957$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0de6803f9295a957$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0de6803f9295a957$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0de6803f9295a957$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0de6803f9295a957$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0de6803f9295a957$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0de6803f9295a957$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $1BiLz.fromByteArray(buf);
    else return $1BiLz.fromByteArray(buf.slice(start, end));
}
function $0de6803f9295a957$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0de6803f9295a957$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0de6803f9295a957$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0de6803f9295a957$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0de6803f9295a957$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0de6803f9295a957$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0de6803f9295a957$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0de6803f9295a957$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0de6803f9295a957$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0de6803f9295a957$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0de6803f9295a957$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0de6803f9295a957$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0de6803f9295a957$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0de6803f9295a957$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0de6803f9295a957$var$Buffer.prototype.readUintLE = $0de6803f9295a957$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0de6803f9295a957$var$Buffer.prototype.readUintBE = $0de6803f9295a957$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0de6803f9295a957$var$Buffer.prototype.readUint8 = $0de6803f9295a957$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0de6803f9295a957$var$Buffer.prototype.readUint16LE = $0de6803f9295a957$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0de6803f9295a957$var$Buffer.prototype.readUint16BE = $0de6803f9295a957$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0de6803f9295a957$var$Buffer.prototype.readUint32LE = $0de6803f9295a957$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0de6803f9295a957$var$Buffer.prototype.readUint32BE = $0de6803f9295a957$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0de6803f9295a957$var$Buffer.prototype.readBigUInt64LE = $0de6803f9295a957$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0de6803f9295a957$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0de6803f9295a957$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0de6803f9295a957$var$Buffer.prototype.readBigUInt64BE = $0de6803f9295a957$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0de6803f9295a957$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0de6803f9295a957$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0de6803f9295a957$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0de6803f9295a957$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0de6803f9295a957$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0de6803f9295a957$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0de6803f9295a957$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0de6803f9295a957$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0de6803f9295a957$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0de6803f9295a957$var$Buffer.prototype.readBigInt64LE = $0de6803f9295a957$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0de6803f9295a957$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0de6803f9295a957$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0de6803f9295a957$var$Buffer.prototype.readBigInt64BE = $0de6803f9295a957$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0de6803f9295a957$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0de6803f9295a957$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0de6803f9295a957$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 4, this.length);
    return $iug7o.read(this, offset, true, 23, 4);
};
$0de6803f9295a957$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 4, this.length);
    return $iug7o.read(this, offset, false, 23, 4);
};
$0de6803f9295a957$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 8, this.length);
    return $iug7o.read(this, offset, true, 52, 8);
};
$0de6803f9295a957$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkOffset(offset, 8, this.length);
    return $iug7o.read(this, offset, false, 52, 8);
};
function $0de6803f9295a957$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0de6803f9295a957$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0de6803f9295a957$var$Buffer.prototype.writeUintLE = $0de6803f9295a957$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0de6803f9295a957$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0de6803f9295a957$var$Buffer.prototype.writeUintBE = $0de6803f9295a957$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0de6803f9295a957$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0de6803f9295a957$var$Buffer.prototype.writeUint8 = $0de6803f9295a957$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0de6803f9295a957$var$Buffer.prototype.writeUint16LE = $0de6803f9295a957$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0de6803f9295a957$var$Buffer.prototype.writeUint16BE = $0de6803f9295a957$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0de6803f9295a957$var$Buffer.prototype.writeUint32LE = $0de6803f9295a957$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0de6803f9295a957$var$Buffer.prototype.writeUint32BE = $0de6803f9295a957$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0de6803f9295a957$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0de6803f9295a957$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0de6803f9295a957$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0de6803f9295a957$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0de6803f9295a957$var$Buffer.prototype.writeBigUInt64LE = $0de6803f9295a957$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0de6803f9295a957$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0de6803f9295a957$var$Buffer.prototype.writeBigUInt64BE = $0de6803f9295a957$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0de6803f9295a957$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0de6803f9295a957$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0de6803f9295a957$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0de6803f9295a957$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0de6803f9295a957$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0de6803f9295a957$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0de6803f9295a957$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0de6803f9295a957$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0de6803f9295a957$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0de6803f9295a957$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0de6803f9295a957$var$Buffer.prototype.writeBigInt64LE = $0de6803f9295a957$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0de6803f9295a957$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0de6803f9295a957$var$Buffer.prototype.writeBigInt64BE = $0de6803f9295a957$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0de6803f9295a957$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0de6803f9295a957$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0de6803f9295a957$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $iug7o.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0de6803f9295a957$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0de6803f9295a957$var$writeFloat(this, value, offset, true, noAssert);
};
$0de6803f9295a957$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0de6803f9295a957$var$writeFloat(this, value, offset, false, noAssert);
};
function $0de6803f9295a957$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0de6803f9295a957$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $iug7o.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0de6803f9295a957$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0de6803f9295a957$var$writeDouble(this, value, offset, true, noAssert);
};
$0de6803f9295a957$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0de6803f9295a957$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0de6803f9295a957$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0de6803f9295a957$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0de6803f9295a957$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0de6803f9295a957$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0de6803f9295a957$var$Buffer.isBuffer(val) ? val : $0de6803f9295a957$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0de6803f9295a957$var$errors = {};
function $0de6803f9295a957$var$E(sym, getMessage, Base) {
    $0de6803f9295a957$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0de6803f9295a957$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0de6803f9295a957$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0de6803f9295a957$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0de6803f9295a957$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0de6803f9295a957$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0de6803f9295a957$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0de6803f9295a957$var$checkBounds(buf, offset, byteLength) {
    $0de6803f9295a957$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0de6803f9295a957$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0de6803f9295a957$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0de6803f9295a957$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0de6803f9295a957$var$checkBounds(buf, offset, byteLength);
}
function $0de6803f9295a957$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0de6803f9295a957$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0de6803f9295a957$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0de6803f9295a957$var$validateNumber(value, type);
        throw new $0de6803f9295a957$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0de6803f9295a957$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0de6803f9295a957$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0de6803f9295a957$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0de6803f9295a957$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0de6803f9295a957$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0de6803f9295a957$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0de6803f9295a957$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0de6803f9295a957$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0de6803f9295a957$var$base64ToBytes(str) {
    return $1BiLz.toByteArray($0de6803f9295a957$var$base64clean(str));
}
function $0de6803f9295a957$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0de6803f9295a957$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0de6803f9295a957$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0de6803f9295a957$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0de6803f9295a957$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0de6803f9295a957$var$BufferBigIntNotDefined : fn;
}
function $0de6803f9295a957$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("1BiLz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $12a7cdb7184bcea6$export$d622b2ad8d90c771; }, function (v) { return $12a7cdb7184bcea6$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $12a7cdb7184bcea6$export$6100ba28696e12de; }, function (v) { return $12a7cdb7184bcea6$export$6100ba28696e12de = v; });
var $12a7cdb7184bcea6$export$a48f0734ac7c2329;
var $12a7cdb7184bcea6$export$d622b2ad8d90c771;
var $12a7cdb7184bcea6$export$6100ba28696e12de;
"use strict";
$12a7cdb7184bcea6$export$a48f0734ac7c2329 = $12a7cdb7184bcea6$var$byteLength;
$12a7cdb7184bcea6$export$d622b2ad8d90c771 = $12a7cdb7184bcea6$var$toByteArray;
$12a7cdb7184bcea6$export$6100ba28696e12de = $12a7cdb7184bcea6$var$fromByteArray;
var $12a7cdb7184bcea6$var$lookup = [];
var $12a7cdb7184bcea6$var$revLookup = [];
var $12a7cdb7184bcea6$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $12a7cdb7184bcea6$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $12a7cdb7184bcea6$var$i = 0, $12a7cdb7184bcea6$var$len = $12a7cdb7184bcea6$var$code.length; $12a7cdb7184bcea6$var$i < $12a7cdb7184bcea6$var$len; ++$12a7cdb7184bcea6$var$i){
    $12a7cdb7184bcea6$var$lookup[$12a7cdb7184bcea6$var$i] = $12a7cdb7184bcea6$var$code[$12a7cdb7184bcea6$var$i];
    $12a7cdb7184bcea6$var$revLookup[$12a7cdb7184bcea6$var$code.charCodeAt($12a7cdb7184bcea6$var$i)] = $12a7cdb7184bcea6$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$12a7cdb7184bcea6$var$revLookup["-".charCodeAt(0)] = 62;
$12a7cdb7184bcea6$var$revLookup["_".charCodeAt(0)] = 63;
function $12a7cdb7184bcea6$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $12a7cdb7184bcea6$var$byteLength(b64) {
    var lens = $12a7cdb7184bcea6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $12a7cdb7184bcea6$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $12a7cdb7184bcea6$var$toByteArray(b64) {
    var tmp;
    var lens = $12a7cdb7184bcea6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $12a7cdb7184bcea6$var$Arr($12a7cdb7184bcea6$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i)] << 18 | $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i)] << 2 | $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i)] << 10 | $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $12a7cdb7184bcea6$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $12a7cdb7184bcea6$var$tripletToBase64(num) {
    return $12a7cdb7184bcea6$var$lookup[num >> 18 & 0x3F] + $12a7cdb7184bcea6$var$lookup[num >> 12 & 0x3F] + $12a7cdb7184bcea6$var$lookup[num >> 6 & 0x3F] + $12a7cdb7184bcea6$var$lookup[num & 0x3F];
}
function $12a7cdb7184bcea6$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($12a7cdb7184bcea6$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $12a7cdb7184bcea6$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($12a7cdb7184bcea6$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($12a7cdb7184bcea6$var$lookup[tmp >> 2] + $12a7cdb7184bcea6$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($12a7cdb7184bcea6$var$lookup[tmp >> 10] + $12a7cdb7184bcea6$var$lookup[tmp >> 4 & 0x3F] + $12a7cdb7184bcea6$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("iug7o", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $d757881a71482ad2$export$aafa59e2e03f2942; }, function (v) { return $d757881a71482ad2$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $d757881a71482ad2$export$68d8715fc104d294; }, function (v) { return $d757881a71482ad2$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d757881a71482ad2$export$aafa59e2e03f2942;
var $d757881a71482ad2$export$68d8715fc104d294;
$d757881a71482ad2$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d757881a71482ad2$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("gAg9R", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $031d9f2443fd20cb$var$Stream;

var $5nsYU = parcelRequire("5nsYU");
var $031d9f2443fd20cb$require$EE = $5nsYU.EventEmitter;

var $Zqiiu = parcelRequire("Zqiiu");
$Zqiiu($031d9f2443fd20cb$var$Stream, $031d9f2443fd20cb$require$EE);

$031d9f2443fd20cb$var$Stream.Readable = (parcelRequire("gR89Q"));

$031d9f2443fd20cb$var$Stream.Writable = (parcelRequire("4DklV"));

$031d9f2443fd20cb$var$Stream.Duplex = (parcelRequire("kJ3xb"));

$031d9f2443fd20cb$var$Stream.Transform = (parcelRequire("8tWBv"));

$031d9f2443fd20cb$var$Stream.PassThrough = (parcelRequire("9T5ke"));

$031d9f2443fd20cb$var$Stream.finished = (parcelRequire("jKVyc"));

$031d9f2443fd20cb$var$Stream.pipeline = (parcelRequire("hLe38"));
// Backwards-compat with node 0.4.x
$031d9f2443fd20cb$var$Stream.Stream = $031d9f2443fd20cb$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $031d9f2443fd20cb$var$Stream() {
    $031d9f2443fd20cb$require$EE.call(this);
}
$031d9f2443fd20cb$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($031d9f2443fd20cb$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("5nsYU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $3ea594d76d0d888f$var$R = typeof Reflect === "object" ? Reflect : null;
var $3ea594d76d0d888f$var$ReflectApply = $3ea594d76d0d888f$var$R && typeof $3ea594d76d0d888f$var$R.apply === "function" ? $3ea594d76d0d888f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $3ea594d76d0d888f$var$ReflectOwnKeys;
if ($3ea594d76d0d888f$var$R && typeof $3ea594d76d0d888f$var$R.ownKeys === "function") $3ea594d76d0d888f$var$ReflectOwnKeys = $3ea594d76d0d888f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $3ea594d76d0d888f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $3ea594d76d0d888f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $3ea594d76d0d888f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $3ea594d76d0d888f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $3ea594d76d0d888f$var$EventEmitter() {
    $3ea594d76d0d888f$var$EventEmitter.init.call(this);
}
module.exports = $3ea594d76d0d888f$var$EventEmitter;
module.exports.once = $3ea594d76d0d888f$var$once;
// Backwards-compat with node 0.10.x
$3ea594d76d0d888f$var$EventEmitter.EventEmitter = $3ea594d76d0d888f$var$EventEmitter;
$3ea594d76d0d888f$var$EventEmitter.prototype._events = undefined;
$3ea594d76d0d888f$var$EventEmitter.prototype._eventsCount = 0;
$3ea594d76d0d888f$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $3ea594d76d0d888f$var$defaultMaxListeners = 10;
function $3ea594d76d0d888f$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($3ea594d76d0d888f$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $3ea594d76d0d888f$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $3ea594d76d0d888f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $3ea594d76d0d888f$var$defaultMaxListeners = arg;
    }
});
$3ea594d76d0d888f$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$3ea594d76d0d888f$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $3ea594d76d0d888f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $3ea594d76d0d888f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $3ea594d76d0d888f$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$3ea594d76d0d888f$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $3ea594d76d0d888f$var$_getMaxListeners(this);
};
$3ea594d76d0d888f$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $3ea594d76d0d888f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $3ea594d76d0d888f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$3ea594d76d0d888f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $3ea594d76d0d888f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $3ea594d76d0d888f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $3ea594d76d0d888f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $3ea594d76d0d888f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$3ea594d76d0d888f$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $3ea594d76d0d888f$var$_addListener(this, type, listener, false);
};
$3ea594d76d0d888f$var$EventEmitter.prototype.on = $3ea594d76d0d888f$var$EventEmitter.prototype.addListener;
$3ea594d76d0d888f$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $3ea594d76d0d888f$var$_addListener(this, type, listener, true);
};
function $3ea594d76d0d888f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $3ea594d76d0d888f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $3ea594d76d0d888f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$3ea594d76d0d888f$var$EventEmitter.prototype.once = function once(type, listener) {
    $3ea594d76d0d888f$var$checkListener(listener);
    this.on(type, $3ea594d76d0d888f$var$_onceWrap(this, type, listener));
    return this;
};
$3ea594d76d0d888f$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $3ea594d76d0d888f$var$checkListener(listener);
    this.prependListener(type, $3ea594d76d0d888f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$3ea594d76d0d888f$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $3ea594d76d0d888f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $3ea594d76d0d888f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$3ea594d76d0d888f$var$EventEmitter.prototype.off = $3ea594d76d0d888f$var$EventEmitter.prototype.removeListener;
$3ea594d76d0d888f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $3ea594d76d0d888f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $3ea594d76d0d888f$var$unwrapListeners(evlistener) : $3ea594d76d0d888f$var$arrayClone(evlistener, evlistener.length);
}
$3ea594d76d0d888f$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $3ea594d76d0d888f$var$_listeners(this, type, true);
};
$3ea594d76d0d888f$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $3ea594d76d0d888f$var$_listeners(this, type, false);
};
$3ea594d76d0d888f$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $3ea594d76d0d888f$var$listenerCount.call(emitter, type);
};
$3ea594d76d0d888f$var$EventEmitter.prototype.listenerCount = $3ea594d76d0d888f$var$listenerCount;
function $3ea594d76d0d888f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$3ea594d76d0d888f$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $3ea594d76d0d888f$var$ReflectOwnKeys(this._events) : [];
};
function $3ea594d76d0d888f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $3ea594d76d0d888f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $3ea594d76d0d888f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $3ea594d76d0d888f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $3ea594d76d0d888f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $3ea594d76d0d888f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $3ea594d76d0d888f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $3ea594d76d0d888f$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $3ea594d76d0d888f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("Zqiiu", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("gR89Q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $bQXJn = parcelRequire("bQXJn");
"use strict";
module.exports = $c457ec8c667d959c$var$Readable;
/*<replacement>*/ var $c457ec8c667d959c$var$Duplex;
/*</replacement>*/ $c457ec8c667d959c$var$Readable.ReadableState = $c457ec8c667d959c$var$ReadableState;

var $5nsYU = parcelRequire("5nsYU");
var $c457ec8c667d959c$require$EE = $5nsYU.EventEmitter;
var $c457ec8c667d959c$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $h9V9M = parcelRequire("h9V9M");

var $1bZtd = parcelRequire("1bZtd");
var $c457ec8c667d959c$require$Buffer = $1bZtd.Buffer;
var $c457ec8c667d959c$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $c457ec8c667d959c$var$_uint8ArrayToBuffer(chunk) {
    return $c457ec8c667d959c$require$Buffer.from(chunk);
}
function $c457ec8c667d959c$var$_isUint8Array(obj) {
    return $c457ec8c667d959c$require$Buffer.isBuffer(obj) || obj instanceof $c457ec8c667d959c$var$OurUint8Array;
}

var $8IaEB = parcelRequire("8IaEB");
var $c457ec8c667d959c$var$debug;
if ($8IaEB && $8IaEB.debuglog) $c457ec8c667d959c$var$debug = $8IaEB.debuglog("stream");
else $c457ec8c667d959c$var$debug = function debug() {};

var $h007z = parcelRequire("h007z");

var $lV8ut = parcelRequire("lV8ut");

var $le5GZ = parcelRequire("le5GZ");
var $c457ec8c667d959c$var$getHighWaterMark = $le5GZ.getHighWaterMark;

var $9DMa8 = parcelRequire("9DMa8");
var $c457ec8c667d959c$require$_require$codes = $9DMa8.codes;
var $c457ec8c667d959c$var$ERR_INVALID_ARG_TYPE = $c457ec8c667d959c$require$_require$codes.ERR_INVALID_ARG_TYPE, $c457ec8c667d959c$var$ERR_STREAM_PUSH_AFTER_EOF = $c457ec8c667d959c$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $c457ec8c667d959c$var$ERR_METHOD_NOT_IMPLEMENTED = $c457ec8c667d959c$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c457ec8c667d959c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $c457ec8c667d959c$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $c457ec8c667d959c$var$StringDecoder;
var $c457ec8c667d959c$var$createReadableStreamAsyncIterator;
var $c457ec8c667d959c$var$from;

(parcelRequire("Zqiiu"))($c457ec8c667d959c$var$Readable, $h9V9M);
var $c457ec8c667d959c$var$errorOrDestroy = $lV8ut.errorOrDestroy;
var $c457ec8c667d959c$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $c457ec8c667d959c$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c457ec8c667d959c$var$ReadableState(options, stream, isDuplex) {
    $c457ec8c667d959c$var$Duplex = $c457ec8c667d959c$var$Duplex || (parcelRequire("kJ3xb"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $c457ec8c667d959c$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $c457ec8c667d959c$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $h007z();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c457ec8c667d959c$var$StringDecoder) $c457ec8c667d959c$var$StringDecoder = (parcelRequire("1ybPW")).StringDecoder;
        this.decoder = new $c457ec8c667d959c$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c457ec8c667d959c$var$Readable(options) {
    $c457ec8c667d959c$var$Duplex = $c457ec8c667d959c$var$Duplex || (parcelRequire("kJ3xb"));
    if (!(this instanceof $c457ec8c667d959c$var$Readable)) return new $c457ec8c667d959c$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c457ec8c667d959c$var$Duplex;
    this._readableState = new $c457ec8c667d959c$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $h9V9M.call(this);
}
Object.defineProperty($c457ec8c667d959c$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c457ec8c667d959c$var$Readable.prototype.destroy = $lV8ut.destroy;
$c457ec8c667d959c$var$Readable.prototype._undestroy = $lV8ut.undestroy;
$c457ec8c667d959c$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c457ec8c667d959c$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c457ec8c667d959c$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c457ec8c667d959c$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c457ec8c667d959c$var$Readable.prototype.unshift = function(chunk) {
    return $c457ec8c667d959c$var$readableAddChunk(this, chunk, null, true, false);
};
function $c457ec8c667d959c$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $c457ec8c667d959c$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c457ec8c667d959c$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c457ec8c667d959c$var$chunkInvalid(state, chunk);
        if (er) $c457ec8c667d959c$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $c457ec8c667d959c$require$Buffer.prototype) chunk = $c457ec8c667d959c$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $c457ec8c667d959c$var$errorOrDestroy(stream, new $c457ec8c667d959c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $c457ec8c667d959c$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $c457ec8c667d959c$var$errorOrDestroy(stream, new $c457ec8c667d959c$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c457ec8c667d959c$var$addChunk(stream, state, chunk, false);
                    else $c457ec8c667d959c$var$maybeReadMore(stream, state);
                } else $c457ec8c667d959c$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $c457ec8c667d959c$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c457ec8c667d959c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c457ec8c667d959c$var$emitReadable(stream);
    }
    $c457ec8c667d959c$var$maybeReadMore(stream, state);
}
function $c457ec8c667d959c$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c457ec8c667d959c$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $c457ec8c667d959c$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$c457ec8c667d959c$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c457ec8c667d959c$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c457ec8c667d959c$var$StringDecoder) $c457ec8c667d959c$var$StringDecoder = (parcelRequire("1ybPW")).StringDecoder;
    var decoder = new $c457ec8c667d959c$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $c457ec8c667d959c$var$MAX_HWM = 0x40000000;
function $c457ec8c667d959c$var$computeNewHighWaterMark(n) {
    if (n >= $c457ec8c667d959c$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $c457ec8c667d959c$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c457ec8c667d959c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c457ec8c667d959c$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c457ec8c667d959c$var$Readable.prototype.read = function(n) {
    $c457ec8c667d959c$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c457ec8c667d959c$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $c457ec8c667d959c$var$endReadable(this);
        else $c457ec8c667d959c$var$emitReadable(this);
        return null;
    }
    n = $c457ec8c667d959c$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c457ec8c667d959c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c457ec8c667d959c$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c457ec8c667d959c$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c457ec8c667d959c$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $c457ec8c667d959c$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c457ec8c667d959c$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c457ec8c667d959c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c457ec8c667d959c$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $c457ec8c667d959c$var$onEofChunk(stream, state) {
    $c457ec8c667d959c$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $c457ec8c667d959c$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $c457ec8c667d959c$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c457ec8c667d959c$var$emitReadable(stream) {
    var state = stream._readableState;
    $c457ec8c667d959c$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c457ec8c667d959c$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $bQXJn.nextTick($c457ec8c667d959c$var$emitReadable_, stream);
    }
}
function $c457ec8c667d959c$var$emitReadable_(stream) {
    var state = stream._readableState;
    $c457ec8c667d959c$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c457ec8c667d959c$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c457ec8c667d959c$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bQXJn.nextTick($c457ec8c667d959c$var$maybeReadMore_, stream, state);
    }
}
function $c457ec8c667d959c$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $c457ec8c667d959c$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c457ec8c667d959c$var$Readable.prototype._read = function(n) {
    $c457ec8c667d959c$var$errorOrDestroy(this, new $c457ec8c667d959c$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$c457ec8c667d959c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c457ec8c667d959c$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $bQXJn.stdout && dest !== $bQXJn.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bQXJn.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c457ec8c667d959c$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c457ec8c667d959c$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c457ec8c667d959c$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c457ec8c667d959c$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $c457ec8c667d959c$var$debug("ondata");
        var ret = dest.write(chunk);
        $c457ec8c667d959c$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c457ec8c667d959c$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c457ec8c667d959c$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c457ec8c667d959c$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($c457ec8c667d959c$var$EElistenerCount(dest, "error") === 0) $c457ec8c667d959c$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $c457ec8c667d959c$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $c457ec8c667d959c$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $c457ec8c667d959c$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c457ec8c667d959c$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $c457ec8c667d959c$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $c457ec8c667d959c$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c457ec8c667d959c$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $c457ec8c667d959c$var$flow(src);
        }
    };
}
$c457ec8c667d959c$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c457ec8c667d959c$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c457ec8c667d959c$var$Readable.prototype.on = function(ev, fn) {
    var res = $h9V9M.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c457ec8c667d959c$var$debug("on readable", state.length, state.reading);
            if (state.length) $c457ec8c667d959c$var$emitReadable(this);
            else if (!state.reading) $bQXJn.nextTick($c457ec8c667d959c$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c457ec8c667d959c$var$Readable.prototype.addListener = $c457ec8c667d959c$var$Readable.prototype.on;
$c457ec8c667d959c$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $h9V9M.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $bQXJn.nextTick($c457ec8c667d959c$var$updateReadableListening, this);
    return res;
};
$c457ec8c667d959c$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $h9V9M.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $bQXJn.nextTick($c457ec8c667d959c$var$updateReadableListening, this);
    return res;
};
function $c457ec8c667d959c$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $c457ec8c667d959c$var$nReadingNextTick(self1) {
    $c457ec8c667d959c$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c457ec8c667d959c$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c457ec8c667d959c$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $c457ec8c667d959c$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $c457ec8c667d959c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bQXJn.nextTick($c457ec8c667d959c$var$resume_, stream, state);
    }
}
function $c457ec8c667d959c$var$resume_(stream, state) {
    $c457ec8c667d959c$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $c457ec8c667d959c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c457ec8c667d959c$var$Readable.prototype.pause = function() {
    $c457ec8c667d959c$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c457ec8c667d959c$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $c457ec8c667d959c$var$flow(stream) {
    var state = stream._readableState;
    $c457ec8c667d959c$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c457ec8c667d959c$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $c457ec8c667d959c$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $c457ec8c667d959c$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c457ec8c667d959c$var$kProxyEvents.length; n++)stream.on($c457ec8c667d959c$var$kProxyEvents[n], this.emit.bind(this, $c457ec8c667d959c$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c457ec8c667d959c$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $c457ec8c667d959c$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($c457ec8c667d959c$var$createReadableStreamAsyncIterator === undefined) $c457ec8c667d959c$var$createReadableStreamAsyncIterator = (parcelRequire("4CVP2"));
    return $c457ec8c667d959c$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($c457ec8c667d959c$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($c457ec8c667d959c$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($c457ec8c667d959c$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$c457ec8c667d959c$var$Readable._fromList = $c457ec8c667d959c$var$fromList;
Object.defineProperty($c457ec8c667d959c$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c457ec8c667d959c$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c457ec8c667d959c$var$endReadable(stream) {
    var state = stream._readableState;
    $c457ec8c667d959c$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $bQXJn.nextTick($c457ec8c667d959c$var$endReadableNT, state, stream);
    }
}
function $c457ec8c667d959c$var$endReadableNT(state, stream) {
    $c457ec8c667d959c$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $c457ec8c667d959c$var$Readable.from = function(iterable, opts) {
    if ($c457ec8c667d959c$var$from === undefined) $c457ec8c667d959c$var$from = (parcelRequire("aoBVX"));
    return $c457ec8c667d959c$var$from($c457ec8c667d959c$var$Readable, iterable, opts);
};
function $c457ec8c667d959c$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bQXJn", function(module, exports) {
// shim for using process in browser
var $8a12e254c0a050de$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8a12e254c0a050de$var$cachedSetTimeout;
var $8a12e254c0a050de$var$cachedClearTimeout;
function $8a12e254c0a050de$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8a12e254c0a050de$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8a12e254c0a050de$var$cachedSetTimeout = setTimeout;
        else $8a12e254c0a050de$var$cachedSetTimeout = $8a12e254c0a050de$var$defaultSetTimout;
    } catch (e) {
        $8a12e254c0a050de$var$cachedSetTimeout = $8a12e254c0a050de$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8a12e254c0a050de$var$cachedClearTimeout = clearTimeout;
        else $8a12e254c0a050de$var$cachedClearTimeout = $8a12e254c0a050de$var$defaultClearTimeout;
    } catch (e) {
        $8a12e254c0a050de$var$cachedClearTimeout = $8a12e254c0a050de$var$defaultClearTimeout;
    }
})();
function $8a12e254c0a050de$var$runTimeout(fun) {
    if ($8a12e254c0a050de$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8a12e254c0a050de$var$cachedSetTimeout === $8a12e254c0a050de$var$defaultSetTimout || !$8a12e254c0a050de$var$cachedSetTimeout) && setTimeout) {
        $8a12e254c0a050de$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8a12e254c0a050de$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8a12e254c0a050de$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8a12e254c0a050de$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8a12e254c0a050de$var$runClearTimeout(marker) {
    if ($8a12e254c0a050de$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8a12e254c0a050de$var$cachedClearTimeout === $8a12e254c0a050de$var$defaultClearTimeout || !$8a12e254c0a050de$var$cachedClearTimeout) && clearTimeout) {
        $8a12e254c0a050de$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8a12e254c0a050de$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8a12e254c0a050de$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8a12e254c0a050de$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8a12e254c0a050de$var$queue = [];
var $8a12e254c0a050de$var$draining = false;
var $8a12e254c0a050de$var$currentQueue;
var $8a12e254c0a050de$var$queueIndex = -1;
function $8a12e254c0a050de$var$cleanUpNextTick() {
    if (!$8a12e254c0a050de$var$draining || !$8a12e254c0a050de$var$currentQueue) return;
    $8a12e254c0a050de$var$draining = false;
    if ($8a12e254c0a050de$var$currentQueue.length) $8a12e254c0a050de$var$queue = $8a12e254c0a050de$var$currentQueue.concat($8a12e254c0a050de$var$queue);
    else $8a12e254c0a050de$var$queueIndex = -1;
    if ($8a12e254c0a050de$var$queue.length) $8a12e254c0a050de$var$drainQueue();
}
function $8a12e254c0a050de$var$drainQueue() {
    if ($8a12e254c0a050de$var$draining) return;
    var timeout = $8a12e254c0a050de$var$runTimeout($8a12e254c0a050de$var$cleanUpNextTick);
    $8a12e254c0a050de$var$draining = true;
    var len = $8a12e254c0a050de$var$queue.length;
    while(len){
        $8a12e254c0a050de$var$currentQueue = $8a12e254c0a050de$var$queue;
        $8a12e254c0a050de$var$queue = [];
        while(++$8a12e254c0a050de$var$queueIndex < len)if ($8a12e254c0a050de$var$currentQueue) $8a12e254c0a050de$var$currentQueue[$8a12e254c0a050de$var$queueIndex].run();
        $8a12e254c0a050de$var$queueIndex = -1;
        len = $8a12e254c0a050de$var$queue.length;
    }
    $8a12e254c0a050de$var$currentQueue = null;
    $8a12e254c0a050de$var$draining = false;
    $8a12e254c0a050de$var$runClearTimeout(timeout);
}
$8a12e254c0a050de$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8a12e254c0a050de$var$queue.push(new $8a12e254c0a050de$var$Item(fun, args));
    if ($8a12e254c0a050de$var$queue.length === 1 && !$8a12e254c0a050de$var$draining) $8a12e254c0a050de$var$runTimeout($8a12e254c0a050de$var$drainQueue);
};
// v8 likes predictible objects
function $8a12e254c0a050de$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8a12e254c0a050de$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8a12e254c0a050de$var$process.title = "browser";
$8a12e254c0a050de$var$process.browser = true;
$8a12e254c0a050de$var$process.env = {};
$8a12e254c0a050de$var$process.argv = [];
$8a12e254c0a050de$var$process.version = ""; // empty string to avoid regexp issues
$8a12e254c0a050de$var$process.versions = {};
function $8a12e254c0a050de$var$noop() {}
$8a12e254c0a050de$var$process.on = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.addListener = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.once = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.off = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.removeListener = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.removeAllListeners = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.emit = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.prependListener = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.prependOnceListener = $8a12e254c0a050de$var$noop;
$8a12e254c0a050de$var$process.listeners = function(name) {
    return [];
};
$8a12e254c0a050de$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8a12e254c0a050de$var$process.cwd = function() {
    return "/";
};
$8a12e254c0a050de$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8a12e254c0a050de$var$process.umask = function() {
    return 0;
};

});

parcelRegister("h9V9M", function(module, exports) {

module.exports = (parcelRequire("5nsYU")).EventEmitter;

});

parcelRegister("8IaEB", function(module, exports) {
"use strict";

});

parcelRegister("h007z", function(module, exports) {
"use strict";
function $c60287cccf456ab4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c60287cccf456ab4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c60287cccf456ab4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c60287cccf456ab4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c60287cccf456ab4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c60287cccf456ab4$var$_defineProperty(obj, key, value) {
    key = $c60287cccf456ab4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c60287cccf456ab4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c60287cccf456ab4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c60287cccf456ab4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c60287cccf456ab4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c60287cccf456ab4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c60287cccf456ab4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c60287cccf456ab4$var$_toPropertyKey(arg) {
    var key = $c60287cccf456ab4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c60287cccf456ab4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $1bZtd = parcelRequire("1bZtd");
var $c60287cccf456ab4$var$Buffer = $1bZtd.Buffer;

var $8IaEB = parcelRequire("8IaEB");
var $c60287cccf456ab4$var$inspect = $8IaEB.inspect;
var $c60287cccf456ab4$var$custom = $c60287cccf456ab4$var$inspect && $c60287cccf456ab4$var$inspect.custom || "inspect";
function $c60287cccf456ab4$var$copyBuffer(src, target, offset) {
    $c60287cccf456ab4$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $c60287cccf456ab4$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $c60287cccf456ab4$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $c60287cccf456ab4$var$Buffer.alloc(0);
                var ret = $c60287cccf456ab4$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $c60287cccf456ab4$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $c60287cccf456ab4$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $c60287cccf456ab4$var$custom,
            value: function value(_, options) {
                return $c60287cccf456ab4$var$inspect(this, $c60287cccf456ab4$var$_objectSpread($c60287cccf456ab4$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("lV8ut", function(module, exports) {

var $bQXJn = parcelRequire("bQXJn");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $ff5581e7899c08e2$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bQXJn.nextTick($ff5581e7899c08e2$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bQXJn.nextTick($ff5581e7899c08e2$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bQXJn.nextTick($ff5581e7899c08e2$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bQXJn.nextTick($ff5581e7899c08e2$var$emitErrorAndCloseNT, _this, err);
            } else $bQXJn.nextTick($ff5581e7899c08e2$var$emitCloseNT, _this);
        } else if (cb) {
            $bQXJn.nextTick($ff5581e7899c08e2$var$emitCloseNT, _this);
            cb(err);
        } else $bQXJn.nextTick($ff5581e7899c08e2$var$emitCloseNT, _this);
    });
    return this;
}
function $ff5581e7899c08e2$var$emitErrorAndCloseNT(self, err) {
    $ff5581e7899c08e2$var$emitErrorNT(self, err);
    $ff5581e7899c08e2$var$emitCloseNT(self);
}
function $ff5581e7899c08e2$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $ff5581e7899c08e2$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $ff5581e7899c08e2$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $ff5581e7899c08e2$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $ff5581e7899c08e2$var$destroy,
    undestroy: $ff5581e7899c08e2$var$undestroy,
    errorOrDestroy: $ff5581e7899c08e2$var$errorOrDestroy
};

});

parcelRegister("le5GZ", function(module, exports) {
"use strict";

var $f73f5227e85b6bf1$var$ERR_INVALID_OPT_VALUE = (parcelRequire("9DMa8")).codes.ERR_INVALID_OPT_VALUE;
function $f73f5227e85b6bf1$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f73f5227e85b6bf1$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $f73f5227e85b6bf1$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $f73f5227e85b6bf1$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $f73f5227e85b6bf1$var$getHighWaterMark
};

});
parcelRegister("9DMa8", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $704d1da1f55b31ed$export$e45cb6485273080e; }, function (v) { return $704d1da1f55b31ed$export$e45cb6485273080e = v; });
var $704d1da1f55b31ed$export$e45cb6485273080e;
"use strict";
function $704d1da1f55b31ed$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $704d1da1f55b31ed$var$codes = {};
function $704d1da1f55b31ed$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $704d1da1f55b31ed$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $704d1da1f55b31ed$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $704d1da1f55b31ed$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $704d1da1f55b31ed$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $704d1da1f55b31ed$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $704d1da1f55b31ed$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$704d1da1f55b31ed$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$704d1da1f55b31ed$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $704d1da1f55b31ed$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($704d1da1f55b31ed$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($704d1da1f55b31ed$var$oneOf(expected, "type"));
    else {
        var type = $704d1da1f55b31ed$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($704d1da1f55b31ed$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$704d1da1f55b31ed$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$704d1da1f55b31ed$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$704d1da1f55b31ed$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$704d1da1f55b31ed$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$704d1da1f55b31ed$export$e45cb6485273080e = $704d1da1f55b31ed$var$codes;

});


parcelRegister("kJ3xb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $bQXJn = parcelRequire("bQXJn");
"use strict";
/*<replacement>*/ var $f16ac07023013857$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $f16ac07023013857$var$Duplex;

var $gR89Q = parcelRequire("gR89Q");

var $4DklV = parcelRequire("4DklV");

(parcelRequire("Zqiiu"))($f16ac07023013857$var$Duplex, $gR89Q);
// Allow the keys array to be GC'ed.
var $f16ac07023013857$var$keys = $f16ac07023013857$var$objectKeys($4DklV.prototype);
for(var $f16ac07023013857$var$v = 0; $f16ac07023013857$var$v < $f16ac07023013857$var$keys.length; $f16ac07023013857$var$v++){
    var $f16ac07023013857$var$method = $f16ac07023013857$var$keys[$f16ac07023013857$var$v];
    if (!$f16ac07023013857$var$Duplex.prototype[$f16ac07023013857$var$method]) $f16ac07023013857$var$Duplex.prototype[$f16ac07023013857$var$method] = $4DklV.prototype[$f16ac07023013857$var$method];
}
function $f16ac07023013857$var$Duplex(options) {
    if (!(this instanceof $f16ac07023013857$var$Duplex)) return new $f16ac07023013857$var$Duplex(options);
    $gR89Q.call(this, options);
    $4DklV.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $f16ac07023013857$var$onend);
        }
    }
}
Object.defineProperty($f16ac07023013857$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($f16ac07023013857$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($f16ac07023013857$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $f16ac07023013857$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bQXJn.nextTick($f16ac07023013857$var$onEndNT, this);
}
function $f16ac07023013857$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($f16ac07023013857$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("4DklV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $bQXJn = parcelRequire("bQXJn");
"use strict";
module.exports = $35fa978c40cff48f$var$Writable;
/* <replacement> */ function $35fa978c40cff48f$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $35fa978c40cff48f$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $35fa978c40cff48f$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $35fa978c40cff48f$var$Duplex;
/*</replacement>*/ $35fa978c40cff48f$var$Writable.WritableState = $35fa978c40cff48f$var$WritableState;

/*<replacement>*/ var $35fa978c40cff48f$var$internalUtil = {
    deprecate: (parcelRequire("2gKEq"))
};

var $h9V9M = parcelRequire("h9V9M");

var $1bZtd = parcelRequire("1bZtd");
var $35fa978c40cff48f$require$Buffer = $1bZtd.Buffer;
var $35fa978c40cff48f$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $35fa978c40cff48f$var$_uint8ArrayToBuffer(chunk) {
    return $35fa978c40cff48f$require$Buffer.from(chunk);
}
function $35fa978c40cff48f$var$_isUint8Array(obj) {
    return $35fa978c40cff48f$require$Buffer.isBuffer(obj) || obj instanceof $35fa978c40cff48f$var$OurUint8Array;
}

var $lV8ut = parcelRequire("lV8ut");

var $le5GZ = parcelRequire("le5GZ");
var $35fa978c40cff48f$var$getHighWaterMark = $le5GZ.getHighWaterMark;

var $9DMa8 = parcelRequire("9DMa8");
var $35fa978c40cff48f$require$_require$codes = $9DMa8.codes;
var $35fa978c40cff48f$var$ERR_INVALID_ARG_TYPE = $35fa978c40cff48f$require$_require$codes.ERR_INVALID_ARG_TYPE, $35fa978c40cff48f$var$ERR_METHOD_NOT_IMPLEMENTED = $35fa978c40cff48f$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $35fa978c40cff48f$var$ERR_MULTIPLE_CALLBACK = $35fa978c40cff48f$require$_require$codes.ERR_MULTIPLE_CALLBACK, $35fa978c40cff48f$var$ERR_STREAM_CANNOT_PIPE = $35fa978c40cff48f$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $35fa978c40cff48f$var$ERR_STREAM_DESTROYED = $35fa978c40cff48f$require$_require$codes.ERR_STREAM_DESTROYED, $35fa978c40cff48f$var$ERR_STREAM_NULL_VALUES = $35fa978c40cff48f$require$_require$codes.ERR_STREAM_NULL_VALUES, $35fa978c40cff48f$var$ERR_STREAM_WRITE_AFTER_END = $35fa978c40cff48f$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $35fa978c40cff48f$var$ERR_UNKNOWN_ENCODING = $35fa978c40cff48f$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $35fa978c40cff48f$var$errorOrDestroy = $lV8ut.errorOrDestroy;

(parcelRequire("Zqiiu"))($35fa978c40cff48f$var$Writable, $h9V9M);
function $35fa978c40cff48f$var$nop() {}

function $35fa978c40cff48f$var$WritableState(options, stream, isDuplex) {
    $35fa978c40cff48f$var$Duplex = $35fa978c40cff48f$var$Duplex || (parcelRequire("kJ3xb"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $35fa978c40cff48f$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $35fa978c40cff48f$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $35fa978c40cff48f$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $35fa978c40cff48f$var$CorkedRequest(this);
}
$35fa978c40cff48f$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($35fa978c40cff48f$var$WritableState.prototype, "buffer", {
            get: $35fa978c40cff48f$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $35fa978c40cff48f$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $35fa978c40cff48f$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($35fa978c40cff48f$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($35fa978c40cff48f$var$realHasInstance.call(this, object)) return true;
            if (this !== $35fa978c40cff48f$var$Writable) return false;
            return object && object._writableState instanceof $35fa978c40cff48f$var$WritableState;
        }
    });
} else $35fa978c40cff48f$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $35fa978c40cff48f$var$Writable(options) {
    $35fa978c40cff48f$var$Duplex = $35fa978c40cff48f$var$Duplex || (parcelRequire("kJ3xb"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $35fa978c40cff48f$var$Duplex;
    if (!isDuplex && !$35fa978c40cff48f$var$realHasInstance.call($35fa978c40cff48f$var$Writable, this)) return new $35fa978c40cff48f$var$Writable(options);
    this._writableState = new $35fa978c40cff48f$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $h9V9M.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$35fa978c40cff48f$var$Writable.prototype.pipe = function() {
    $35fa978c40cff48f$var$errorOrDestroy(this, new $35fa978c40cff48f$var$ERR_STREAM_CANNOT_PIPE());
};
function $35fa978c40cff48f$var$writeAfterEnd(stream, cb) {
    var er = new $35fa978c40cff48f$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $35fa978c40cff48f$var$errorOrDestroy(stream, er);
    $bQXJn.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $35fa978c40cff48f$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $35fa978c40cff48f$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $35fa978c40cff48f$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $35fa978c40cff48f$var$errorOrDestroy(stream, er);
        $bQXJn.nextTick(cb, er);
        return false;
    }
    return true;
}
$35fa978c40cff48f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $35fa978c40cff48f$var$_isUint8Array(chunk);
    if (isBuf && !$35fa978c40cff48f$require$Buffer.isBuffer(chunk)) chunk = $35fa978c40cff48f$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $35fa978c40cff48f$var$nop;
    if (state.ending) $35fa978c40cff48f$var$writeAfterEnd(this, cb);
    else if (isBuf || $35fa978c40cff48f$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $35fa978c40cff48f$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$35fa978c40cff48f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$35fa978c40cff48f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $35fa978c40cff48f$var$clearBuffer(this, state);
    }
};
$35fa978c40cff48f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $35fa978c40cff48f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($35fa978c40cff48f$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $35fa978c40cff48f$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $35fa978c40cff48f$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($35fa978c40cff48f$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $35fa978c40cff48f$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $35fa978c40cff48f$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $35fa978c40cff48f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $35fa978c40cff48f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $35fa978c40cff48f$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $35fa978c40cff48f$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bQXJn.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bQXJn.nextTick($35fa978c40cff48f$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $35fa978c40cff48f$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $35fa978c40cff48f$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $35fa978c40cff48f$var$finishMaybe(stream, state);
    }
}
function $35fa978c40cff48f$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $35fa978c40cff48f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $35fa978c40cff48f$var$ERR_MULTIPLE_CALLBACK();
    $35fa978c40cff48f$var$onwriteStateUpdate(state);
    if (er) $35fa978c40cff48f$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $35fa978c40cff48f$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $35fa978c40cff48f$var$clearBuffer(stream, state);
        if (sync) $bQXJn.nextTick($35fa978c40cff48f$var$afterWrite, stream, state, finished, cb);
        else $35fa978c40cff48f$var$afterWrite(stream, state, finished, cb);
    }
}
function $35fa978c40cff48f$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $35fa978c40cff48f$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $35fa978c40cff48f$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $35fa978c40cff48f$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $35fa978c40cff48f$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $35fa978c40cff48f$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $35fa978c40cff48f$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $35fa978c40cff48f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$35fa978c40cff48f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $35fa978c40cff48f$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$35fa978c40cff48f$var$Writable.prototype._writev = null;
$35fa978c40cff48f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $35fa978c40cff48f$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($35fa978c40cff48f$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $35fa978c40cff48f$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $35fa978c40cff48f$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $35fa978c40cff48f$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $35fa978c40cff48f$var$finishMaybe(stream, state);
    });
}
function $35fa978c40cff48f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $bQXJn.nextTick($35fa978c40cff48f$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $35fa978c40cff48f$var$finishMaybe(stream, state) {
    var need = $35fa978c40cff48f$var$needFinish(state);
    if (need) {
        $35fa978c40cff48f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $35fa978c40cff48f$var$endWritable(stream, state, cb) {
    state.ending = true;
    $35fa978c40cff48f$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bQXJn.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $35fa978c40cff48f$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($35fa978c40cff48f$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$35fa978c40cff48f$var$Writable.prototype.destroy = $lV8ut.destroy;
$35fa978c40cff48f$var$Writable.prototype._undestroy = $lV8ut.undestroy;
$35fa978c40cff48f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("2gKEq", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $1a71434f5666c428$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $1a71434f5666c428$var$deprecate(fn, msg) {
    if ($1a71434f5666c428$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1a71434f5666c428$var$config("throwDeprecation")) throw new Error(msg);
            else if ($1a71434f5666c428$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $1a71434f5666c428$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("1ybPW", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $121225f12d8d671d$export$63a7aa211a91ed69; }, function (v) { return $121225f12d8d671d$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $121225f12d8d671d$export$63a7aa211a91ed69;
"use strict";

var $kZuKR = parcelRequire("kZuKR");
var $121225f12d8d671d$require$Buffer = $kZuKR.Buffer;
/*</replacement>*/ var $121225f12d8d671d$var$isEncoding = $121225f12d8d671d$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $121225f12d8d671d$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $121225f12d8d671d$var$normalizeEncoding(enc) {
    var nenc = $121225f12d8d671d$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($121225f12d8d671d$require$Buffer.isEncoding === $121225f12d8d671d$var$isEncoding || !$121225f12d8d671d$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$121225f12d8d671d$export$63a7aa211a91ed69 = $121225f12d8d671d$var$StringDecoder;
function $121225f12d8d671d$var$StringDecoder(encoding) {
    this.encoding = $121225f12d8d671d$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $121225f12d8d671d$var$utf16Text;
            this.end = $121225f12d8d671d$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $121225f12d8d671d$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $121225f12d8d671d$var$base64Text;
            this.end = $121225f12d8d671d$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $121225f12d8d671d$var$simpleWrite;
            this.end = $121225f12d8d671d$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $121225f12d8d671d$require$Buffer.allocUnsafe(nb);
}
$121225f12d8d671d$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$121225f12d8d671d$var$StringDecoder.prototype.end = $121225f12d8d671d$var$utf8End;
// Returns only complete characters in a Buffer
$121225f12d8d671d$var$StringDecoder.prototype.text = $121225f12d8d671d$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$121225f12d8d671d$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $121225f12d8d671d$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $121225f12d8d671d$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $121225f12d8d671d$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $121225f12d8d671d$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $121225f12d8d671d$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $121225f12d8d671d$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $121225f12d8d671d$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $121225f12d8d671d$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $121225f12d8d671d$var$utf8Text(buf, i) {
    var total = $121225f12d8d671d$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $121225f12d8d671d$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $121225f12d8d671d$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $121225f12d8d671d$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $121225f12d8d671d$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $121225f12d8d671d$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $121225f12d8d671d$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $121225f12d8d671d$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("kZuKR", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $1bZtd = parcelRequire("1bZtd");
var $f4815c6acd8e1f77$var$Buffer = $1bZtd.Buffer;
// alternative to using Object.keys for old browsers
function $f4815c6acd8e1f77$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($f4815c6acd8e1f77$var$Buffer.from && $f4815c6acd8e1f77$var$Buffer.alloc && $f4815c6acd8e1f77$var$Buffer.allocUnsafe && $f4815c6acd8e1f77$var$Buffer.allocUnsafeSlow) module.exports = $1bZtd;
else {
    // Copy properties from require('buffer')
    $f4815c6acd8e1f77$var$copyProps($1bZtd, module.exports);
    module.exports.Buffer = $f4815c6acd8e1f77$var$SafeBuffer;
}
function $f4815c6acd8e1f77$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $f4815c6acd8e1f77$var$Buffer(arg, encodingOrOffset, length);
}
$f4815c6acd8e1f77$var$SafeBuffer.prototype = Object.create($f4815c6acd8e1f77$var$Buffer.prototype);
// Copy static methods from Buffer
$f4815c6acd8e1f77$var$copyProps($f4815c6acd8e1f77$var$Buffer, $f4815c6acd8e1f77$var$SafeBuffer);
$f4815c6acd8e1f77$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $f4815c6acd8e1f77$var$Buffer(arg, encodingOrOffset, length);
};
$f4815c6acd8e1f77$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $f4815c6acd8e1f77$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$f4815c6acd8e1f77$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $f4815c6acd8e1f77$var$Buffer(size);
};
$f4815c6acd8e1f77$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1bZtd.SlowBuffer(size);
};

});


parcelRegister("4CVP2", function(module, exports) {

var $bQXJn = parcelRequire("bQXJn");
"use strict";
var $35e79051556a4fd3$var$_Object$setPrototypeO;
function $35e79051556a4fd3$var$_defineProperty(obj, key, value) {
    key = $35e79051556a4fd3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $35e79051556a4fd3$var$_toPropertyKey(arg) {
    var key = $35e79051556a4fd3$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $35e79051556a4fd3$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jKVyc = parcelRequire("jKVyc");
var $35e79051556a4fd3$var$kLastResolve = Symbol("lastResolve");
var $35e79051556a4fd3$var$kLastReject = Symbol("lastReject");
var $35e79051556a4fd3$var$kError = Symbol("error");
var $35e79051556a4fd3$var$kEnded = Symbol("ended");
var $35e79051556a4fd3$var$kLastPromise = Symbol("lastPromise");
var $35e79051556a4fd3$var$kHandlePromise = Symbol("handlePromise");
var $35e79051556a4fd3$var$kStream = Symbol("stream");
function $35e79051556a4fd3$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $35e79051556a4fd3$var$readAndResolve(iter) {
    var resolve = iter[$35e79051556a4fd3$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$35e79051556a4fd3$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$35e79051556a4fd3$var$kLastPromise] = null;
            iter[$35e79051556a4fd3$var$kLastResolve] = null;
            iter[$35e79051556a4fd3$var$kLastReject] = null;
            resolve($35e79051556a4fd3$var$createIterResult(data, false));
        }
    }
}
function $35e79051556a4fd3$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $bQXJn.nextTick($35e79051556a4fd3$var$readAndResolve, iter);
}
function $35e79051556a4fd3$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$35e79051556a4fd3$var$kEnded]) {
                resolve($35e79051556a4fd3$var$createIterResult(undefined, true));
                return;
            }
            iter[$35e79051556a4fd3$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $35e79051556a4fd3$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $35e79051556a4fd3$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($35e79051556a4fd3$var$_Object$setPrototypeO = {
    get stream () {
        return this[$35e79051556a4fd3$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$35e79051556a4fd3$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$35e79051556a4fd3$var$kEnded]) return Promise.resolve($35e79051556a4fd3$var$createIterResult(undefined, true));
        if (this[$35e79051556a4fd3$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $bQXJn.nextTick(function() {
                if (_this[$35e79051556a4fd3$var$kError]) reject(_this[$35e79051556a4fd3$var$kError]);
                else resolve($35e79051556a4fd3$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$35e79051556a4fd3$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($35e79051556a4fd3$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$35e79051556a4fd3$var$kStream].read();
            if (data !== null) return Promise.resolve($35e79051556a4fd3$var$createIterResult(data, false));
            promise = new Promise(this[$35e79051556a4fd3$var$kHandlePromise]);
        }
        this[$35e79051556a4fd3$var$kLastPromise] = promise;
        return promise;
    }
}, $35e79051556a4fd3$var$_defineProperty($35e79051556a4fd3$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $35e79051556a4fd3$var$_defineProperty($35e79051556a4fd3$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$35e79051556a4fd3$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($35e79051556a4fd3$var$createIterResult(undefined, true));
        });
    });
}), $35e79051556a4fd3$var$_Object$setPrototypeO), $35e79051556a4fd3$var$AsyncIteratorPrototype);
var $35e79051556a4fd3$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($35e79051556a4fd3$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $35e79051556a4fd3$var$_defineProperty(_Object$create, $35e79051556a4fd3$var$kStream, {
        value: stream,
        writable: true
    }), $35e79051556a4fd3$var$_defineProperty(_Object$create, $35e79051556a4fd3$var$kLastResolve, {
        value: null,
        writable: true
    }), $35e79051556a4fd3$var$_defineProperty(_Object$create, $35e79051556a4fd3$var$kLastReject, {
        value: null,
        writable: true
    }), $35e79051556a4fd3$var$_defineProperty(_Object$create, $35e79051556a4fd3$var$kError, {
        value: null,
        writable: true
    }), $35e79051556a4fd3$var$_defineProperty(_Object$create, $35e79051556a4fd3$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $35e79051556a4fd3$var$_defineProperty(_Object$create, $35e79051556a4fd3$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$35e79051556a4fd3$var$kStream].read();
            if (data) {
                iterator[$35e79051556a4fd3$var$kLastPromise] = null;
                iterator[$35e79051556a4fd3$var$kLastResolve] = null;
                iterator[$35e79051556a4fd3$var$kLastReject] = null;
                resolve($35e79051556a4fd3$var$createIterResult(data, false));
            } else {
                iterator[$35e79051556a4fd3$var$kLastResolve] = resolve;
                iterator[$35e79051556a4fd3$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$35e79051556a4fd3$var$kLastPromise] = null;
    $jKVyc(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$35e79051556a4fd3$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$35e79051556a4fd3$var$kLastPromise] = null;
                iterator[$35e79051556a4fd3$var$kLastResolve] = null;
                iterator[$35e79051556a4fd3$var$kLastReject] = null;
                reject(err);
            }
            iterator[$35e79051556a4fd3$var$kError] = err;
            return;
        }
        var resolve = iterator[$35e79051556a4fd3$var$kLastResolve];
        if (resolve !== null) {
            iterator[$35e79051556a4fd3$var$kLastPromise] = null;
            iterator[$35e79051556a4fd3$var$kLastResolve] = null;
            iterator[$35e79051556a4fd3$var$kLastReject] = null;
            resolve($35e79051556a4fd3$var$createIterResult(undefined, true));
        }
        iterator[$35e79051556a4fd3$var$kEnded] = true;
    });
    stream.on("readable", $35e79051556a4fd3$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $35e79051556a4fd3$var$createReadableStreamAsyncIterator;

});
parcelRegister("jKVyc", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $e61ef48a64671f37$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("9DMa8")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e61ef48a64671f37$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e61ef48a64671f37$var$noop() {}
function $e61ef48a64671f37$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $e61ef48a64671f37$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $e61ef48a64671f37$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e61ef48a64671f37$var$once(callback || $e61ef48a64671f37$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e61ef48a64671f37$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e61ef48a64671f37$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($e61ef48a64671f37$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $e61ef48a64671f37$var$eos;

});


parcelRegister("aoBVX", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("8tWBv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $62ce7da91ad2b440$var$Transform;

var $9DMa8 = parcelRequire("9DMa8");
var $62ce7da91ad2b440$require$_require$codes = $9DMa8.codes;
var $62ce7da91ad2b440$var$ERR_METHOD_NOT_IMPLEMENTED = $62ce7da91ad2b440$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $62ce7da91ad2b440$var$ERR_MULTIPLE_CALLBACK = $62ce7da91ad2b440$require$_require$codes.ERR_MULTIPLE_CALLBACK, $62ce7da91ad2b440$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $62ce7da91ad2b440$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $62ce7da91ad2b440$var$ERR_TRANSFORM_WITH_LENGTH_0 = $62ce7da91ad2b440$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $kJ3xb = parcelRequire("kJ3xb");

(parcelRequire("Zqiiu"))($62ce7da91ad2b440$var$Transform, $kJ3xb);
function $62ce7da91ad2b440$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $62ce7da91ad2b440$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $62ce7da91ad2b440$var$Transform(options) {
    if (!(this instanceof $62ce7da91ad2b440$var$Transform)) return new $62ce7da91ad2b440$var$Transform(options);
    $kJ3xb.call(this, options);
    this._transformState = {
        afterTransform: $62ce7da91ad2b440$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $62ce7da91ad2b440$var$prefinish);
}
function $62ce7da91ad2b440$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $62ce7da91ad2b440$var$done(_this, er, data);
    });
    else $62ce7da91ad2b440$var$done(this, null, null);
}
$62ce7da91ad2b440$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $kJ3xb.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$62ce7da91ad2b440$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $62ce7da91ad2b440$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$62ce7da91ad2b440$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$62ce7da91ad2b440$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$62ce7da91ad2b440$var$Transform.prototype._destroy = function(err, cb) {
    $kJ3xb.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $62ce7da91ad2b440$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $62ce7da91ad2b440$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $62ce7da91ad2b440$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("9T5ke", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $732d61972bff0a53$var$PassThrough;

var $8tWBv = parcelRequire("8tWBv");

(parcelRequire("Zqiiu"))($732d61972bff0a53$var$PassThrough, $8tWBv);
function $732d61972bff0a53$var$PassThrough(options) {
    if (!(this instanceof $732d61972bff0a53$var$PassThrough)) return new $732d61972bff0a53$var$PassThrough(options);
    $8tWBv.call(this, options);
}
$732d61972bff0a53$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("hLe38", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $cee1b9693a1a87c3$var$eos;
function $cee1b9693a1a87c3$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $9DMa8 = parcelRequire("9DMa8");
var $cee1b9693a1a87c3$require$_require$codes = $9DMa8.codes;
var $cee1b9693a1a87c3$var$ERR_MISSING_ARGS = $cee1b9693a1a87c3$require$_require$codes.ERR_MISSING_ARGS, $cee1b9693a1a87c3$var$ERR_STREAM_DESTROYED = $cee1b9693a1a87c3$require$_require$codes.ERR_STREAM_DESTROYED;
function $cee1b9693a1a87c3$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $cee1b9693a1a87c3$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $cee1b9693a1a87c3$var$destroyer(stream, reading, writing, callback) {
    callback = $cee1b9693a1a87c3$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($cee1b9693a1a87c3$var$eos === undefined) $cee1b9693a1a87c3$var$eos = (parcelRequire("jKVyc"));
    $cee1b9693a1a87c3$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($cee1b9693a1a87c3$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $cee1b9693a1a87c3$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $cee1b9693a1a87c3$var$call(fn) {
    fn();
}
function $cee1b9693a1a87c3$var$pipe(from, to) {
    return from.pipe(to);
}
function $cee1b9693a1a87c3$var$popCallback(streams) {
    if (!streams.length) return $cee1b9693a1a87c3$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $cee1b9693a1a87c3$var$noop;
    return streams.pop();
}
function $cee1b9693a1a87c3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $cee1b9693a1a87c3$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $cee1b9693a1a87c3$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $cee1b9693a1a87c3$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($cee1b9693a1a87c3$var$call);
            if (reading) return;
            destroys.forEach($cee1b9693a1a87c3$var$call);
            callback(error);
        });
    });
    return streams.reduce($cee1b9693a1a87c3$var$pipe);
}
module.exports = $cee1b9693a1a87c3$var$pipeline;

});



parcelRegister("2Tz2T", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    module.exports.stripBOM = function(str) {
        if (str[0] === "\uFEFF") return str.substring(1);
        else return str;
    };
}).call(module.exports);

});

parcelRegister("aUA6y", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var prefixMatch;
    prefixMatch = new RegExp(/(?!xmlns)^.*:/);
    module.exports.normalize = function(str) {
        return str.toLowerCase();
    };
    module.exports.firstCharLowerCase = function(str) {
        return str.charAt(0).toLowerCase() + str.slice(1);
    };
    module.exports.stripPrefix = function(str) {
        return str.replace(prefixMatch, "");
    };
    module.exports.parseNumbers = function(str) {
        if (!isNaN(str)) str = str % 1 === 0 ? parseInt(str, 10) : parseFloat(str);
        return str;
    };
    module.exports.parseBooleans = function(str) {
        if (/^(?:true|false)$/i.test(str)) str = str.toLowerCase() === "true";
        return str;
    };
}).call(module.exports);

});

parcelRegister("2E3Dc", function(module, exports) {
var $1ed2224a62c1a2b8$var$scope = typeof $parcel$global !== "undefined" && $parcel$global || typeof self !== "undefined" && self || window;
var $1ed2224a62c1a2b8$var$apply = Function.prototype.apply;
// DOM APIs, for completeness
module.exports.setTimeout = function() {
    return new $1ed2224a62c1a2b8$var$Timeout($1ed2224a62c1a2b8$var$apply.call(setTimeout, $1ed2224a62c1a2b8$var$scope, arguments), clearTimeout);
};
module.exports.setInterval = function() {
    return new $1ed2224a62c1a2b8$var$Timeout($1ed2224a62c1a2b8$var$apply.call(setInterval, $1ed2224a62c1a2b8$var$scope, arguments), clearInterval);
};
module.exports.clearTimeout = module.exports.clearInterval = function(timeout) {
    if (timeout) timeout.close();
};
function $1ed2224a62c1a2b8$var$Timeout(id, clearFn) {
    this._id = id;
    this._clearFn = clearFn;
}
$1ed2224a62c1a2b8$var$Timeout.prototype.unref = $1ed2224a62c1a2b8$var$Timeout.prototype.ref = function() {};
$1ed2224a62c1a2b8$var$Timeout.prototype.close = function() {
    this._clearFn.call($1ed2224a62c1a2b8$var$scope, this._id);
};
// Does not start the time, just sets up the members needed.
module.exports.enroll = function(item, msecs) {
    clearTimeout(item._idleTimeoutId);
    item._idleTimeout = msecs;
};
module.exports.unenroll = function(item) {
    clearTimeout(item._idleTimeoutId);
    item._idleTimeout = -1;
};
module.exports._unrefActive = module.exports.active = function(item) {
    clearTimeout(item._idleTimeoutId);
    var msecs = item._idleTimeout;
    if (msecs >= 0) item._idleTimeoutId = setTimeout(function onTimeout() {
        if (item._onTimeout) item._onTimeout();
    }, msecs);
};
parcelRequire("iuTbD");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
module.exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof $parcel$global !== "undefined" && $parcel$global.setImmediate || module.exports && module.exports.setImmediate;
module.exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof $parcel$global !== "undefined" && $parcel$global.clearImmediate || module.exports && module.exports.clearImmediate;

});
parcelRegister("iuTbD", function(module, exports) {

var $bQXJn = parcelRequire("bQXJn");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $bQXJn.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});



var $939c0c8d3a4d7175$var$n, $939c0c8d3a4d7175$export$41c562ebe57d11e2, $939c0c8d3a4d7175$var$u, $939c0c8d3a4d7175$export$a8257692ac88316c, $939c0c8d3a4d7175$var$i, $939c0c8d3a4d7175$var$o, $939c0c8d3a4d7175$var$r, $939c0c8d3a4d7175$var$f, $939c0c8d3a4d7175$var$e, $939c0c8d3a4d7175$var$c = {}, $939c0c8d3a4d7175$var$s = [], $939c0c8d3a4d7175$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $939c0c8d3a4d7175$var$h = Array.isArray;
function $939c0c8d3a4d7175$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $939c0c8d3a4d7175$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $939c0c8d3a4d7175$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $939c0c8d3a4d7175$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $939c0c8d3a4d7175$var$d(l, f, i, o, null);
}
function $939c0c8d3a4d7175$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$939c0c8d3a4d7175$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $939c0c8d3a4d7175$export$41c562ebe57d11e2.vnode && $939c0c8d3a4d7175$export$41c562ebe57d11e2.vnode(f), f;
}
function $939c0c8d3a4d7175$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $939c0c8d3a4d7175$export$ffb0004e005737fa(n) {
    return n.children;
}
function $939c0c8d3a4d7175$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $939c0c8d3a4d7175$var$m(n, l) {
    if (null == l) return n.__ ? $939c0c8d3a4d7175$var$m(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $939c0c8d3a4d7175$var$m(n) : null;
}
function $939c0c8d3a4d7175$var$w(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $939c0c8d3a4d7175$var$v({}, o)).__v = o.__v + 1, $939c0c8d3a4d7175$export$41c562ebe57d11e2.vnode && $939c0c8d3a4d7175$export$41c562ebe57d11e2.vnode(i), $939c0c8d3a4d7175$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $939c0c8d3a4d7175$var$m(o) : r, !!(32 & o.__u), t), i.__v = o.__v, i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $939c0c8d3a4d7175$var$k(i), i;
}
function $939c0c8d3a4d7175$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $939c0c8d3a4d7175$var$k(n);
    }
}
function $939c0c8d3a4d7175$var$x(n) {
    (!n.__d && (n.__d = !0) && $939c0c8d3a4d7175$var$i.push(n) && !$939c0c8d3a4d7175$var$C.__r++ || $939c0c8d3a4d7175$var$o !== $939c0c8d3a4d7175$export$41c562ebe57d11e2.debounceRendering) && (($939c0c8d3a4d7175$var$o = $939c0c8d3a4d7175$export$41c562ebe57d11e2.debounceRendering) || $939c0c8d3a4d7175$var$r)($939c0c8d3a4d7175$var$C);
}
function $939c0c8d3a4d7175$var$C() {
    var n, u, t, o = [], r = [];
    for($939c0c8d3a4d7175$var$i.sort($939c0c8d3a4d7175$var$f); n = $939c0c8d3a4d7175$var$i.shift();)n.__d && (t = $939c0c8d3a4d7175$var$i.length, u = $939c0c8d3a4d7175$var$w(n, o, r) || u, 0 === t || $939c0c8d3a4d7175$var$i.length > t ? ($939c0c8d3a4d7175$var$j(o, u, r), r.length = o.length = 0, u = void 0, $939c0c8d3a4d7175$var$i.sort($939c0c8d3a4d7175$var$f)) : u && $939c0c8d3a4d7175$export$41c562ebe57d11e2.__c && $939c0c8d3a4d7175$export$41c562ebe57d11e2.__c(u, $939c0c8d3a4d7175$var$s));
    u && $939c0c8d3a4d7175$var$j(o, u, r), $939c0c8d3a4d7175$var$C.__r = 0;
}
function $939c0c8d3a4d7175$var$P(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $939c0c8d3a4d7175$var$s, b = l.length;
    for(u.__d = e, $939c0c8d3a4d7175$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $939c0c8d3a4d7175$var$c : g[y.__i] || $939c0c8d3a4d7175$var$c, y.__i = v, $939c0c8d3a4d7175$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $939c0c8d3a4d7175$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $939c0c8d3a4d7175$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $939c0c8d3a4d7175$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $939c0c8d3a4d7175$var$d(null, i, null, null, null) : $939c0c8d3a4d7175$var$h(i) ? $939c0c8d3a4d7175$var$d($939c0c8d3a4d7175$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $939c0c8d3a4d7175$var$d(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $939c0c8d3a4d7175$var$I(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r ? f == r - 1 && (a = f - r) : a = 0, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $939c0c8d3a4d7175$var$m(o)), $939c0c8d3a4d7175$var$O(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $939c0c8d3a4d7175$var$m(o)), $939c0c8d3a4d7175$var$O(o, o));
}
function $939c0c8d3a4d7175$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $939c0c8d3a4d7175$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $939c0c8d3a4d7175$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($939c0c8d3a4d7175$var$h(n) ? n.some(function(n) {
        $939c0c8d3a4d7175$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $939c0c8d3a4d7175$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $939c0c8d3a4d7175$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $939c0c8d3a4d7175$var$a.test(l) ? u : u + "px";
}
function $939c0c8d3a4d7175$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $939c0c8d3a4d7175$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $939c0c8d3a4d7175$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $939c0c8d3a4d7175$var$L : $939c0c8d3a4d7175$var$D, o)) : n.removeEventListener(l, o ? $939c0c8d3a4d7175$var$L : $939c0c8d3a4d7175$var$D, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $939c0c8d3a4d7175$var$D(n) {
    if (this.l) {
        var u = this.l[n.type + !1];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($939c0c8d3a4d7175$export$41c562ebe57d11e2.event ? $939c0c8d3a4d7175$export$41c562ebe57d11e2.event(n) : n);
    }
}
function $939c0c8d3a4d7175$var$L(n) {
    if (this.l) return this.l[n.type + !0]($939c0c8d3a4d7175$export$41c562ebe57d11e2.event ? $939c0c8d3a4d7175$export$41c562ebe57d11e2.event(n) : n);
}
function $939c0c8d3a4d7175$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $939c0c8d3a4d7175$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $939c0c8d3a4d7175$export$16fa2f45be04daa8(k, C), p.constructor = A, p.render = $939c0c8d3a4d7175$var$q), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $939c0c8d3a4d7175$var$v({}, p.__s)), $939c0c8d3a4d7175$var$v(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $939c0c8d3a4d7175$export$41c562ebe57d11e2.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $939c0c8d3a4d7175$var$v($939c0c8d3a4d7175$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $939c0c8d3a4d7175$var$P(n, $939c0c8d3a4d7175$var$h(T = null != a && a.type === $939c0c8d3a4d7175$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $939c0c8d3a4d7175$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $939c0c8d3a4d7175$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $939c0c8d3a4d7175$export$41c562ebe57d11e2.diffed) && a(u);
}
function $939c0c8d3a4d7175$var$j(n, u, t) {
    for(var i = 0; i < t.length; i++)$939c0c8d3a4d7175$var$N(t[i], t[++i], t[++i]);
    $939c0c8d3a4d7175$export$41c562ebe57d11e2.__c && $939c0c8d3a4d7175$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $939c0c8d3a4d7175$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $939c0c8d3a4d7175$var$z(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = !0), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = !1;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $939c0c8d3a4d7175$var$n.call(l.childNodes), w = t.props || $939c0c8d3a4d7175$var$c, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $939c0c8d3a4d7175$var$A(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $939c0c8d3a4d7175$var$A(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $939c0c8d3a4d7175$var$P(l, $939c0c8d3a4d7175$var$h(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $939c0c8d3a4d7175$var$m(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $939c0c8d3a4d7175$var$p(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $939c0c8d3a4d7175$var$A(l, a, g, w[a], !1), a = "checked", void 0 !== b && b !== l[a] && $939c0c8d3a4d7175$var$A(l, a, b, w[a], !1));
    }
    return l;
}
function $939c0c8d3a4d7175$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $939c0c8d3a4d7175$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $939c0c8d3a4d7175$var$O(n, u, t) {
    var i, o;
    if ($939c0c8d3a4d7175$export$41c562ebe57d11e2.unmount && $939c0c8d3a4d7175$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $939c0c8d3a4d7175$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $939c0c8d3a4d7175$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $939c0c8d3a4d7175$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $939c0c8d3a4d7175$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $939c0c8d3a4d7175$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $939c0c8d3a4d7175$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $939c0c8d3a4d7175$export$41c562ebe57d11e2.__ && $939c0c8d3a4d7175$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $939c0c8d3a4d7175$var$M(t, u = (!o && i || t).__k = $939c0c8d3a4d7175$export$c8a8987d4410bf2d($939c0c8d3a4d7175$export$ffb0004e005737fa, null, [
        u
    ]), r || $939c0c8d3a4d7175$var$c, $939c0c8d3a4d7175$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $939c0c8d3a4d7175$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), u.__d = void 0, $939c0c8d3a4d7175$var$j(f, u, e);
}
function $939c0c8d3a4d7175$export$fa8d919ba61d84db(n, l) {
    $939c0c8d3a4d7175$export$b3890eb0ae9dca99(n, l, $939c0c8d3a4d7175$export$fa8d919ba61d84db);
}
function $939c0c8d3a4d7175$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $939c0c8d3a4d7175$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $939c0c8d3a4d7175$var$n.call(arguments, 2) : t), $939c0c8d3a4d7175$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $939c0c8d3a4d7175$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $939c0c8d3a4d7175$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $939c0c8d3a4d7175$var$x(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$939c0c8d3a4d7175$var$n = $939c0c8d3a4d7175$var$s.slice, $939c0c8d3a4d7175$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $939c0c8d3a4d7175$var$u = 0, $939c0c8d3a4d7175$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $939c0c8d3a4d7175$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $939c0c8d3a4d7175$var$v({}, this.state), "function" == typeof n && (n = n($939c0c8d3a4d7175$var$v({}, u), this.props)), n && $939c0c8d3a4d7175$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $939c0c8d3a4d7175$var$x(this));
}, $939c0c8d3a4d7175$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $939c0c8d3a4d7175$var$x(this));
}, $939c0c8d3a4d7175$export$16fa2f45be04daa8.prototype.render = $939c0c8d3a4d7175$export$ffb0004e005737fa, $939c0c8d3a4d7175$var$i = [], $939c0c8d3a4d7175$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $939c0c8d3a4d7175$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $939c0c8d3a4d7175$var$C.__r = 0, $939c0c8d3a4d7175$var$e = 0;


var $7547aaeb0ecd0855$var$t = /["&<]/;
function $7547aaeb0ecd0855$var$n(r) {
    if (0 === r.length || !1 === $7547aaeb0ecd0855$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $7547aaeb0ecd0855$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $7547aaeb0ecd0855$var$f = 0, $7547aaeb0ecd0855$var$i = Array.isArray;
function $7547aaeb0ecd0855$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    var a, c, p = {};
    for(c in t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: --$7547aaeb0ecd0855$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $939c0c8d3a4d7175$export$41c562ebe57d11e2).vnode && (0, $939c0c8d3a4d7175$export$41c562ebe57d11e2).vnode(l), l;
}
function $7547aaeb0ecd0855$export$45700d561b2268ac(r) {
    var t = $7547aaeb0ecd0855$export$34b9dba7ce09269b((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $7547aaeb0ecd0855$var$c = {}, $7547aaeb0ecd0855$var$p = /[A-Z]/g;
function $7547aaeb0ecd0855$export$991f6ffe102e5bac(e, t) {
    if ((0, $939c0c8d3a4d7175$export$41c562ebe57d11e2).attr) {
        var f = (0, $939c0c8d3a4d7175$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if ("ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $7547aaeb0ecd0855$var$c[u] || ($7547aaeb0ecd0855$var$c[u] = u.replace($7547aaeb0ecd0855$var$p, "-$&").toLowerCase()), _ = ";";
                "number" != typeof a || l.startsWith("--") || $7547aaeb0ecd0855$var$o.test(l) || (_ = "px;"), i = i + l + ":" + a + _;
            }
        }
        return e + '="' + i + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $7547aaeb0ecd0855$var$n(t) + '"';
}
function $7547aaeb0ecd0855$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($7547aaeb0ecd0855$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $7547aaeb0ecd0855$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $7547aaeb0ecd0855$var$n("" + r);
}


var $c0eb5bd78d5dce59$exports = {};




// Generated by CoffeeScript 1.12.7
(function() {
    "use strict";
    var builder, defaults, parser, processors, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    defaults = (parcelRequire("7E3cb"));
    builder = (parcelRequire("fpj45"));
    parser = (parcelRequire("lUgJQ"));
    processors = (parcelRequire("aUA6y"));
    $c0eb5bd78d5dce59$exports.defaults = defaults.defaults;
    $c0eb5bd78d5dce59$exports.processors = processors;
    $c0eb5bd78d5dce59$exports.ValidationError = function(superClass) {
        extend(ValidationError, superClass);
        function ValidationError(message) {
            this.message = message;
        }
        return ValidationError;
    }(Error);
    $c0eb5bd78d5dce59$exports.Builder = builder.Builder;
    $c0eb5bd78d5dce59$exports.Parser = parser.Parser;
    $c0eb5bd78d5dce59$exports.parseString = parser.parseString;
    $c0eb5bd78d5dce59$exports.parseStringPromise = parser.parseStringPromise;
}).call($c0eb5bd78d5dce59$exports);



!function(e, t) {
    t();
}(0, function() {
    "use strict";
    function e(e) {
        var t = !0, n = !1, o = null, d = {
            text: !0,
            search: !0,
            url: !0,
            tel: !0,
            email: !0,
            password: !0,
            number: !0,
            date: !0,
            month: !0,
            week: !0,
            time: !0,
            datetime: !0,
            "datetime-local": !0
        };
        function i(e) {
            return !!(e && e !== document && "HTML" !== e.nodeName && "BODY" !== e.nodeName && "classList" in e && "contains" in e.classList);
        }
        function s(e) {
            e.classList.contains("focus-visible") || (e.classList.add("focus-visible"), e.setAttribute("data-focus-visible-added", ""));
        }
        function u(e) {
            t = !1;
        }
        function a() {
            document.addEventListener("mousemove", c), document.addEventListener("mousedown", c), document.addEventListener("mouseup", c), document.addEventListener("pointermove", c), document.addEventListener("pointerdown", c), document.addEventListener("pointerup", c), document.addEventListener("touchmove", c), document.addEventListener("touchstart", c), document.addEventListener("touchend", c);
        }
        function c(e) {
            e.target.nodeName && "html" === e.target.nodeName.toLowerCase() || (t = !1, document.removeEventListener("mousemove", c), document.removeEventListener("mousedown", c), document.removeEventListener("mouseup", c), document.removeEventListener("pointermove", c), document.removeEventListener("pointerdown", c), document.removeEventListener("pointerup", c), document.removeEventListener("touchmove", c), document.removeEventListener("touchstart", c), document.removeEventListener("touchend", c));
        }
        document.addEventListener("keydown", function(n) {
            n.metaKey || n.altKey || n.ctrlKey || (i(e.activeElement) && s(e.activeElement), t = !0);
        }, !0), document.addEventListener("mousedown", u, !0), document.addEventListener("pointerdown", u, !0), document.addEventListener("touchstart", u, !0), document.addEventListener("visibilitychange", function(e) {
            "hidden" === document.visibilityState && (n && (t = !0), a());
        }, !0), a(), e.addEventListener("focus", function(e) {
            var n, o, u;
            i(e.target) && (t || (n = e.target, o = n.type, "INPUT" === (u = n.tagName) && d[o] && !n.readOnly || "TEXTAREA" === u && !n.readOnly || n.isContentEditable)) && s(e.target);
        }, !0), e.addEventListener("blur", function(e) {
            var t;
            i(e.target) && (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) && (n = !0, window.clearTimeout(o), o = window.setTimeout(function() {
                n = !1;
            }, 100), (t = e.target).hasAttribute("data-focus-visible-added") && (t.classList.remove("focus-visible"), t.removeAttribute("data-focus-visible-added")));
        }, !0), e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.host ? e.host.setAttribute("data-js-focus-visible", "") : e.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }
    if ("undefined" != typeof window && "undefined" != typeof document) {
        var t;
        window.applyFocusVisiblePolyfill = e;
        try {
            t = new CustomEvent("focus-visible-polyfill-ready");
        } catch (e) {
            (t = document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
        }
        window.dispatchEvent(t);
    }
    "undefined" != typeof document && e(document);
});





const $5fecb737de9f1b0a$export$47c024def8e5035b = (props)=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h2", {
                class: "mt-2 mb-1",
                children: "Voies de recours"
            }),
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                children: [
                    "Vous avez signal\xe9 au responsable du site internet un d\xe9faut d'accessibilit\xe9 qui vous emp\xeache d'acc\xe9der \xe0 un contenu ou \xe0 un des services du portail et vous n'avez pas obtenu de r\xe9ponse satisfaisante, dans ce cas\xa0:",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                class: "list",
                children: [
                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                        children: [
                            "\xc9crire un message au ",
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                href: "https://formulaire.defenseurdesdroits.fr/formulaire_saisine/",
                                target: "_blank",
                                title: "D\xe9fenseur des droits (nouvelle fen\xeatre)",
                                children: "D\xe9fenseur des droits"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                        children: [
                            "Contacter le ",
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                href: "https://www.defenseurdesdroits.fr/carte-des-delegues",
                                target: "_blank",
                                title: "d\xe9l\xe9gu\xe9 du D\xe9fenseur des droits dans votre r\xe9gion (nouvelle fen\xeatre)",
                                children: "d\xe9l\xe9gu\xe9 du D\xe9fenseur des droits dans votre r\xe9gion"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                        children: [
                            "Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre)",
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("br", {}),
                            "D\xe9fenseur des droits",
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("br", {}),
                            "Libre r\xe9ponse 71120",
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("br", {}),
                            "75342 Paris CEDEX 07"
                        ]
                    })
                ]
            })
        ]
    });
};




const $c354922333f7ddf6$export$5e101e6255c12710 = ({ content: content })=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h2", {
                className: "mt-2 mb-1",
                children: "Retour d'information et contact"
            }),
            content ? /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                dangerouslySetInnerHTML: {
                    __html: content
                }
            }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                    children: [
                        "Si vous n'arrivez pas \xe0 acc\xe9der \xe0 un contenu ou \xe0 un service, vous pouvez contacter le responsable du site pour \xeatre orient\xe9 vers une alternative accessible ou obtenir le contenu sous une autre forme.",
                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                            class: "list",
                            children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                children: [
                                    "Envoyer un message \xe0 ",
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                        href: "mailto:accessibilite.france@orange.com",
                                        children: "accessibilite.france@orange.com"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};




const $a20371a83a71fd9c$export$814cc77def5a44df = ({ plan: plan, title: title })=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
        children: plan ? /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            dangerouslySetInnerHTML: {
                __html: $a20371a83a71fd9c$var$replaceServiceName(plan, title)
            }
        }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            children: [
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                    children: "Orange s'engage \xe0 rendre ses sites internet, intranet, extranet, ses progiciels, ses applications mobiles et mobilier urbain num\xe9rique accessibles\xa0conform\xe9ment \xe0 l'article 47 de la loi n\xb02005-102 du 11 f\xe9vrier 2005."
                }),
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                    children: [
                        "\xc0 cette fin,\xa0Orange\xa0met en \u0153uvre la strat\xe9gie et les actions suivantes\xa0:",
                        " ",
                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                            href: "https://oran.ge/accessibilite-schema",
                            title: "sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique 2024-2026 (PDF, 230Ko - nouvelle fen\xeatre)",
                            target: "_blank",
                            children: "Sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique 2024-2026 (PDF, 230Ko)"
                        }),
                        "."
                    ]
                }),
                title ? /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                    children: [
                        "Cette d\xe9claration d'accessibilit\xe9 s'applique \xe0 ",
                        title,
                        "."
                    ]
                }) : ""
            ]
        })
    });
};
const $a20371a83a71fd9c$var$replaceServiceName = (plan, title)=>{
    return plan.replace(/\[nom du service concerné\]/g, title);
};




const $52df0947391178d6$export$1a50ff47e262ae90 = ({ details: details, nonComplianceComment: nonComplianceComment })=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                class: "h3 mb-1 mt-2",
                children: "Non-conformit\xe9s"
            }),
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                dangerouslySetInnerHTML: {
                    __html: nonComplianceComment
                }
            }),
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                children: [
                    "Liste des crit\xe8res ",
                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                        lang: "en",
                        title: "Web Content Accessibility Guidelines",
                        style: "speak: spell-out;",
                        children: "WCAG"
                    }),
                    " non conformes\xa0:"
                ]
            }),
            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                class: "list",
                children: Array.isArray(details.detail) ? details.detail.map((detail)=>{
                    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                        children: detail.title
                    });
                }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                    children: details.detail.title
                })
            })
        ]
    });
};



const $85a814d8ba30c5e8$export$7fe28cb29e71bf10 = (data)=>{
    const { approval: approval = {
        name: ""
    }, audit_date: audit_date = "", audit_updatedate: audit_updatedate = "", compliantStateComment: compliantStateComment = "", contact: contact = {
        name: "",
        content: ""
    }, derogations: derogations = "", details: details = {
        detail: []
    }, environments: environments = {
        environment: []
    }, exemptions: exemptions = "", nonComplianceComment: nonComplianceComment = "", pages_results: pages_results = {
        page: []
    }, plan: plan = "", referential: referential = {
        name: "",
        version: "",
        level: ""
    }, results: results = {
        result: []
    }, technologies: technologies = {
        technology: []
    }, tests: tests = {
        test: []
    }, title: title = "", urls: urls = {
        url: []
    } } = data;
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
        class: "site-width",
        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            class: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "header-wrapper mb-2 mb-md-3",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "container-fluid",
                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h1", {
                            class: "pb-0 mt-1 mt-md-2 mb-1 mb-md-2",
                            children: [
                                "D\xe9claration d'accessibilit\xe9 : ",
                                title
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "row",
                    children: [
                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                            class: "col-12 col-md-8",
                            children: [
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $a20371a83a71fd9c$export$814cc77def5a44df), {
                                    plan: plan,
                                    title: title
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h2", {
                                    class: "mb-1",
                                    children: "Etat de conformit\xe9"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)($85a814d8ba30c5e8$var$ConformityText, {
                                    conformity: pages_results.conformity,
                                    referential: referential,
                                    title: title,
                                    isExpired: $85a814d8ba30c5e8$var$isExpiredAudit(audit_date, audit_updatedate)
                                }),
                                compliantStateComment !== "" ? /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: compliantStateComment
                                    }
                                }) : "",
                                $85a814d8ba30c5e8$var$isExpiredAudit(audit_date, audit_updatedate) && /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
                                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "Pour information, voici les r\xe9sultats de la pr\xe9c\xe9dente d\xe9claration \xe9tablie le ",
                                            $85a814d8ba30c5e8$var$dateFormater(audit_date),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        "Orange utilise une autre m\xe9thode de test que le",
                                        " ",
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                            title: "R\xe9f\xe9rentiel g\xe9n\xe9ral d'am\xe9lioration de l'accessibilit\xe9",
                                            style: "speak: spell-out;",
                                            children: "RGAA"
                                        }),
                                        ", les",
                                        " ",
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                            lang: "en",
                                            title: "Web Content Accessibility Guidelines",
                                            style: "speak: spell-out;",
                                            children: "WCAG"
                                        }),
                                        " ",
                                        "version 2.2 niveaux A et AA. ",
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("br", {}),
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                            href: "https://a11y-guidelines.orange.com/fr/cadrage/correspondance-rgaa-wcag/",
                                            target: "_blank",
                                            title: "Consulter le tableau de correspondance entre les RGAA et les WCAG (nouvelle fen\xeatre)",
                                            children: [
                                                "Consulter le tableau de correspondance entre les",
                                                " ",
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                                    title: "R\xe9f\xe9rentiel g\xe9n\xe9ral d'am\xe9lioration de l'accessibilit\xe9",
                                                    style: "speak: spell-out;",
                                                    children: "RGAA"
                                                }),
                                                " ",
                                                "et les",
                                                " ",
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                                    lang: "en",
                                                    title: "Web Content Accessibility Guidelines",
                                                    style: "speak: spell-out;",
                                                    children: "WCAG"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        "L'audit a \xe9t\xe9 effectu\xe9 via la",
                                        " ",
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                            href: "https://la-va11ydette.orange.com/",
                                            target: "_blank",
                                            title: "Va11ydette d'Orange (nouvelle fen\xeatre)",
                                            children: "Va11ydette d'Orange."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "R\xe9sultat des tests"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                    class: "d-flex mt-1 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                            class: "text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h4", {
                                                    class: "pie",
                                                    "data-value": $85a814d8ba30c5e8$var$global_conformity(results),
                                                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                                        class: "pie-val",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                class: "sr-only",
                                                                children: "Conformit\xe9 globale"
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                children: [
                                                                    $85a814d8ba30c5e8$var$global_conformity(results),
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("strong", {
                                                    class: "mt-1 d-block",
                                                    "aria-hidden": "true",
                                                    children: "Conformit\xe9 globale"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                            class: "ml-3 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h4", {
                                                    class: "pie",
                                                    "data-value": pages_results.conformity,
                                                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                                        class: "pie-val",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                class: "sr-only",
                                                                children: "Conformit\xe9 moyenne"
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                children: [
                                                                    pages_results.conformity,
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("strong", {
                                                    class: "mt-1 d-block",
                                                    "aria-hidden": "true",
                                                    children: "Conformit\xe9 moyenne"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        "L'audit de conformit\xe9 r\xe9alis\xe9 en interne par ",
                                        approval.name,
                                        " r\xe9v\xe8le que\xa0:"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                                    class: "list",
                                    children: [
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                            children: [
                                                $85a814d8ba30c5e8$var$global_conformity(results),
                                                "% des crit\xe8res",
                                                " ",
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                                    lang: "en",
                                                    title: "Web Content Accessibility Guidelines",
                                                    style: "speak: spell-out;",
                                                    children: "WCAG"
                                                }),
                                                " ",
                                                "de niveau A et AA sont respect\xe9s."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                            children: [
                                                "Le taux moyen de conformit\xe9 du service en ligne s'\xe9l\xe8ve \xe0 ",
                                                pages_results.conformity,
                                                "%."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                            class: "col-12 col-md-8 col-lg-6",
                            children: [
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h4", {
                                    class: "h3 mb-1 mt-3",
                                    id: "title-table-synthesis",
                                    children: "Synth\xe8se par niveau"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("table", {
                                    class: "table",
                                    "aria-labelledby": "title-table-synthesis",
                                    dangerouslySetInnerHTML: {
                                        __html: $85a814d8ba30c5e8$var$synthesis_table(results)
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                            class: "col-12",
                            children: [
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h4", {
                                    class: "h3 mb-1 mt-3",
                                    "aria-hidden": "true",
                                    id: "title-table-taux",
                                    children: "Taux de conformit\xe9 par page selon les deux niveaux de crit\xe8res A et AA"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                    class: "slider-table",
                                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("table", {
                                        class: "table",
                                        "aria-labelledby": "title-table-taux",
                                        children: [
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("caption", {
                                                class: "sr-only",
                                                children: "Taux de conformit\xe9 par page selon les deux niveaux de crit\xe8res A et AA"
                                            }),
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("thead", {
                                                children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "row",
                                                            children: "Crit\xe8res/Niveau"
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: [
                                                                "Conforme / ",
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "A"
                                                                }),
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    class: "sr-only leftZero",
                                                                    children: "Niveau un A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: [
                                                                "Conforme / ",
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "AA"
                                                                }),
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    class: "sr-only leftZero",
                                                                    children: "Niveau deux A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: [
                                                                "Non conforme / ",
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "A"
                                                                }),
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    class: "sr-only leftZero",
                                                                    children: "Niveau un A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: [
                                                                "Non conforme / ",
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "AA"
                                                                }),
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    class: "sr-only leftZero",
                                                                    children: "Niveau deux A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: [
                                                                "Non applicable / ",
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "A"
                                                                }),
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    class: "sr-only leftZero",
                                                                    children: "Niveau un A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: [
                                                                "Non applicable / ",
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "AA"
                                                                }),
                                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                                    class: "sr-only leftZero",
                                                                    children: "Niveau deux A"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "col",
                                                            children: "Taux de conformit\xe9"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("tbody", {
                                                children: Array.isArray(pages_results.page) ? pages_results.page.map((page)=>/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                                scope: "row",
                                                                children: page.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: page.ok[0]["_"]
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: page.ok[1]["_"]
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: page.nok[0]["_"]
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: page.nok[1]["_"]
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: page.na[0]["_"]
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: page.na[1]["_"]
                                                            }),
                                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                                children: [
                                                                    page.conformity,
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    })) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("th", {
                                                            scope: "row",
                                                            children: pages_results.page.name
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: pages_results.page.ok[0]["_"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: pages_results.page.ok[1]["_"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: pages_results.page.nok[0]["_"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: pages_results.page.nok[1]["_"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: pages_results.page.na[0]["_"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: pages_results.page.na[1]["_"]
                                                        }),
                                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("td", {
                                                            children: [
                                                                pages_results.page.conformity,
                                                                "%"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                            class: "col-12 col-md-8",
                            children: [
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h2", {
                                    class: "mt-2 mb-1 mt-md-3",
                                    children: "Contenus non accessibles"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: "Les contenus list\xe9s ci-dessous ne sont pas accessibles pour les raisons suivantes\xa0:"
                                }),
                                details !== "" && /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $52df0947391178d6$export$1a50ff47e262ae90), {
                                    details: details,
                                    nonComplianceComment: nonComplianceComment
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "D\xe9rogations pour charge disproportionn\xe9e"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: derogations !== "" ? derogations : "(Aucune)"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "Contenus non soumis \xe0 l'obligation d'accessibilit\xe9"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: exemptions !== "" ? exemptions : "(Aucune)"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h2", {
                                    class: "mb-1 mt-2",
                                    children: "\xc9tablissement de cette d\xe9claration d'accessibilit\xe9"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        "Cette d\xe9claration a \xe9t\xe9 \xe9tablie le ",
                                        $85a814d8ba30c5e8$var$dateFormater(audit_date),
                                        ". ",
                                        audit_updatedate !== "" ? `Elle a \xe9t\xe9 mise \xe0 jour le ${$85a814d8ba30c5e8$var$dateFormater(audit_updatedate)}.` : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "Technologies utilis\xe9es pour la r\xe9alisation du site web"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                                    class: "list",
                                    children: Array.isArray(technologies.technology) ? technologies.technology.map((tech)=>{
                                        return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                            children: tech
                                        });
                                    }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                        children: technologies.technology
                                    })
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "Environnement de test"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: "Agents utilisateurs, technologies d'assistance et outils utilis\xe9s pour v\xe9rifier l'accessibilit\xe9"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                                    class: "list",
                                    children: Array.isArray(environments.environment) ? environments.environment.map((env)=>{
                                        return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                            children: env
                                        });
                                    }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                        children: environments.environment
                                    })
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "Outils utilis\xe9s lors de l'\xe9valuation"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                                    class: "list",
                                    children: $85a814d8ba30c5e8$var$groupTestsByType(tests.test).map((test)=>{
                                        return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("strong", {
                                                    children: test.type
                                                }),
                                                " : ",
                                                test.outils
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h3", {
                                    class: "h3 mb-1 mt-2",
                                    children: "Page(s) ayant fait l'objet de la v\xe9rification de conformit\xe9"
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        "L'audit de v\xe9rification a \xe9t\xe9 effectu\xe9 sur les pages suivantes \xe0 l'aide de la ",
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                            href: "https://la-va11ydette.orange.com/",
                                            children: "va11ydette d'Orange"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("ul", {
                                    class: "list",
                                    children: Array.isArray(urls.url) ? urls.url.map((url)=>{
                                        return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                            children: url.location ? /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                                href: url.location,
                                                target: "_blank",
                                                title: `${url.name} (nouvelle fen\xeatre)`,
                                                children: url.name
                                            }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                children: url.name
                                            })
                                        });
                                    }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("li", {
                                        children: urls.url.location ? /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                            href: urls.url.location,
                                            target: "_blank",
                                            title: `${urls.url.name} (nouvelle fen\xeatre)`,
                                            children: urls.url.name
                                        }) : /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                            children: urls.url.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $c354922333f7ddf6$export$5e101e6255c12710), {
                                    ...contact
                                }),
                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $5fecb737de9f1b0a$export$47c024def8e5035b), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $85a814d8ba30c5e8$var$ConformityText = ({ conformity: conformity, referential: referential, title: title, isExpired: isExpired })=>{
    let conformityInt = parseInt(conformity);
    let level = referential.level === "A" ? "A" : "A et AA";
    switch(true){
        case conformityInt === 100 && !isExpired:
            return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                children: [
                    title,
                    " est totalement conforme aux crit\xe8res ",
                    referential.name,
                    " version ",
                    referential.version,
                    " de niveau ",
                    level,
                    ", en raison des d\xe9rogations \xe9num\xe9r\xe9es ci-dessous."
                ]
            });
        case conformityInt >= 50 && !isExpired:
            return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                children: [
                    title,
                    " est partiellement conforme aux crit\xe8res ",
                    referential.name,
                    " version ",
                    referential.version,
                    " de niveau ",
                    level,
                    ", en raison des non-conformit\xe9s et des d\xe9rogations \xe9num\xe9r\xe9es ci-dessous."
                ]
            });
        case conformityInt < 50 && !isExpired:
            return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
                children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                    children: [
                        title,
                        " est non conforme aux crit\xe8res ",
                        referential.name,
                        " version ",
                        referential.version,
                        " de niveau ",
                        level,
                        ", en raison des non-conformit\xe9s et des d\xe9rogations \xe9num\xe9r\xe9es ci-dessous."
                    ]
                })
            });
        case isExpired:
            return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $939c0c8d3a4d7175$export$ffb0004e005737fa), {
                children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                    children: [
                        title,
                        " est non conforme aux crit\xe8res ",
                        referential.name,
                        " version ",
                        referential.version,
                        " de niveau ",
                        level,
                        ", car il n'existe aucun r\xe9sultat d'audit de conformit\xe9 en cours de validit\xe9."
                    ]
                })
            });
    }
};
const $85a814d8ba30c5e8$var$isExpiredAudit = (auditDate, updateDate)=>{
    const THREE_YEARS_IN_MS = 94608000000 // 3 years in milliseconds
    ;
    const now = new Date();
    let comparisonDate;
    if (updateDate) comparisonDate = new Date(updateDate);
    else comparisonDate = new Date(auditDate);
    return now.getTime() - comparisonDate.getTime() > THREE_YEARS_IN_MS;
};
const $85a814d8ba30c5e8$var$global_conformity = (results)=>{
    let total = 0;
    results.result.forEach((result)=>{
        if (result.type === "total") total = result.conformity;
    });
    return total;
};
const $85a814d8ba30c5e8$var$synthesis_table = (results)=>{
    // En-têtes de table
    let html = '<thead><tr><th scope="row">Niveau</th>';
    results.result.forEach((item)=>{
        let displayType;
        if (item.type === "a") displayType = '<span aria-hidden="true">A</span><span class="sr-only">Niveau un A</span>';
        else if (item.type === "aa") displayType = '<span aria-hidden="true">AA</span><span class="sr-only">Niveau deux A</span>';
        else if (item.type === "total") displayType = item.type.charAt(0).toUpperCase() + item.type.slice(1);
        else displayType = item.type;
        html += `<th scope="col">${displayType}</th>`;
    });
    html += "</tr></thead><tbody>";
    // Lignes de table
    let rows = [
        {
            data: "criteria",
            label: "Nombre de crit\xe8res"
        },
        {
            data: "ok",
            label: "Conforme"
        },
        {
            data: "nok",
            label: "Non conforme"
        },
        {
            data: "na",
            label: "Non applicable"
        },
        {
            data: "conformity",
            label: "Conformit\xe9"
        }
    ];
    rows.forEach((row)=>{
        html += `<tr><th scope="row">${row.label}</th>`;
        results.result.forEach((item)=>{
            html += `<td>${item[row.data]}${row.data === "conformity" ? "%" : ""}</td>`;
        });
        html += "</tr>";
    });
    html += "</tbody>";
    return html;
};
const $85a814d8ba30c5e8$var$dateFormater = (date)=>{
    let parts = date.split("-");
    let newDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return newDate;
};
const $85a814d8ba30c5e8$var$groupTestsByType = (tests)=>{
    let groupedTests = {};
    tests.forEach((test)=>{
        let type;
        switch(test.type){
            case "auto":
                type = "Tests automatiques";
                break;
            case "manual":
                type = "Tests manuels";
                break;
            case "functional":
                type = "Tests fonctionnels";
                break;
            default:
                type = test.type;
        }
        if (!groupedTests[type]) groupedTests[type] = [];
        groupedTests[type].push(`${test.name} ${test.version}`);
    });
    let result = [];
    for(let type in groupedTests)result.push({
        type: type,
        outils: groupedTests[type].join(", ")
    });
    return result;
};






const $6e98a49c31ebe60d$export$271f9f08425019c7 = ({ url: url = "" })=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
        class: "site-width",
        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            class: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "header-wrapper mb-2 mb-md-3",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "container-fluid",
                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h1", {
                            class: "pb-0 mt-1 mt-md-2 mb-1 mb-md-2",
                            children: [
                                "D\xe9claration d'accessibilit\xe9 : ",
                                url
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "row",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "col-12 col-md-10 col-xl-8",
                        children: [
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                class: "alert-container alert-info mb-2",
                                role: "alert",
                                children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    class: "alert",
                                    children: [
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                            class: "alert-icon icon-info",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                            class: "text-mw",
                                            children: "La page d'o\xf9 vous venez n'a pas encore fait l'objet d'un audit de conformit\xe9."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $a20371a83a71fd9c$export$814cc77def5a44df), {
                                title: url
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h2", {
                                class: "mt-2",
                                children: "Etat de conformit\xe9"
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                children: [
                                    url,
                                    " est non conforme aux crit\xe8res",
                                    " ",
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                        lang: "en",
                                        title: "Web Content Accessibility Guidelines",
                                        style: "speak: spell-out;",
                                        children: "WCAG"
                                    }),
                                    " ",
                                    "version 2.2 de niveau A et AA, car il n'existe aucun r\xe9sultat d'audit de conformit\xe9 en cours de validit\xe9 permettant de mesurer les crit\xe8res."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Orange utilise une autre m\xe9thode de test que le",
                                    " ",
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                        title: "R\xe9f\xe9rentiel g\xe9n\xe9ral d'am\xe9lioration de l'accessibilit\xe9",
                                        style: "speak: spell-out;",
                                        children: "RGAA"
                                    }),
                                    ", les WCAG version 2.2 niveaux A et AA. ",
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("br", {}),
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                        href: "https://a11y-guidelines.orange.com/fr/cadrage/correspondance-rgaa-wcag/",
                                        target: "_blank",
                                        title: "Consulter le tableau de correspondance entre les RGAA et les WCAG (nouvelle fen\xeatre)",
                                        children: [
                                            "Consulter le tableau de correspondance entre les",
                                            " ",
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                                title: "R\xe9f\xe9rentiel g\xe9n\xe9ral d'am\xe9lioration de l'accessibilit\xe9",
                                                style: "speak: spell-out;",
                                                children: "RGAA"
                                            }),
                                            " ",
                                            "et les",
                                            " ",
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("abbr", {
                                                lang: "en",
                                                title: "Web Content Accessibility Guidelines",
                                                style: "speak: spell-out;",
                                                children: "WCAG"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $c354922333f7ddf6$export$5e101e6255c12710), {}),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $5fecb737de9f1b0a$export$47c024def8e5035b), {})
                        ]
                    })
                })
            ]
        })
    });
};



const $fc14f12ad6de2ebf$export$a08c9fc854caa58b = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
        class: "site-width",
        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            class: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "header-wrapper mb-2 mb-md-3",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "container-fluid",
                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h1", {
                            class: "pb-0 mt-1 mt-md-2 mb-1 mb-md-2",
                            children: [
                                "D\xe9claration d'accessibilit\xe9 : ",
                                title
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "row",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "col-12 col-md-10 col-xl-8",
                        children: [
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                class: "alert-container alert-info mb-2",
                                role: "alert",
                                children: [
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                        class: "alert",
                                        children: [
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                class: "alert-icon icon-info",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                class: "text-mw",
                                                children: "Ce site est en cours de refonte, nous publierons la d\xe9claration associ\xe9e d\xe8s que possible."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                        class: "alert-content",
                                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                            class: "alert-text",
                                            children: [
                                                "Vous pouvez nous aider \xe0 am\xe9liorer l'accessibilit\xe9 du site en nous signalant les probl\xe8mes \xe9ventuels que vous rencontrez. Pour ce faire,",
                                                " ",
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                                    href: "mailto:accessibilite.france@orange.com",
                                                    children: "envoyez-nous un courriel \xe0 accessibilite.france@orange.com"
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Vous pouvez vous informer sur le",
                                    " ",
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                        href: "https://oran.ge/accessibilite-schema",
                                        target: "_blank",
                                        title: "sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique (nouvelle fen\xeatre : PDF, 230Ko)",
                                        "aria-label": "sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique (nouvelle fen\xeatre : PDF, 230Ko)",
                                        children: "sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique (nouvelle fen\xeatre : PDF, 230Ko)"
                                    }),
                                    " ",
                                    "sur lequel s'engage Orange."
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};



const $0d7a12686956c975$export$edf27be85e5f6da0 = (props)=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
        class: "site-width",
        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            class: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "header-wrapper mb-2 mb-md-3",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "container-fluid",
                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h1", {
                            class: "pb-0 mt-1 mt-md-2 mb-1 mb-md-2",
                            children: "D\xe9claration d'accessibilit\xe9"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "row",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "col-12 col-md-10 col-xl-8",
                        children: [
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                class: "alert-container alert-danger mb-2",
                                role: "alert",
                                children: [
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                        class: "alert",
                                        children: [
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                class: "alert-icon icon-error-severe",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                                class: "text-mw",
                                                children: "Il y a une erreur dans votre requ\xeate (la page n'appartient pas au domaine Orange France ou Sosh), nous ne pouvons pas afficher de d\xe9claration."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                        class: "alert-content",
                                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                            class: "alert-text",
                                            children: [
                                                "Si vous pensez qu'il s'agit d'un dysfonctionnement, n'h\xe9sitez \xe0 ",
                                                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                                    href: "mailto:accessibilite.france@orange.com",
                                                    children: "nous le signaler en nous envoyant un courriel"
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                children: "Orange s'engage \xe0 rendre ses sites internet, intranet, extranet, ses progiciels, ses applications mobiles et mobilier urbain num\xe9rique accessibles\xa0conform\xe9ment \xe0 l'article 47 de la loi n\xb02005-102 du 11 f\xe9vrier 2005."
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "\xc0 cette fin,\xa0Orange\xa0met en \u0153uvre la strat\xe9gie et les actions suivantes\xa0:",
                                    " ",
                                    /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("a", {
                                        href: "https://oran.ge/accessibilite-schema",
                                        title: "sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique 2024-2026 (PDF, 230Ko - nouvelle fen\xeatre)",
                                        target: "_blank",
                                        children: "Sch\xe9ma pluriannuel d'am\xe9lioration de l'accessibilit\xe9 num\xe9rique 2024-2026 (PDF, 230Ko)"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};






const $312d954682092271$export$521b0bfdf8dc9144 = (props)=>{
    return /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
        class: "site-width",
        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
            class: "container-fluid",
            children: [
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "header-wrapper mb-2 mb-md-3",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "container-fluid",
                        children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("h1", {
                            class: "pb-0 mt-1 mt-md-2 mb-1 mb-md-2",
                            children: "D\xe9claration d'accessibilit\xe9"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                    class: "row",
                    children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                        class: "col-12 col-md-10 col-xl-8",
                        children: [
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("div", {
                                class: "alert-container alert-info mb-2",
                                role: "alert",
                                children: /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("p", {
                                    class: "alert",
                                    children: [
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                            class: "alert-icon icon-info",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)("span", {
                                            class: "text-mw",
                                            children: "Il y a une erreur dans votre requ\xeate, la page n'appartient pas au domaine Orange France ou Sosh, nous ne pouvons pas afficher de d\xe9claration."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $a20371a83a71fd9c$export$814cc77def5a44df), {}),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $c354922333f7ddf6$export$5e101e6255c12710), {}),
                            /*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $5fecb737de9f1b0a$export$47c024def8e5035b), {})
                        ]
                    })
                })
            ]
        })
    });
};


function $822810191707f6d8$var$convertXMLtoJSON(content) {
    try {
        let jsonData = null;
        content = content.replace(/\n/g, "") // retire les retours à ligne du xml pour éviter d'avoir des \n dans les data
        ;
        (0, $c0eb5bd78d5dce59$exports.parseString)(content, // https://www.npmjs.com/package/xml2js#options
        {
            explicitArray: false,
            mergeAttrs: true
        }, (err, result)=>{
            if (err) throw err;
            jsonData = result.declaration;
        });
        return jsonData;
    } catch (error) {
        console.error(error);
    }
}
function $822810191707f6d8$var$getReportContent(url) {
    return new Promise((resolve, reject)=>{
        let fileUrl = url.endsWith("/") ? url.slice(0, -1) : url // retire le dernier / de l'url qui peut être présent dans le lien
        ;
        fileUrl = fileUrl.replace(/\//g, "_") + ".xml";
        fileUrl = "https://cdn.woopic.com/v1/AUTH_e408f19d19da4e889e4ba9d9a1470ef0/accessibilite/" + fileUrl;
        fetch(fileUrl).then((response)=>{
            if (response.headers.get("content-type").includes("application/xml")) resolve(response.text());
            else {
                // Si le fichier n'existe pas, essayez de remonter d'un niveau dans l'URL
                const pos = url.lastIndexOf("/");
                if (pos !== -1) $822810191707f6d8$var$getReportContent(url.substring(0, pos)).then(resolve).catch(reject);
                else reject();
            }
        }).catch((error)=>{
            console.error("Erreur lors de la v\xe9rification de l'existence du fichier:", error);
            reject(error);
        });
    });
}
// https://jira.si.fr.intraorange/browse/FTACCUEILV-3198
// Si title existant, compléter la propriété title avec le suffixe " (nouvelle fenêtre)"
// Si title inexistant, reprendre le libellé du lien pour alimenter la propriété title et la compléter du même suffixe" (nouvelle fenêtre)"
// Redonder la propriété title obtenue avec la propriété aria-label toujours avec le suffixe "... (nouvelle fenêtre)"
const $822810191707f6d8$var$accessibility = ()=>{
    const suffix = " (nouvelle fen\xeatre)";
    document.querySelectorAll("body > .site-width a[target=_blank]").forEach((blankLink)=>{
        let attrTitle = blankLink.title;
        let attrAria = blankLink.ariaLabel;
        let attrText = blankLink.text;
        attrText = attrText.trim() // remove linebreaks and extra spaces
        ;
        let textSuffix = attrText + suffix;
        if (attrTitle == "") blankLink.title = textSuffix;
        else blankLink.title += suffix;
        if (attrAria == "" || attrAria == null) blankLink.setAttribute("aria-label", textSuffix);
        else blankLink.ariaLabel += suffix;
    });
};
try {
    // récupère le paramètre url de l'URL
    const href = new URL(window.location.href);
    const page = href.searchParams.get("url") || "";
    // teste si le domaine est orange.fr ou sosh.fr
    if (page && !page.includes("orange.fr") && !page.includes("sosh.fr")) {
        document.body.id = "accessibility-not-orange-sosh";
        (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $312d954682092271$export$521b0bfdf8dc9144), {}), document.getElementById("content"));
    } else if (page.length === 0) {
        document.body.id = "accessibility-error";
        (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $6e98a49c31ebe60d$export$271f9f08425019c7), {
            url: page
        }), document.getElementById("content"));
    } else $822810191707f6d8$var$getReportContent(page).then((result)=>{
        let data = $822810191707f6d8$var$convertXMLtoJSON(result);
        // Si la déclaration d'accessibilité n'existe pas
        if (data === null) {
            document.body.id = "accessibility-not-found" // ???
            ;
            (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $6e98a49c31ebe60d$export$271f9f08425019c7), {
                url: page
            }), document.getElementById("content"));
        } else {
            // la déclaration d'accessibilité existe
            // on change le titre de la page
            if (data.title) document.title = "D\xe9claration d'accessibilit\xe9 : " + data.title;
            // on ajoute l'id de la page à l'élément body
            data.status = data.status.toLowerCase();
            document.body.id = "accessibility-" + data.status;
            //data.status = "WIP" // for testing
            if (data.status === "done") (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $85a814d8ba30c5e8$export$7fe28cb29e71bf10), {
                ...data
            }), document.getElementById("content"));
            else if (data.status === "wip") (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $fc14f12ad6de2ebf$export$a08c9fc854caa58b), {
                ...data
            }), document.getElementById("content"));
            else {
                document.body.id = "accessibility-error";
                (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $0d7a12686956c975$export$edf27be85e5f6da0), {}), document.getElementById("content"));
            }
        }
    }).catch((error)=>{
        document.body.id = "accessibility-error";
        (0, $939c0c8d3a4d7175$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $7547aaeb0ecd0855$export$34b9dba7ce09269b)((0, $6e98a49c31ebe60d$export$271f9f08425019c7), {
            url: page
        }), document.getElementById("content"));
    });
} catch (error) {
    console.error(error);
}

})();
//# sourceMappingURL=index.80deeace.js.map
